/* ============================================
   Charmlio v5 — Full-page Lens Advisor
   With Lottie animated icons
   ============================================ */
(function () {
  'use strict';

  // ── Lottie icon mapping ──
  var LOTTIE_MAP = {
    // Step 1: Usage types
    'single': 'distance',
    'progressive': 'progressive',
    'reading': 'reading',
    'frame-only': 'nonprescription',
    // Step 3: Lens tiers → thickness
    'standard': 'basic_thickness',
    'thin': 'thin_lenses',
    'ultra': 'ultra_thin',
    // Step 4: Coatings → lens types
    'blue': 'digital_protection',
    'photo': 'transition',
    'ar': 'nonprescription',    // Charm Clear: Frame Only's frame illustration, recoloured via CSS to read as "lensed"
    'arplus': 'clear_standard_olive_frame', // Charm Clear Plus: disco-ball animation with the glasses frame recoloured to dark olive (rest untouched)
    // Step 4: Sunglasses lens types
    'solid': 'sunglasses_solid',
    'polarized': 'sunglasses_polarized',
  };

  var lottieInstances = {};

  var lottieReady = false;
  var pendingLottieInits = [];

  function initLottieIcon(container, key) {
    if (!container) return;
    if (typeof lottie === 'undefined' || typeof LOTTIE_ANIMATIONS === 'undefined') {
      // Queue for later if lottie hasn't loaded yet
      pendingLottieInits.push({ container: container, key: key });
      return;
    }
    var animKey = LOTTIE_MAP[key];
    if (!animKey || !LOTTIE_ANIMATIONS[animKey]) return;
    // Don't re-init if already done
    var existing = lottieInstances[key];
    if (existing) {
      for (var i = 0; i < existing.length; i++) {
        if (existing[i].el === container) return;
      }
    }
    try {
      var anim = lottie.loadAnimation({
        container: container,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: JSON.parse(JSON.stringify(LOTTIE_ANIMATIONS[animKey]))
      });
      lottieInstances[key] = lottieInstances[key] || [];
      lottieInstances[key].push({ el: container, anim: anim });
    } catch (e) {
      console.warn('Charmlio Lottie error:', key, e);
    }
  }

  function flushPendingLottie() {
    if (typeof lottie === 'undefined' || typeof LOTTIE_ANIMATIONS === 'undefined') return;
    if (lottieReady) return;
    lottieReady = true;
    var queue = pendingLottieInits.slice();
    pendingLottieInits = [];
    queue.forEach(function(item) {
      initLottieIcon(item.container, item.key);
    });
  }

  function playLottieFor(key) {
    var arr = lottieInstances[key];
    if (!arr) return;
    arr.forEach(function(item) {
      item.anim.goToAndPlay(0, true);
    });
  }

  function destroyAllLottie() {
    Object.keys(lottieInstances).forEach(function(key) {
      lottieInstances[key].forEach(function(item) {
        try { item.anim.destroy(); } catch(e) {}
      });
    });
    lottieInstances = {};
  }

  // ── Data ──
  var TYPES = [
    { id: 'single', name: 'Single Vision (Distance)', desc: 'General use lenses for common prescriptions and seeing things from distance.', add: false },
    { id: 'progressive', name: 'Bifocal & Progressive', desc: 'One pair of glasses corrects vision at near, middle, and far distances.', add: true },
    { id: 'reading', name: 'Reading', desc: 'Lenses that magnify to assist with reading and close-up work.', add: false },
    { id: 'frame-only', name: 'Frame Only', desc: 'Comes with the lenses included by the brand.', add: false }
  ];

  // Default data — overridden by admin via localStorage
  var DEFAULT_TIERS = [
    { id: 'standard', name: 'Standard', badge: 'standard', label: 'STANDARD', price: 0,
      desc: 'Our classic 1.50 index lens. Clear, comfortable, and ready for everyday wear.',
      feats: ['Crystal-clear optics', 'Full UV protection', 'Lightweight & comfortable'] },
    { id: 'thin', name: 'Thin & Light', badge: 'thin', label: 'THIN & LIGHT', rec: true, price: 0,
      desc: 'Our most popular pick! 1.60 index lenses sit closer to your face and feel lighter all day.',
      feats: ['20% thinner profile', 'Noticeably lighter on your nose', 'Scratch-resistant coating', 'Full UV protection'] },
    { id: 'ultra', name: 'Ultra-Thin', badge: 'ultra', label: 'ULTRA-THIN', price: 0,
      desc: 'Premium 1.67 index. The thinnest, lightest lenses we carry. Perfect for strong prescriptions.',
      feats: ['30% thinner than standard', 'Feather-light all day', 'Premium optical clarity', 'Scratch-resistant coating', 'Ideal for higher prescriptions'] }
  ];

  // Fallback only — overridden by remote API config on every page load
  var DEFAULT_COATS = [
    { id: 'ar', name: 'Charm Clear', desc: 'Your everyday lens with <strong>scratch-resistant coating</strong>. Always a great starting point.', prices: { standard: 0, thin: 10000, ultra: 15000 }, icon: null },
    { id: 'arplus', name: 'Charm Clear Plus', desc: 'Premium <strong>anti-reflective coating</strong> that cuts glare and reflections — sharper vision and clearer photos.', prices: { standard: 4500, thin: 7000, ultra: 9500 }, icon: null },
    { id: 'blue', name: 'Digital +', desc: 'Filters harsh <strong>blue light</strong> from screens. Great if you spend time on phones or computers.', prices: { standard: 3000, thin: 6000, ultra: 9000 }, icon: null },
    { id: 'photo', name: 'Transitions (Photochromic)', desc: 'Clear indoors, darken in sunlight. Like sunglasses and regular glasses in one. Comes with <strong>anti-reflective coating</strong> by default.', prices: { standard: 10000, thin: 12000, ultra: 15000 }, icon: null, hasColor: true }
  ];

  var TIERS = DEFAULT_TIERS;
  var COATS = DEFAULT_COATS;

  // ── Sunglasses lens options (replaces coatings for sunglasses products) ──
  var SG_COATS = [
    { id: 'solid', name: 'Solid Colour', desc: 'Classic sun lenses with UV protection. Reduces brightness for comfortable outdoor vision.', prices: { standard: 5000, thin: 15000, ultra: 20000 }, icon: null, hasColor: true,
      colors: [
        { id: 'gray', name: 'Gray', dot: 'linear-gradient(135deg, #6B7B8D, #8494A7)' },
        { id: 'brown', name: 'Brown', dot: 'linear-gradient(135deg, #8B6914, #A0783C)' },
        { id: 'green', name: 'Green', dot: 'linear-gradient(135deg, #4A6741, #5E8054)' }
      ]
    },
    { id: 'polarized', name: 'Polarized', desc: 'Reduces glare from reflective surfaces like roads, water, and snow. Full UV protection for sharper outdoor vision.', prices: { standard: 12500, thin: 22500, ultra: 27500 }, icon: null, hasColor: true, isPremium: true,
      colors: [
        { id: 'gray', name: 'Gray', dot: 'linear-gradient(135deg, #6B7B8D, #8494A7)' },
        { id: 'brown', name: 'Brown', dot: 'linear-gradient(135deg, #8B6914, #A0783C)' },
        { id: 'green', name: 'Green', dot: 'linear-gradient(135deg, #4A6741, #5E8054)' }
      ]
    }
  ];

  // ── Lens variant map: coatingId_tierId → Shopify variant ID ──
  var LENS_VARIANT_MAP = {
    'ar_standard': 45959337214149,
    'ar_thin': 45959337246917,
    'ar_ultra': 45959337279685,
    'arplus_standard': 46126868594885,
    'arplus_thin': 46126868627653,
    'arplus_ultra': 46126868660421,
    'blue_standard': 45959337312453,
    'blue_thin': 45959337345221,
    'blue_ultra': 45959337377989,
    'photo_standard': 45959337410757,
    'photo_thin': 45959337443525,
    'photo_ultra': 45959337476293,
    // Sunglasses lens variants
    'solid_standard': 46007938252997,
    'solid_thin': 46007938285765,
    'solid_ultra': 46007938318533,
    'polarized_standard': 46007938351301,
    'polarized_thin': 46007938384069,
    'polarized_ultra': 46007938416837
  };

  // ── Load admin config from localStorage ──
  function loadAdminConfig() {
    try {
      var raw = localStorage.getItem('charmlio_lens_config');
      if (!raw) return;
      var cfg = JSON.parse(raw);

      // Coatings — admin stores prices per tier in dollars, we need cents
      if (cfg.coatings && cfg.coatings.length > 0) {
        COATS = cfg.coatings.map(function (c) {
          var pricesInCents = {};
          if (c.prices) {
            Object.keys(c.prices).forEach(function (tierId) {
              pricesInCents[tierId] = Math.round((c.prices[tierId] || 0) * 100);
            });
          } else if (c.price !== undefined) {
            // Legacy single price — apply to all tiers
            var p = Math.round((c.price || 0) * 100);
            TIERS.forEach(function (t) { pricesInCents[t.id] = p; });
          }
          return {
            id: c.id,
            name: c.name,
            desc: c.desc,
            prices: pricesInCents,
            icon: null,
            hasColor: c.id === 'photo' // Transitions always has color picker
          };
        });
      }

      // Tiers — admin stores price in dollars, we need cents
      if (cfg.tiers && cfg.tiers.length > 0) {
        TIERS = cfg.tiers.map(function (t) {
          return {
            id: t.id,
            name: t.name,
            badge: t.id,
            label: t.name.toUpperCase(),
            rec: !!t.rec,
            price: Math.round((t.price || 0) * 100), // dollars → cents
            desc: t.desc,
            feats: t.feats || []
          };
        });
      }

      // Variant map — admin can override the hardcoded defaults
      if (cfg.variantMap) {
        Object.keys(cfg.variantMap).forEach(function (k) {
          LENS_VARIANT_MAP[k] = cfg.variantMap[k];
        });
      }

      console.log('[Charmlio] Loaded admin config — ' + COATS.length + ' coatings, ' + TIERS.length + ' tiers');
    } catch (e) {
      console.warn('[Charmlio] Could not load admin config:', e);
    }
  }

  // Fetch config from backend API (source of truth)
  var _configPromise = null;
  function applyRemoteConfig(cfg) {
    if (!cfg || !cfg.coatings || !cfg.tiers) return;
    COATS = cfg.coatings.map(function (c) {
      var pricesInCents = {};
      if (c.prices) {
        Object.keys(c.prices).forEach(function (tierId) {
          pricesInCents[tierId] = Math.round((c.prices[tierId] || 0) * 100);
        });
      }
      return {
        id: c.id, name: c.name, desc: c.desc,
        prices: pricesInCents, icon: null,
        hasColor: c.hasColor || c.id === 'photo'
      };
    });
    TIERS = cfg.tiers.map(function (t) {
      return {
        id: t.id, name: t.name, badge: t.id,
        label: t.name.toUpperCase(), rec: !!t.rec,
        price: Math.round((t.price || 0) * 100),
        desc: t.desc, feats: t.feats || []
      };
    });
    if (cfg.variantMap) {
      Object.keys(cfg.variantMap).forEach(function (k) {
        LENS_VARIANT_MAP[k] = cfg.variantMap[k];
      });
    }
    try { localStorage.setItem('charmlio_lens_config', JSON.stringify(cfg)); } catch(e) {}
    console.log('[Charmlio] Remote config applied — ' + COATS.length + ' coatings, ' + TIERS.length + ' tiers');
  }

  // When viewing the storefront on shopify theme dev (localhost / 127.0.0.1), hit the local
  // charmlio-backend (vercel dev on :3000). On any real domain, fall through to production.
  // Safe to ship: production builds never match the localhost check.
  var CHARMLIO_API_BASE = (function () {
    try {
      var h = window.location.hostname;
      if (h === '127.0.0.1' || h === 'localhost') return 'http://localhost:3000';
    } catch (e) {}
    return 'https://charmlio-backend.vercel.app';
  })();

  function fetchRemoteConfig() {
    _configPromise = fetch(CHARMLIO_API_BASE + '/api/config')
      .then(function (r) { return r.json(); })
      .then(function (cfg) {
        applyRemoteConfig(cfg);
        if (charmlioReady && !isSunglasses) {
          renderTiers();
          renderCoats();
          updateTotal();
          updateSubtotalBar(currentDataStep());
        } else if (charmlioReady) {
          renderTiers();
          updateTotal();
          updateSubtotalBar(currentDataStep());
        }
      })
      .catch(function (e) {
        console.warn('[Charmlio] Could not fetch remote config:', e);
      });
    return _configPromise;
  }

  // ── Fetch CL product rxParams from backend ──
  var _clConfigPromise = null;
  function fetchClProductConfig() {
    if (_clConfigPromise) return _clConfigPromise;
    var prod = window.CharmlioProduct;
    if (!prod || !prod.isContactLens || !prod.id) return Promise.resolve();
    _clConfigPromise = fetch(CHARMLIO_API_BASE + '/api/cl-products?id=' + prod.id)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // New single-product response: data itself is the product (has rxParams directly)
        if (data && data.rxParams) {
          prod.rxParams = data.rxParams;
          prod.prescriptionType = data.prescriptionType || 'sphere';
          prod.category = data.category || '';
          prod.whatsIncluded = data.whatsIncluded || '';
          P = prod;
          return;
        }
        // Legacy fallback: full list response (data.products array)
        var products = data.products || [];
        var match = null;
        for (var i = 0; i < products.length; i++) {
          if (products[i].shopifyProductId === prod.id) { match = products[i]; break; }
        }
        if (match && match.rxParams) {
          prod.rxParams = match.rxParams;
          prod.prescriptionType = match.prescriptionType || 'sphere';
          prod.category = match.category || '';
          prod.whatsIncluded = match.whatsIncluded || '';
          P = prod;
        }
      })
      .catch(function (e) {
        console.warn('[Charmlio] Could not fetch CL config:', e);
        // Retry once on failure (network glitch, timeout, etc.)
        _clConfigPromise = null;
      });
    return _clConfigPromise;
  }

  // Load product data from admin localStorage
  function loadAdminProduct() {
    try {
      var raw = localStorage.getItem('charmlio_products');
      if (!raw) return;
      var products = JSON.parse(raw);
      if (!products || !products.length) return;

      // Use first product as default if no CharmlioProduct was set by Shopify
      if (!window.CharmlioProduct || !window.CharmlioProduct.id) {
        var p = products[0];
        window.CharmlioProduct = {
          id: p.id,
          title: p.title || p.name,
          price: Math.round((p.price || 0) * 100),
          formattedPrice: '$' + (p.price || 0).toFixed(2),
          variantId: p.variants && p.variants[0] ? p.variants[0].id : p.id,
          image: p.images && p.images[0] ? p.images[0] : '',
          imageMed: p.images && p.images[0] ? p.images[0] : '',
          variants: p.variants || [],
          isGlasses: p.collection === 'glasses' || p.collection === 'sunglasses',
          type: p.type || p.collection || ''
        };
        P = window.CharmlioProduct;
        console.log('[Charmlio] Loaded product from admin:', P.title);
      }
    } catch (e) {
      console.warn('[Charmlio] Could not load admin products:', e);
    }
  }


  // Ranges
  var SPH = [], CYL = [], AXIS = [], ADD = [], PD1 = [], PD2 = [];
  (function () {
    for (var i = -2000; i <= 1200; i += 25) SPH.push(i / 100);
    for (var j = -600; j <= 600; j += 25) CYL.push(j / 100);
    for (var k = 1; k <= 180; k++) AXIS.push(k);
    for (var l = 100; l <= 350; l += 25) ADD.push(l / 100);
    for (var m = 70; m <= 160; m++) PD1.push(m / 2);   // 35 to 80 in half steps (the PD tool gives totals like 63.5)
    for (var n = 175; n <= 400; n += 5) PD2.push(n / 10);
  })();

  // ── Flow definitions: which data-steps each type uses ──
  // Coatings (4) now comes before lens thickness (3)
  var FLOWS = {
    'single':      [1, 2, 4, 3, 5],
    'progressive': [1, 2, 4, 3, 5],
    'reading':     [1, 2, 4, 3, 5],
    'frame-only':  [1, 5]
  };

  var STEP_NAMES = {
    1: 'Choose your usage',
    2: 'Enter prescription',
    3: 'Lens thickness',
    4: 'Lens type',
    5: 'Review',
    6: 'Enter prescription',
    7: 'Base curve'
  };

  var CHECK_SVG = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var CHECK_GREEN = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#16A34A" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

  // ── GA4: which lens usage shoppers pick on step 1 ──
  // One DISTINCT event name per usage type (not a single event + a usage_type
  // param) — the admin Sales Funnel counts these straight off GA4's built-in
  // eventName dimension. A param would only be countable after registering a
  // custom dimension in GA4 admin, which takes 24-48h to backfill and can't be
  // done from code. gtag comes from Shopify's Google channel, same as the
  // phone_click / add_to_cart events the theme already sends.
  var USAGE_EVENTS = {
    'single': 'lens_usage_single',
    'progressive': 'lens_usage_progressive',
    'reading': 'lens_usage_reading',
    'frame-only': 'lens_usage_frame_only'
  };
  var usageFired = {};   // at most one event per type per configurator session

  function fireUsagePick(typeId) {
    if (!USAGE_EVENTS[typeId] || usageFired[typeId]) return;
    // At most one pick per type per configurator session — so the admin's number
    // is "how many PEOPLE chose Progressive", not how many times a button got
    // mashed. Set before either send so a throw can't let a retry double-count.
    usageFired[typeId] = true;

    // 1) Our own counter — this is what the admin's Lens Type tab reads. It used
    //    to read GA4, which meant a number we own broke every ~7 days whenever
    //    the Google OAuth token expired. Owning the count removes Google from
    //    the path entirely. keepalive so a fast click-through still lands.
    try {
      fetch(CHARMLIO_API_BASE + '/api/config?service=lens-click', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type: typeId }),
        keepalive: true
      }).catch(function () { /* never surface analytics failures to a shopper */ });
    } catch (e) {}

    // 2) GA4, unchanged — still handy in the GA4 UI for cross-referencing, but
    //    nothing in the admin depends on it any more.
    try {
      if (typeof window.gtag !== 'function') return;
      window.gtag('event', USAGE_EVENTS[typeId], {
        usage_type: typeId,
        item_name: (P.title || '').replace(/<br\s*\/?>(?:\s*)/gi, ' ').trim() || 'Charm Optical product',
        page_location: window.location.pathname
      });
    } catch (e) { /* analytics must never break the configurator */ }
  }

  // ── State ──
  var S = { flowIndex: 0, type: null, method: 'manual',
    od: { sph: '0.00', cyl: '0.00', axis: '', add: '' },
    os: { sph: '0.00', cyl: '0.00', axis: '', add: '' },
    pd: { mode: 'single', v: '', r: '', l: '' },
    file: null, tier: null, coats: [], transitionColor: '', sgColor: '',
    // Contact lens state
    clRx: { right: { sph: '', cyl: '', axis: '' }, left: { sph: '', cyl: '', axis: '' } },
    baseCurve: '' };
  var P = window.CharmlioProduct || {};
  var isSunglasses = !!P.isSunglasses;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || document).querySelectorAll(s)); }
  function money(c) { return '$' + (c / 100).toFixed(2); }

  // Photochromic transition — stack clear (base) + tinted (overlay), fade overlay opacity via CSS
  function startPhotoCycle() {
    stopPhotoCycle();
    if (!P.imageClear) return;

    // Desktop showcase
    var imgEl = $('#c-img');
    if (imgEl) {
      // Wrap image in a positioning container
      var wrap = document.createElement('div');
      wrap.id = 'c-photo-wrap';
      wrap.className = 'c-photo-wrap';
      imgEl.parentElement.insertBefore(wrap, imgEl);
      wrap.appendChild(imgEl);
      // Set base to clear
      imgEl.src = P.imageClear;
      // Tinted overlay — same classes as base image so it matches exactly
      var overlay = document.createElement('img');
      overlay.src = P.image;
      overlay.alt = '';
      overlay.className = 'c-showcase-img c-photo-overlay';
      overlay.id = 'c-photo-overlay';
      wrap.appendChild(overlay);
    }

    // Mobile
    var mobImgEl = $('#c-mob-img');
    if (mobImgEl) {
      mobImgEl.src = P.imageClear;
      var mobWrap = document.createElement('div');
      mobWrap.id = 'c-photo-wrap-mob';
      mobWrap.className = 'c-photo-wrap-mob';
      mobImgEl.parentElement.insertBefore(mobWrap, mobImgEl);
      mobWrap.appendChild(mobImgEl);
      var mobOverlay = document.createElement('img');
      mobOverlay.src = P.image;
      mobOverlay.alt = '';
      mobOverlay.className = 'c-mob-product-img c-photo-overlay';
      mobOverlay.id = 'c-photo-overlay-mob';
      mobWrap.appendChild(mobOverlay);
    }
  }

  function stopPhotoCycle() {
    // Desktop: unwrap and remove overlay
    var wrap = document.getElementById('c-photo-wrap');
    if (wrap) {
      var imgEl = $('#c-img');
      if (imgEl) { wrap.parentElement.insertBefore(imgEl, wrap); imgEl.src = P.image || ''; }
      wrap.remove();
    }
    // Mobile: unwrap and remove overlay
    var mobWrap = document.getElementById('c-photo-wrap-mob');
    if (mobWrap) {
      var mobImgEl = $('#c-mob-img');
      if (mobImgEl) { mobWrap.parentElement.insertBefore(mobImgEl, mobWrap); mobImgEl.src = P.imageMed || P.image || ''; }
      mobWrap.remove();
    }
  }

  function getFlow() {
    if (S.type === 'contact-lens') {
      return [6, 5];
    }
    return FLOWS[S.type] || [1];
  }

  function currentDataStep() {
    var flow = getFlow();
    return flow[S.flowIndex] || 1;
  }

  // Get the active coatings list based on product type
  function getActiveCoats() { return isSunglasses ? SG_COATS : COATS; }

  // Get the price for a coating based on selected tier (or standard if no tier yet)
  function coatPrice(coat) {
    if (!coat.prices) return 0;
    // If a tier is selected, use that tier's price
    if (S.tier && coat.prices[S.tier] !== undefined) return coat.prices[S.tier];
    // Default to standard tier price
    if (coat.prices['standard'] !== undefined) return coat.prices['standard'];
    // Fallback: cheapest price
    var vals = Object.values(coat.prices).filter(function (v) { return v > 0; });
    return vals.length > 0 ? Math.min.apply(null, vals) : 0;
  }

  // Get the cheapest price across all tiers (for "from $X" label)
  function coatMinPrice(coat) {
    if (!coat.prices) return 0;
    var vals = Object.values(coat.prices).filter(function (v) { return v > 0; });
    return vals.length > 0 ? Math.min.apply(null, vals) : 0;
  }

  // Check if prices vary by tier
  function coatHasVariablePrice(coat) {
    if (!coat.prices) return false;
    var vals = Object.values(coat.prices).filter(function (v) { return v > 0; });
    if (vals.length <= 1) return false;
    return Math.min.apply(null, vals) !== Math.max.apply(null, vals);
  }

  function total() {
    var t = P.price || 0;
    if (S.type === 'contact-lens') {
      var qtyR = S.clBoxQty && S.clBoxQty.right != null ? S.clBoxQty.right : 1;
      var qtyL = S.clBoxQty && S.clBoxQty.left != null ? S.clBoxQty.left : 1;
      var sameChk = $('#c-cl-same');
      var isSame = sameChk && sameChk.checked;
      return t * (isSame ? qtyR : (qtyR + qtyL));
    }
    if (S.type === 'frame-only') return t;
    // Thickness premium is baked into each coating's per-tier price (coatPrice below) — never add
    // tier.price on top, or thin/ultra lenses get double-charged (the $80/$150 bug, fixed 2026-06-20).
    var ac = getActiveCoats();
    if (S.coats[0]) { var a = ac.find(function (x) { return x.id === S.coats[0]; }); if (a) t += coatPrice(a); }
    return t;
  }

  function fill(el, vals, o) {
    o = o || {};
    var h = '<option value="">' + (o.ph || '---') + '</option>';
    vals.forEach(function (v) {
      var d = v, val = v;
      if (o.fmt) { d = (v > 0 ? '+' : '') + v.toFixed(2); val = d; }
      else if (o.fpd) { d = v % 1 !== 0 ? v.toFixed(1) : '' + v; val = d; }
      var sel = o.def !== undefined && v === o.def ? ' selected' : '';
      h += '<option value="' + val + '"' + sel + '>' + d + '</option>';
    });
    el.innerHTML = h;
    // Toggle is-filled class for CL selects
    if (el.classList.contains('cl-field-select')) {
      el.classList.toggle('is-filled', el.value !== '');
      if (!el._fillBound) {
        el._fillBound = true;
        el.addEventListener('change', function () { el.classList.toggle('is-filled', el.value !== ''); });
      }
    }
  }

  // ── DOM ──
  var page, body;

  function init() {
    // Load admin overrides from localStorage (instant), then fetch from API (fresh)
    loadAdminConfig();
    fetchRemoteConfig();
    loadAdminProduct();
    // Pre-fetch CL product config for contact lens pages
    if (P.isContactLens) fetchClProductConfig();

    // Always bind form intercept (the handler checks P.isGlasses at submit time)
    $$('form[action="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // Re-read in case product changed since page load
        P = window.CharmlioProduct || P;
        if (P.isGlasses || P.isContactLens) { e.preventDefault(); initAndOpen(); }
      });
    });
    var trigger = document.getElementById('charmlio-trigger');
    if (trigger) trigger.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); initAndOpen(); });
    window.CharmlioOpen = initAndOpen;

    if (!P.isGlasses && !P.isContactLens) return;
    setupCharmlio();
  }

  var charmlioReady = false;
  function setupCharmlio() {
    if (charmlioReady) return;
    page = $('#charmlio');
    if (!page) return;
    charmlioReady = true;
    body = $('#c-body');
    renderTypes();
    renderTiers();
    renderCoats();
    initRx();
    bindInternal();
    bindInsurance();
    initInsDropdown(); // custom dropdown reads the value bindInsurance restored

    // Listen for live sync from admin panel (same or other tab)
    window.addEventListener('storage', function (e) {
      if (e.key === 'charmlio_sync' || e.key === 'charmlio_lens_config') {
        console.log('[Charmlio] Admin sync detected — reloading config');
        loadAdminConfig();
        renderTiers();
        renderCoats();
        updateTotal();
      }
      if (e.key === 'charmlio_products') {
        loadAdminProduct();
        if (page && page.classList.contains('is-open')) {
          $('#c-img').src = P.image || '';
          $('#c-name').innerHTML = (P.title || '').replace(/<br\s*\/?>/gi, '<br>');
          $('#c-variant').textContent = P.formattedPrice || '';
          $('#c-mob-img').src = P.imageMed || P.image || '';
          $('#c-mob-name').textContent = P.title ? P.title.replace(/<br\s*\/?>/g, ' ') : '';
          $('#c-mob-price-text').textContent = P.formattedPrice || '';
        }
      }
    });
  }

  // Lazy init + open (for when first product was non-glasses)
  function initAndOpen() {
    P = window.CharmlioProduct || P;
    isSunglasses = !!P.isSunglasses;
    loadAdminConfig();
    // Wait for remote config + CL product config before opening
    var configReady = _configPromise || fetchRemoteConfig();
    var clReady = P.isContactLens ? fetchClProductConfig() : Promise.resolve();
    Promise.all([configReady, clReady]).then(function () {
      P = window.CharmlioProduct || P;
      // If CL fetch failed (rxParams still missing), retry once before opening
      if (P.isContactLens && !P.rxParams && !_clConfigPromise) {
        return fetchClProductConfig().then(function () {
          P = window.CharmlioProduct || P;
          setupCharmlio();
          if (charmlioReady) open();
        });
      }
      setupCharmlio();
      if (charmlioReady) open();
    }).catch(function () {
      P = window.CharmlioProduct || P;
      setupCharmlio();
      if (charmlioReady) open();
    });
  }

  // ── Open / Close ──
  function open() {
    // Re-read product data (may have changed if user clicked a different product)
    P = window.CharmlioProduct || P;
    reset();
    $('#c-img').src = P.image || '';
    $('#c-name').innerHTML = (P.title || '').replace(/<br\s*\/?>/gi, '<br>');
    $('#c-variant').textContent = P.formattedPrice || '';
    $('#c-mob-img').src = P.imageMed || P.image || '';
    $('#c-mob-name').textContent = P.title ? P.title.replace(/<br\s*\/?>/g, ' ') : '';
    $('#c-mob-price-text').textContent = P.formattedPrice || '';

    // Momono deal banners — show if vendor is Momono
    var _isMomono = P.vendor && P.vendor.toLowerCase() === 'momono';
    var _momonoCoatBanner = $('#c-momono-coat-banner');
    var _momonoTierBanner = $('#c-momono-tier-banner');
    if (_momonoCoatBanner) _momonoCoatBanner.style.display = _isMomono ? 'flex' : 'none';
    if (_momonoTierBanner) _momonoTierBanner.style.display = _isMomono ? 'flex' : 'none';

    // Contact lens: auto-set type + init CL RX
    if (P.isContactLens) {
      S.type = 'contact-lens';
      initClRx();
      initBaseCurve();
      // Auto-select BC if only one option
      if (P.rxParams && P.rxParams.baseCurve && P.rxParams.baseCurve.values && P.rxParams.baseCurve.values.length === 1) {
        S.baseCurve = P.rxParams.baseCurve.values[0];
      }
    }

    updateTotal();
    // Flush any pending Lottie animations (deferred lottie-web may be loaded now)
    flushPendingLottie();
    // Start photochromic image cycling if this variant has clear/tinted images
    if (P.imageClear) startPhotoCycle();
    page.classList.add('is-open');
    document.body.classList.add('c-locked');
    page.setAttribute('aria-hidden', 'false');
    // Hide chat widget (Tidio)
    if (window.tidioChatApi) window.tidioChatApi.hide();
    else document.querySelectorAll('#tidio-chat, #tidio-chat-iframe, [id^="tidio"]').forEach(function(el) { el.style.display = 'none'; });
    goTo(0);
  }

  function close() {
    stopPhotoCycle();
    page.classList.remove('is-open');
    document.body.classList.remove('c-locked');
    page.setAttribute('aria-hidden', 'true');
    // Show chat widget (Tidio)
    if (window.tidioChatApi) window.tidioChatApi.show();
    else document.querySelectorAll('#tidio-chat, #tidio-chat-iframe, [id^="tidio"]').forEach(function(el) { el.style.display = ''; });
  }

  // ── RX Expiry Check ──
  var expiryAcknowledged = { glasses: false, cl: false };

  function checkRxExpiry(dateStr, type) {
    // type: 'glasses' (2yr) or 'cl' (1yr)
    if (!dateStr) return false;
    var rxDate = new Date(dateStr + 'T00:00:00');
    var now = new Date();
    var diffMs = now - rxDate;
    var diffYears = diffMs / (365.25 * 24 * 60 * 60 * 1000);
    var maxYears = 2;
    return diffYears > maxYears;
  }

  function showExpiryPopup(type) {
    var popup = document.getElementById('c-expiry-popup');
    if (!popup) return;
    var yearsEl = document.getElementById('c-expiry-years');
    if (yearsEl) yearsEl.textContent = '2';
    popup.classList.add('is-open');

    var proceedBtn = document.getElementById('c-expiry-proceed');
    var bookBtn = document.getElementById('c-expiry-book');

    // Remove old handlers by cloning
    var newProceed = proceedBtn.cloneNode(true);
    proceedBtn.parentNode.replaceChild(newProceed, proceedBtn);
    newProceed.addEventListener('click', function () {
      expiryAcknowledged[type] = true;
      popup.classList.remove('is-open');
    });

    // Book button just opens the link (already an <a>), but also close popup
    if (bookBtn) {
      var newBook = bookBtn.cloneNode(true);
      bookBtn.parentNode.replaceChild(newBook, bookBtn);
      newBook.addEventListener('click', function () {
        popup.classList.remove('is-open');
      });
    }
  }

  function reset() {
    stopPhotoCycle();
    usageFired = {};
    S.flowIndex = 0; S.type = null; S.method = 'manual';
    S.od = { sph: '0.00', cyl: '0.00', axis: '', add: '' };
    S.os = { sph: '0.00', cyl: '0.00', axis: '', add: '' };
    S.pd = { mode: 'single', v: '', r: '', l: '' };
    S.file = null; S.tier = null; S.coats = []; S.transitionColor = ''; S.sgColor = '';
    S.clRx = { right: { sph: '', cyl: '', axis: '' }, left: { sph: '', cyl: '', axis: '' } };
    S.baseCurve = '';
    S.clMethod = 'manual'; S.clFile = null; S.clBoxQty = { right: 1, left: 1 };
    S.rxDate = ''; S.rxDoctor = ''; S.rxConfirm = false;
    S.clRxDate = ''; S.clRxDoctor = ''; S.clConfirm = false;
    expiryAcknowledged = { glasses: false, cl: false };
    // Reset verify fields
    var rxDateEl = $('#c-rx-date'); if (rxDateEl) rxDateEl.value = '';
    var rxDocEl = $('#c-rx-doctor'); if (rxDocEl) rxDocEl.value = '';
    showDrMsg('c-rx-doctor', 'c-rx-doctor-msg', 'ok');
    showDrMsg('c-cl-rx-doctor', 'c-cl-doctor-msg', 'ok');
    var rxConfEl = $('#c-rx-confirm'); if (rxConfEl) rxConfEl.checked = false;
    var clDateEl = $('#c-cl-rx-date'); if (clDateEl) clDateEl.value = '';
    var clDocEl = $('#c-cl-rx-doctor'); if (clDocEl) clDocEl.value = '';
    var clConfEl = $('#c-cl-confirm'); if (clConfEl) clConfEl.checked = false;
    // Reset date picker selects
    $$('.c-date-sel').forEach(function (sel) { sel.selectedIndex = 0; });
    var clSameEl = $('#c-cl-same'); if (clSameEl) clSameEl.checked = false;
    var clToggle = $('#c-cl-same-toggle'); if (clToggle) { clToggle.setAttribute('aria-checked', 'false'); }
    var clSepForm = $('#c-cl-separate-form'); if (clSepForm) clSepForm.style.display = '';
    var clSameForm = $('#c-cl-same-form'); if (clSameForm) clSameForm.style.display = 'none';
    // Reset CL method tabs + indicator
    $$('[data-cl-method]').forEach(function (b, i) { b.classList.toggle('is-active', i === 0); });
    var clInd = $('#c-cl-indicator'); if (clInd) clInd.classList.remove('is-right');
    $$('[data-panel="cl-manual"]').forEach(function (p) { p.classList.add('is-active'); });
    // Reset qty pills and dropdowns
    $$('.cl-qty-pill').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-qty') === '1'); });
    $$('.cl-qty-select').forEach(function (s) { s.value = '1'; });
    $$('[data-panel="cl-upload"]').forEach(function (p) { p.classList.remove('is-active'); });
    var clUpZone = $('#c-cl-upload-zone'); if (clUpZone) clUpZone.style.display = '';
    var clUpDone = $('#c-cl-upload-done'); if (clUpDone) clUpDone.style.display = 'none';
    $$('.c-card').forEach(function (c) { c.classList.remove('is-selected'); });
    $$('.c-tier').forEach(function (c) { c.classList.remove('is-selected'); });
    $$('.c-coat').forEach(function (c) { c.classList.remove('is-on'); });
    var zone = $('#c-upload-zone'); if (zone) zone.style.display = '';
    var done = $('#c-upload-done'); if (done) done.style.display = 'none';
    $$('.c-method').forEach(function (b, i) { b.classList.toggle('is-active', i === 0); });
    // Reset glasses rx panels (first active), but preserve CL manual panel
    $$('.c-step[data-step="2"] .c-rx-panel').forEach(function (p, i) { p.classList.toggle('is-active', i === 0); });
    $$('[data-panel="cl-manual"]').forEach(function (p) { p.classList.add('is-active'); });
    $$('[data-panel="cl-upload"]').forEach(function (p) { p.classList.remove('is-active'); });
    var dc = $('#c-pd-dual-check'); if (dc) dc.checked = false;
    var dd = $('#c-pd-dual'); if (dd) dd.style.display = 'none';
    var sp = $('#c-pd'); if (sp) sp.style.display = '';
    pdResetState(); // PD-MEASURE-TOOL
  }

  // ── Navigation ──
  function goTo(flowIdx) {
    var flow = getFlow();
    if (flowIdx < 0 || flowIdx >= flow.length) return;
    S.flowIndex = flowIdx;

    var dataStep = flow[flowIdx];

    $$('.c-step').forEach(function (s) { s.classList.remove('is-active'); });
    var el = $('.c-step[data-step="' + dataStep + '"]');
    if (el) el.classList.add('is-active');

    // Auto-select default when entering lens type step
    if (dataStep === 4) {
      if (isSunglasses) {
        if (S.coats.length === 0) { S.coats = ['solid']; S.sgColor = 'gray'; }
        else if (S.coats.length > 1) S.coats = [S.coats[0]];
        $$('.c-sg-card').forEach(function (c) { c.classList.remove('is-on'); });
        var sgCard = $('.c-sg-card[data-id="' + S.coats[0] + '"]');
        if (sgCard) sgCard.classList.add('is-on');
        var picker = $('#c-sg-colors');
        if (picker) picker.style.display = '';
        updateSgSwatches();
      } else {
        if (S.coats.length === 0) S.coats = ['ar'];
        else if (S.coats.length > 1) S.coats = [S.coats[0]];
        $$('.c-coat').forEach(function (r) { r.classList.remove('is-on'); });
        var coatRow = $('.c-coat[data-id="' + S.coats[0] + '"]');
        if (coatRow) coatRow.classList.add('is-on');
        if (S.coats[0] === 'photo' && !S.transitionColor) {
          S.transitionColor = 'brown';
          updateTransitionSwatches();
        }
      }
    }

    // Re-render tier cards when entering thickness step (prices depend on selected coating)
    if (dataStep === 3) {
      renderTiers();
      // Re-select the tier if one was previously selected
      if (S.tier) {
        var tierCard = $('.c-tier[data-id="' + S.tier + '"]');
        if (tierCard) tierCard.classList.add('is-selected');
      }
    }

    if (dataStep === 5) {
      // Update heading for CL vs glasses
      var h5 = $('.c-step[data-step="5"] .c-heading');
      if (h5) h5.textContent = S.type === 'contact-lens' ? 'Your contact lenses' : 'Your glasses';
      var s5 = $('.c-step[data-step="5"] .c-subtext');
      if (s5) s5.textContent = S.type === 'contact-lens' ? 'Review your order before adding to cart.' : 'Review your order before adding to cart.';
      renderReview();
      updateInsuranceVisibility();
    }

    // Progress bar — hide during Usage (1) and RX (2), show stepper for lens/CL steps
    var progressBar = $('.c-progress');
    var stepper = $('.c-stepper');
    var isCL = S.type === 'contact-lens';
    if (isCL && (dataStep === 6 || dataStep === 5)) {
      // CL flow: 2-step stepper — Prescription → Review
      if (progressBar) progressBar.style.display = 'none';
      if (stepper) {
        stepper.style.display = '';
        buildStepper(['Prescription', 'Review']);
        var clStepperSteps = [6, 5];
        updateStepper(clStepperSteps.indexOf(dataStep));
      }
    } else if (dataStep === 4 || dataStep === 3 || dataStep === 5) {
      // Glasses flow: 3-step stepper — Lens Type → Thickness → Review
      if (progressBar) progressBar.style.display = 'none';
      if (stepper) {
        stepper.style.display = '';
        buildStepper(['Lens Type', 'Thickness', 'Review']);
        var stepperSteps = [4, 3, 5];
        var currentStepperIdx = stepperSteps.indexOf(dataStep);
        updateStepper(currentStepperIdx);
      }
    } else if (dataStep === 1 || dataStep === 2 || dataStep === 6) {
      // Original progress bar for early steps
      if (progressBar) progressBar.style.display = '';
      if (stepper) stepper.style.display = 'none';
      var pct = Math.round(((flowIdx + 1) / flow.length) * 100);
      $('#c-progress').style.width = pct + '%';
    } else {
      if (progressBar) progressBar.style.display = '';
      if (stepper) stepper.style.display = 'none';
      var pct = Math.round(((flowIdx + 1) / flow.length) * 100);
      $('#c-progress').style.width = pct + '%';
    }

    // Update subtotal bar with itemized breakdown
    updateSubtotalBar(dataStep);

    // Back button
    var back = $('#c-back');
    var mobBack = $('#c-mob-back');
    if (flowIdx <= 0) {
      back.classList.add('is-hidden');
      mobBack.classList.add('is-hidden');
    } else {
      back.classList.remove('is-hidden');
      mobBack.classList.remove('is-hidden');
    }

    var backText = $('#c-back-text');
    if (flowIdx <= 0) {
      backText.textContent = 'Back';
    } else {
      var prevStep = flow[flowIdx - 1];
      backText.textContent = STEP_NAMES[prevStep] || 'Back';
    }

    $('#c-mob-step').textContent = 'Step ' + (flowIdx + 1) + ' of ' + flow.length;

    updateBtn(dataStep);
    updateTotal();
    if (body) body.scrollTop = 0;

    // Play Lottie animations for visible step cards
    if (dataStep === 1) {
      setTimeout(function() {
        TYPES.forEach(function(t) { playLottieFor(t.id); });
      }, 300);
    } else if (dataStep === 3) {
      setTimeout(function() {
        TIERS.forEach(function(t) { playLottieFor(t.id); });
      }, 300);
    } else if (dataStep === 4) {
      setTimeout(function() {
        COATS.forEach(function(a) { if (LOTTIE_MAP[a.id]) playLottieFor(a.id); });
      }, 300);
    }
  }

  // ── Prescriber ("Dr name") validation ─────────────────────────────
  // We cannot dispense Rx eyewear in Canada without the prescriber's name, so
  // the field has to hold something that can actually be a name — not "n/a",
  // "--", "idk", or a keyboard mash. Two tiers: a nudge (empty / name missing)
  // and a hard stop (an answer that stands in for "unknown").
  var DR_UNKNOWN = [
    'na', 'nan', 'nil', 'none', 'nonegiven', 'null', 'no', 'nope', 'nah', 'n', 'nada', 'zero',
    'unknown', 'unkown', 'unknwn', 'unk', 'idk', 'dunno', 'dontknow', 'donotknow', 'idontknow',
    'idonotknow', 'noidea', 'notsure', 'unsure', 'cantremember', 'cannotremember', 'dontremember',
    'donotremember', 'cantrecall', 'dontrecall', 'forgot', 'forget', 'noname', 'nonamegiven',
    'nobody', 'noone', 'nodoctor', 'nodr', 'noeyedoctor', 'private', 'confidential', 'anonymous',
    'anon', 'self', 'myself', 'me', 'mine', 'mydoctor', 'mydr', 'myeyedoctor', 'eyedoctor',
    'same', 'sameasabove', 'tbd', 'tba', 'pending', 'later', 'sendlater', 'blank', 'empty',
    'notapplicable', 'notavailable', 'noanswer', 'whatever', 'whocares', 'who', 'why', 'none of',
    'test', 'testing', 'tester', 'asdf', 'asdfg', 'asdfgh', 'asdfasdf', 'qwerty', 'abc', 'abcd',
    'abcde', 'xyz', 'sample', 'example', 'johndoe', 'janedoe', 'name', 'yourname', 'fullname',
    'optometrist', 'optician', 'ophthalmologist', 'clinic', 'internet', 'online', 'walkin'
  ];
  var DR_TITLES = ['dr', 'drs', 'doctor', 'doc', 'od', 'ods', 'optom', 'mr', 'mrs', 'ms', 'miss', 'mx', 'prof', 'professor', 'sir', 'madam'];
  var DR_FILLER = ['my', 'the', 'a', 'an', 'at', 'of', 'from', 'eye', 'eyes', 'vision', 'name', 'is', 'was'];
  var DR_KEYS = ['qwertyuiop', 'asdfghjkl', 'zxcvbnm', '1234567890'];

  function drNormalize(v) {
    return String(v || '').toLowerCase().replace(/[‘’']/g, '').replace(/\s+/g, ' ').trim();
  }

  // "Our Dr", "your optometrist", "Charm Optical" all point at our own clinic —
  // the field's own hint tells people to write that, so it must pass.
  function drIsOurs(n) {
    if (/\bcharm\b/.test(n)) return true;
    return /^(our|ours|ur|your|yours|in[\s-]?house|inhouse|in[\s-]?store)[\s-]*(dr\.?|doc|doctor|optometrist|optom|od|clinic|store|office|guys)?\.?$/.test(n) &&
      /(dr|doc|optom|od|clinic|store|office|guys)/.test(n);
  }

  function drLooksMashed(letters) {
    if (/(.)\1{2,}/.test(letters)) return true;                        // aaa, zzzz
    if (letters.length >= 4 && !/[aeiouy]/.test(letters)) return true; // sdfgh
    if (/[^aeiouy]{5,}/.test(letters)) return true;                    // long consonant run
    for (var i = 0; i < DR_KEYS.length; i++) {
      if (letters.length >= 3 && DR_KEYS[i].indexOf(letters) !== -1) return true; // asdf, zxcv
    }
    return false;
  }

  // Returns 'ok' | 'empty' | 'short' (nudge) | 'junk' (hard stop)
  function drVerdict(raw) {
    var n = drNormalize(raw);
    if (!n) return 'empty';
    if (drIsOurs(n)) return 'ok';
    // Non-Latin names (Chinese, Cyrillic, Arabic …) survive as-is — never reject them.
    if (n.replace(/[\x00-\x7F]/g, '').length >= 2) return 'ok';

    var flat = n.replace(/[^a-z0-9]+/g, ' ').trim();  // "n/a" -> "n a"
    var squished = flat.replace(/ /g, '');            // "n/a" -> "na", "--" -> ""
    var letters = squished.replace(/[0-9]/g, '');

    if (!letters) return 'junk';                                        // "--", "1234", "???"
    if (DR_UNKNOWN.indexOf(squished) !== -1) return 'junk';
    if (/^(same|none|no)\b/.test(flat)) return 'junk';                  // "no dr on file", "same as above"
    if (/\b(dont|donot|cant|cannot|not)\s+(know|remember|recall|sure|applicable|available|given)\b/.test(flat)) return 'junk';
    if (/\b(unknown|idk|dunno|forgot|forget|whatever|anonymous)\b/.test(flat)) return 'junk';

    var tokens = flat.split(' ').filter(Boolean);
    var parts = tokens.filter(function (t) { return DR_TITLES.indexOf(t) === -1; });
    if (!parts.length) return 'short';                                  // just "Dr." / "Doctor"
    var hadTitle = parts.length < tokens.length;

    var named = parts.filter(function (t) { return DR_FILLER.indexOf(t) === -1; });
    if (!named.length) return 'junk';                                   // "my eye doctor"

    // Mash-check each name token on its own — joining them would invent consonant
    // runs across word boundaries and reject real names ("Frank Schmidt").
    for (var i = 0; i < named.length; i++) {
      if (drLooksMashed(named[i].replace(/[0-9]/g, ''))) return 'junk';
    }

    var hasWord = named.some(function (t) { return t.replace(/[0-9]/g, '').length >= 2; });
    if (!hasWord) return hadTitle ? 'short' : 'junk';                   // "Dr. K" nudges; a bare "x" does not
    return 'ok';
  }

  // A pen nib, not an alert circle. The field is asking the customer to WRITE
  // something — it isn't telling them they broke a rule.
  var DR_ICON = '<span class="c-dr-msg__mark" aria-hidden="true">' +
    '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M12 19h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/></svg></span>';

  function drMessage(verdict) {
    if (verdict === 'empty') {
      return { hard: false, text: 'Please write the name of whoever did your eye exam.' };
    }
    if (verdict === 'short') {
      return { hard: false, text: 'Almost — we just need the <strong>name</strong> that goes with the title. First name, last name, or both is fine.' };
    }
    return { hard: true, text: 'We need a <strong>real name</strong> here, so that if anything on your prescription needs a quick double-check, we know who to reach — your clinic, or you.' };
  }

  function showDrMsg(inputId, msgId, verdict) {
    var input = $('#' + inputId);
    var msg = $('#' + msgId);
    if (!input || !msg) return;
    if (verdict === 'ok') {
      msg.style.display = 'none';
      msg.innerHTML = '';
      input.classList.remove('c-dr-warn');
      input.removeAttribute('aria-invalid');
      return;
    }
    var m = drMessage(verdict);
    msg.className = 'c-dr-msg' + (m.hard ? ' is-hard' : '');
    msg.innerHTML = DR_ICON + '<span class="c-dr-msg__body">' + m.text + '</span>';
    msg.style.display = 'flex';
    input.classList.toggle('c-dr-warn', m.hard);
    if (m.hard) { input.setAttribute('aria-invalid', 'true'); } else { input.removeAttribute('aria-invalid'); }
  }

  function DR_IDS(isCL) {
    return isCL
      ? { input: 'c-cl-rx-doctor', msg: 'c-cl-doctor-msg' }
      : { input: 'c-rx-doctor', msg: 'c-rx-doctor-msg' };
  }

  // Blocks Save & Continue and explains why. Same gate for manual entry and file upload.
  function guardDoctor(isCL) {
    var ids = DR_IDS(isCL);
    var verdict = drVerdict(isCL ? S.clRxDoctor : S.rxDoctor);
    showDrMsg(ids.input, ids.msg, verdict);
    if (verdict === 'ok') return true;
    var el = $('#' + ids.input);
    if (el) {
      try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
      try { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    }
    return false;
  }

  function bindDoctorField(isCL) {
    var ids = DR_IDS(isCL);
    var el = $('#' + ids.input);
    if (!el) return;
    el.addEventListener('input', function () {
      if (isCL) { S.clRxDoctor = this.value.trim(); } else { S.rxDoctor = this.value.trim(); }
      // While typing we only ever clear a warning — never raise one mid-word.
      if (drVerdict(this.value) === 'ok') showDrMsg(ids.input, ids.msg, 'ok');
      updateBtn(isCL ? 6 : 2);
    });
    el.addEventListener('blur', function () {
      showDrMsg(ids.input, ids.msg, drVerdict(this.value));
    });
  }

  function updateBtn(dataStep) {
    var btn = $('#c-next');
    var disabled = false;
    if (dataStep === 1 && !S.type) disabled = true;
    if (dataStep === 4 && S.coats.length === 0) disabled = true;
    if (dataStep === 3 && !S.tier) disabled = true;
    // Glasses RX: also need verification (unless "later").
    // The Dr name is NOT part of the disabled check on purpose — we let the click
    // through so guardDoctor() can say why, instead of a silently dead button.
    if (dataStep === 2 && S.method !== 'later') {
      if (!S.rxDate || !S.rxConfirm) disabled = true;
    }
    // CL RX: need SPH for both eyes (+ CYL/AXIS for toric) OR uploaded file + verification
    if (dataStep === 6) {
      if (S.clMethod === 'manual') {
        if (!S.clRx.right.sph || !S.clRx.left.sph) disabled = true;
        if (P.prescriptionType === 'toric') {
          if (!S.clRx.right.cyl || !S.clRx.right.axis || !S.clRx.left.cyl || !S.clRx.left.axis) disabled = true;
        }
      } else if (S.clMethod === 'upload') {
        if (!S.clFile) disabled = true;
      }
      // Dr name handled by guardDoctor() on click — see the glasses branch above.
      if (!S.clRxDate || !S.clConfirm) disabled = true;
      // Require BC selection when multiple BC options exist
      var bcs = (P.rxParams && P.rxParams.baseCurve && P.rxParams.baseCurve.values) ? P.rxParams.baseCurve.values : [];
      if (bcs.length > 1 && !S.baseCurve) disabled = true;
    }
    btn.disabled = disabled;

    var footer = $('.c-panel-footer');
    if (dataStep === 5) {
      btn.innerHTML = 'Add to Cart &mdash; ' + money(total());
      btn.style.width = '100%';
      btn.style.minWidth = '';
      footer.classList.add('is-checkout');
    } else {
      btn.innerHTML = 'Save &amp; Continue';
      btn.style.width = 'auto';
      btn.style.minWidth = '160px';
      footer.classList.remove('is-checkout');
    }
  }

  function updateTotal() {
    $('#c-total').textContent = money(total());
  }

  // ── 3-step labeled stepper ──
  var _lastStepperKey = '';
  function buildStepper(labels) {
    var key = labels.join(',');
    if (key === _lastStepperKey) return;
    _lastStepperKey = key;
    var stepper = $('.c-stepper');
    if (!stepper) return;
    var html = '';
    for (var i = 0; i < labels.length; i++) {
      if (i > 0) html += '<div class="c-stepper-line"></div>';
      html += '<div class="c-stepper-step"><div class="c-stepper-dot">' + (i + 1) + '</div><div class="c-stepper-label">' + labels[i] + '</div></div>';
    }
    stepper.innerHTML = html;
  }

  function updateStepper(activeIdx) {
    var dots = $$('.c-stepper-dot');
    var lines = $$('.c-stepper-line');
    var lbls = $$('.c-stepper-label');
    for (var i = 0; i < dots.length; i++) {
      if (!dots[i]) continue;
      dots[i].classList.remove('is-active', 'is-done');
      if (lbls[i]) lbls[i].classList.remove('is-active', 'is-done');
      if (i < activeIdx) {
        dots[i].classList.add('is-done');
        dots[i].innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
        if (lbls[i]) lbls[i].classList.add('is-done');
      } else if (i === activeIdx) {
        dots[i].classList.add('is-active');
        dots[i].innerHTML = '' + (i + 1);
        if (lbls[i]) lbls[i].classList.add('is-active');
      } else {
        dots[i].innerHTML = '' + (i + 1);
      }
    }
    for (var j = 0; j < lines.length; j++) {
      if (!lines[j]) continue;
      lines[j].classList.toggle('is-done', j < activeIdx);
    }
  }

  // ── Itemized breakdown (desktop showcase + mobile dropdown) ──
  function buildBreakdownHTML() {
    var framePrice = P.price || 0;
    var _ac = getActiveCoats();
    var coat = S.coats.length > 0 ? _ac.find(function (x) { return x.id === S.coats[0]; }) : null;
    var coatBase = coat ? (coat.prices['standard'] || 0) : 0;
    var tierDelta = 0;
    if (coat && S.tier && coat.prices[S.tier] !== undefined) {
      tierDelta = coat.prices[S.tier] - coatBase;
    }
    var totalVal = total();

    var coatLabel = '';
    if (coat) {
      coatLabel = coat.name;
      if (isSunglasses && S.sgColor) coatLabel += ' — ' + S.sgColor.charAt(0).toUpperCase() + S.sgColor.slice(1);
      else if (S.coats[0] === 'photo' && S.transitionColor) coatLabel += ' (' + S.transitionColor + ')';
    }

    var rows = '';
    rows += '<div class="c-bd-row"><span class="c-bd-label">Frame</span><span class="c-bd-price">' + money(framePrice) + '</span></div>';
    if (coat) {
      var coatPriceStr = coatBase > 0 ? '+ ' + money(coatBase) : '<span class="c-bd-inc">Included</span>';
      rows += '<div class="c-bd-row"><span class="c-bd-label">' + coatLabel + '</span><span class="c-bd-price">' + coatPriceStr + '</span></div>';
    }
    if (S.tier && tierDelta > 0) {
      var tierObj = TIERS.find(function (x) { return x.id === S.tier; });
      rows += '<div class="c-bd-row"><span class="c-bd-label">' + (tierObj ? tierObj.name : 'Thickness') + '</span><span class="c-bd-price">+ ' + money(tierDelta) + '</span></div>';
    } else if (S.tier) {
      var tierObj2 = TIERS.find(function (x) { return x.id === S.tier; });
      if (tierObj2 && tierObj2.id !== 'standard') {
        rows += '<div class="c-bd-row"><span class="c-bd-label">' + tierObj2.name + '</span><span class="c-bd-price"><span class="c-bd-inc">Included</span></span></div>';
      }
    }
    rows += '<div class="c-bd-divider"></div>';
    rows += '<div class="c-bd-row c-bd-total"><span class="c-bd-label">Subtotal</span><span class="c-bd-price">' + money(totalVal) + '</span></div>';
    return rows;
  }

  function updateSubtotalBar(dataStep) {
    var desktopBd = $('#c-breakdown');
    var mobBd = $('#c-mob-breakdown');
    var mobPrice = $('#c-mob-price-text');
    var totalEl = $('#c-total');

    // Always update footer total
    if (totalEl) totalEl.textContent = money(total());

    // Update mobile price text
    if (mobPrice) mobPrice.textContent = money(total());

    // Only show breakdown on lens steps (4=Lens Type, 3=Thickness)
    var showBreakdown = (dataStep === 4 || dataStep === 3);

    if (desktopBd) {
      if (showBreakdown) {
        desktopBd.innerHTML = buildBreakdownHTML();
        desktopBd.classList.add('is-visible');
      } else {
        desktopBd.innerHTML = '';
        desktopBd.classList.remove('is-visible');
      }
    }

    if (mobBd) {
      if (showBreakdown) {
        mobBd.innerHTML = buildBreakdownHTML();
        mobBd.classList.add('has-content');
      } else {
        mobBd.innerHTML = '';
        mobBd.classList.remove('has-content');
        mobBd.classList.remove('is-open');
        // Collapse if open
        var mobBtn = $('#c-mob-price');
        if (mobBtn) mobBtn.setAttribute('aria-expanded', 'false');
      }
    }

    // Show/hide chevron on mobile price button
    var chevron = document.querySelector('.c-mob-chevron');
    if (chevron) chevron.style.display = showBreakdown ? '' : 'none';
  }

  function next() {
    // If on the progressive notice, "Go Back" returns to step 1
    var btn = $('#c-next');
    if (btn._progressiveNotice) {
      prev();
      return;
    }

    var dataStep = currentDataStep();

    // Progressive/Bifocal — show in-store-only message
    if (dataStep === 1 && S.type === 'progressive') {
      showProgressiveNotice();
      return;
    }

    // Block if axis is missing when CYL is set (step 2, manual entry)
    if (dataStep === 2 && S.method === 'manual' && hasAxisErrors()) {
      // Scroll to the first warning
      var warn = $('.c-axis-warn');
      if (warn) warn.focus();
      return;
    }

    // No prescriber, no order — covers manual entry AND uploaded files, glasses,
    // sunglasses (step 2) and contact lenses (step 6).
    if (dataStep === 2 && S.method !== 'later' && !guardDoctor(false)) return;
    if (dataStep === 6 && !guardDoctor(true)) return;

    if (dataStep === 5) {
      addToCart();
      return;
    }
    goTo(S.flowIndex + 1);
  }

  function showProgressiveNotice() {
    // Hide all steps, show the notice
    $$('.c-step').forEach(function (s) { s.classList.remove('is-active'); });
    var notice = $('.c-step[data-step="progressive-notice"]');
    if (notice) notice.classList.add('is-active');

    // Update back button
    var back = $('#c-back');
    var mobBack = $('#c-mob-back');
    back.classList.remove('is-hidden');
    mobBack.classList.remove('is-hidden');
    $('#c-back-text').textContent = 'Choose your usage';

    // Hide the continue button, show a "Go Back" style
    var btn = $('#c-next');
    btn.innerHTML = 'Go Back';
    btn.disabled = false;
    btn.style.width = 'auto';
    btn.style.minWidth = '160px';
    btn._progressiveNotice = true;

    if (body) body.scrollTop = 0;
  }

  function prev() {
    // If on progressive notice, go back to step 1
    var notice = $('.c-step[data-step="progressive-notice"]');
    if (notice && notice.classList.contains('is-active')) {
      notice.classList.remove('is-active');
      var btn = $('#c-next');
      btn._progressiveNotice = false;
      goTo(0);
      return;
    }
    if (S.flowIndex <= 0) { close(); return; }
    goTo(S.flowIndex - 1);
  }

  // ── Step 1: Types with Lottie icons ──
  function renderTypes() {
    var wrap = $('#c-types');
    var h = '';
    TYPES.forEach(function (t) {
      h += '<div class="c-card" data-id="' + t.id + '">';
      // Icon area — Lottie animated icon
      if (LOTTIE_MAP[t.id]) {
        h += '<div class="c-card-icon"><div class="c-lottie" data-lottie="' + t.id + '"></div></div>';
      }
      h += '<div class="c-card-text"><div class="c-card-title">' + t.name + '</div>' +
        '<div class="c-card-desc">' + t.desc + '</div></div>' +
        '<div class="c-radio">' + CHECK_SVG + '</div></div>';
    });
    wrap.innerHTML = h;

    // Init Lottie for each card
    $$('.c-lottie[data-lottie]', wrap).forEach(function(el) {
      var key = el.getAttribute('data-lottie');
      initLottieIcon(el, key);
    });

    // Card click handlers
    $$('.c-card', wrap).forEach(function (card) {
      card.addEventListener('click', function () {
        $$('.c-card', wrap).forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        var newType = card.getAttribute('data-id');
        // Switching usage RESETS the downstream lens selection so a stale config can't carry
        // over — e.g. picking "Frame Only" (or another vision type) after a Sun Lens + Thickness
        // were chosen, which left the review listing lens charges that weren't in the price/total.
        // Rx values are kept (they belong to the prescription, not the lens choice); the lens
        // steps re-default via goTo when re-entered.
        if (newType !== S.type) {
          S.coats = [];
          S.tier = null;
          S.sgColor = '';
          S.transitionColor = '';
          stopPhotoCycle();
          $$('.c-coat').forEach(function (c) { c.classList.remove('is-on'); });
          $$('.c-sg-card').forEach(function (c) { c.classList.remove('is-on'); });
          $$('.c-tier').forEach(function (c) { c.classList.remove('is-selected'); });
          $$('.c-sg-swatch').forEach(function (c) { c.classList.remove('is-active'); });
          $$('.c-trans-swatch').forEach(function (c) { c.classList.remove('is-active'); });
          // Repaint the always-visible footer "Total" + mobile price pill so they don't linger on
          // the old lens-inclusive amount next to the new (e.g. Frame Only) choice.
          updateSubtotalBar(1);
        }
        S.type = newType;
        fireUsagePick(newType);
        var typeObj = TYPES.find(function (x) { return x.id === S.type; });
        $$('.c-add-col').forEach(function (c) { c.style.display = typeObj && typeObj.add ? '' : 'none'; });
        // Play the selected animation
        playLottieFor(S.type);
        updateBtn(1);
        if (navigator.vibrate) navigator.vibrate(10);
      });

      // Hover to play animation
      card.addEventListener('mouseenter', function() {
        var id = card.getAttribute('data-id');
        playLottieFor(id);
      });
    });
  }

  // ── Axis validation ──
  function cylHasValue(eye) {
    var v = S[eye].cyl;
    return v !== '' && v !== '0.00' && v !== '+0.00' && v !== '-0.00';
  }

  function checkAxisWarning(eye) {
    var prefix = eye === 'od' ? 'c-od' : 'c-os';
    var axisEl = $('#' + prefix + '-axis');
    var row = axisEl.closest('tr');
    var existing = row.parentNode.querySelector('.c-axis-msg[data-eye="' + eye + '"]');

    if (cylHasValue(eye) && !S[eye].axis) {
      axisEl.classList.add('c-axis-warn');
      if (!existing) {
        var tr = document.createElement('tr');
        tr.className = 'c-axis-msg-row';
        var td = document.createElement('td');
        td.setAttribute('colspan', '5');
        td.innerHTML = '<div class="c-axis-msg" data-eye="' + eye + '">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#EF4444" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
          'Axis is required when CYL is entered</div>';
        tr.appendChild(td);
        row.parentNode.insertBefore(tr, row.nextSibling);
      }
    } else {
      axisEl.classList.remove('c-axis-warn');
      if (existing) existing.closest('tr').remove();
    }
  }

  function hasAxisErrors() {
    var errors = false;
    ['od', 'os'].forEach(function(eye) {
      if (cylHasValue(eye) && !S[eye].axis) {
        checkAxisWarning(eye);
        errors = true;
      }
    });
    return errors;
  }

  // ── Date Picker Helper ──
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function initDatePicker(pickerId, hiddenId, onChangeCallback) {
    var picker = $('#' + pickerId);
    var hidden = $('#' + hiddenId);
    if (!picker || !hidden) return;
    var monthSel = picker.querySelector('[data-role="month"]');
    var daySel = picker.querySelector('[data-role="day"]');
    var yearSel = picker.querySelector('[data-role="year"]');
    if (!monthSel || !daySel || !yearSel) return;

    // Populate months
    MONTHS.forEach(function (m, i) {
      var opt = document.createElement('option');
      opt.value = '' + (i + 1);
      opt.textContent = m;
      monthSel.appendChild(opt);
    });
    // Populate days 1-31
    for (var d = 1; d <= 31; d++) {
      var opt = document.createElement('option');
      opt.value = '' + d;
      opt.textContent = '' + d;
      daySel.appendChild(opt);
    }
    // Populate years: current year back 10 years
    var thisYear = new Date().getFullYear();
    for (var y = thisYear; y >= thisYear - 10; y--) {
      var opt = document.createElement('option');
      opt.value = '' + y;
      opt.textContent = '' + y;
      yearSel.appendChild(opt);
    }

    function updateDays() {
      var m = parseInt(monthSel.value, 10);
      var yr = parseInt(yearSel.value, 10) || thisYear;
      if (!m) return;
      var maxDay = new Date(yr, m, 0).getDate();
      var curDay = parseInt(daySel.value, 10);
      // Remove excess days
      while (daySel.options.length > maxDay + 1) daySel.remove(daySel.options.length - 1);
      // Add missing days
      for (var dd = daySel.options.length - 1; dd < maxDay; dd++) {
        var o = document.createElement('option');
        o.value = '' + (dd + 1);
        o.textContent = '' + (dd + 1);
        daySel.appendChild(o);
      }
      if (curDay > maxDay) daySel.value = '' + maxDay;
    }

    function sync() {
      var m = monthSel.value, d = daySel.value, y = yearSel.value;
      if (m && d && y) {
        var dateStr = y + '-' + (m.length < 2 ? '0' + m : m) + '-' + (d.length < 2 ? '0' + d : d);
        hidden.value = dateStr;
        if (onChangeCallback) onChangeCallback(dateStr);
      } else {
        hidden.value = '';
      }
    }

    monthSel.addEventListener('change', function () { updateDays(); sync(); });
    daySel.addEventListener('change', sync);
    yearSel.addEventListener('change', function () { updateDays(); sync(); });
  }

  // ── Step 2: Rx ──
  function initRx() {
    fill($('#c-od-sph'), SPH, { fmt: true, def: 0, ph: '0.00' });
    fill($('#c-os-sph'), SPH, { fmt: true, def: 0, ph: '0.00' });
    fill($('#c-od-cyl'), CYL, { fmt: true, def: 0, ph: '0.00' });
    fill($('#c-os-cyl'), CYL, { fmt: true, def: 0, ph: '0.00' });
    fill($('#c-od-axis'), AXIS, { ph: '---' });
    fill($('#c-os-axis'), AXIS, { ph: '---' });
    fill($('#c-od-add'), ADD, { fmt: true, ph: '---' });
    fill($('#c-os-add'), ADD, { fmt: true, ph: '---' });
    fill($('#c-pd'), PD1, { fpd: true, def: 63, ph: '63' });
    fill($('#c-pd-r'), PD2, { fpd: true, ph: '---' });
    fill($('#c-pd-l'), PD2, { fpd: true, ph: '---' });

    // Methods
    $$('.c-method').forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('.c-method').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        S.method = btn.getAttribute('data-method');
        $$('.c-step[data-step="2"] .c-rx-panel').forEach(function (p) { p.classList.remove('is-active'); });
        var panel = $('.c-step[data-step="2"] .c-rx-panel[data-panel="' + S.method + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });

    // Dual PD — when ON, hide the single PD box and reveal the Right/Left boxes
    $('#c-pd-dual-check').addEventListener('change', function () {
      S.pd.mode = this.checked ? 'dual' : 'single';
      $('#c-pd-dual').style.display = this.checked ? '' : 'none';
      $('#c-pd').style.display = this.checked ? 'none' : '';
      // Back to one PD: the box shows Right + Left (32.5 + 31 = 63.5), not a stale number. Set directly, no change
      // event, so it does not count as a hand edit of a measured PD.
      if (!this.checked) {
        var pr = parseFloat($('#c-pd-r').value), pl = parseFloat($('#c-pd-l').value), sp = $('#c-pd');
        if (pr > 0 && pl > 0) {
          var tv = pdFmt(pr + pl);
          for (var i = 0; i < sp.options.length; i++) { if (sp.options[i].value === tv) { sp.value = tv; S.pd.v = tv; break; } }
        }
      }
    });

    // Hide "Send Later" method button if present
    $$('.c-method[data-method="later"]').forEach(function(el) { el.style.display = 'none'; });

    // Upload
    var zone = $('#c-upload-zone');
    var input = $('#c-file-input');
    zone.addEventListener('click', function () { input.click(); });
    zone.addEventListener('dragover', function (e) { e.preventDefault(); zone.classList.add('is-drag'); });
    zone.addEventListener('dragleave', function () { zone.classList.remove('is-drag'); });
    zone.addEventListener('drop', function (e) {
      e.preventDefault(); zone.classList.remove('is-drag');
      if (e.dataTransfer.files.length) handleFile(e.dataTransfer.files[0]);
    });
    input.addEventListener('change', function () { if (input.files.length) handleFile(input.files[0]); });
    $('#c-file-remove').addEventListener('click', function () {
      S.file = null; input.value = '';
      zone.style.display = ''; $('#c-upload-done').style.display = 'none';
    });
    function handleFile(f) {
      if (f.size > 10485760) { alert('File must be under 10MB'); return; }
      S.file = f;
      $('#c-file-name').textContent = f.name;
      zone.style.display = 'none'; $('#c-upload-done').style.display = '';
    }

    // Save values
    var fields = {
      'c-od-sph':['od','sph'],'c-od-cyl':['od','cyl'],'c-od-axis':['od','axis'],'c-od-add':['od','add'],
      'c-os-sph':['os','sph'],'c-os-cyl':['os','cyl'],'c-os-axis':['os','axis'],'c-os-add':['os','add']
    };
    Object.keys(fields).forEach(function (id) {
      var el = $('#' + id);
      if (el) el.addEventListener('change', function () {
        S[fields[id][0]][fields[id][1]] = el.value;
        // When CYL or AXIS changes, validate axis requirement
        var f = fields[id];
        if (f[1] === 'cyl' || f[1] === 'axis') checkAxisWarning(f[0]);
      });
    });
    $('#c-pd').addEventListener('change', function () { S.pd.v = this.value; });
    $('#c-pd-r').addEventListener('change', function () { S.pd.r = this.value; });
    $('#c-pd-l').addEventListener('change', function () { S.pd.l = this.value; });
    initPdMeasure(); // PD-MEASURE-TOOL

    // Glasses verification fields
    var rxConfEl = $('#c-rx-confirm');
    var rxVerify = $('#c-rx-verify');
    initDatePicker('c-rx-date-picker', 'c-rx-date', function (dateStr) {
      S.rxDate = dateStr;
      expiryAcknowledged.glasses = false;
      if (checkRxExpiry(dateStr, 'glasses')) showExpiryPopup('glasses');
      updateBtn(2);
    });
    bindDoctorField(false);
    if (rxConfEl) rxConfEl.addEventListener('change', function () { S.rxConfirm = this.checked; updateBtn(2); });
    // Show/hide verification based on method
    function updateRxVerifyVis() {
      if (rxVerify) rxVerify.style.display = S.method === 'later' ? 'none' : '';
    }
    // Patch method switching to also toggle verify visibility
    $$('.c-method').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(updateRxVerifyVis, 10);
      });
    });
    try { enhanceRxSelects(page); } catch (e) { console.warn('[Charmlio] Rx list enhance failed', e); } // RX-DROPDOWN
  }

  // ── Step 3: Tiers with Lottie thickness icons ──
  function renderTiers() {
    var wrap = $('#c-tiers');
    var h = '';

    // Summary pill showing selected lens type (rendered in separate container)
    var _ac3 = getActiveCoats();
    var coat = S.coats.length > 0 ? _ac3.find(function (x) { return x.id === S.coats[0]; }) : null;
    var pillWrap = $('#c-tier-pill');
    if (pillWrap) {
      if (coat) {
        var coatBase = coat.prices['standard'] || 0;
        var pillClass = coatBase === 0 ? 'c-summary-pill--green' : 'c-summary-pill--orange';
        var pillText = coatBase === 0 ? 'Included' : '+ ' + money(coatBase) + ' added';
        pillWrap.innerHTML = '<div class="c-summary-pill ' + pillClass + '">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> ' +
          coat.name + ' · ' + pillText + '</div>';
      } else {
        pillWrap.innerHTML = '';
      }
    }

    TIERS.forEach(function (t) {
      var hasLottie = !!LOTTIE_MAP[t.id];
      h += '<div class="c-tier" data-id="' + t.id + '">';

      // Lottie icon for thickness visualization
      if (hasLottie) {
        h += '<div class="c-tier-icon"><div class="c-lottie" data-lottie="' + t.id + '"></div></div>';
      }

      // Calculate delta price: coat.prices[tier] - coat.prices['standard']
      var tierDelta = 0;
      if (coat && coat.prices && coat.prices[t.id] !== undefined) {
        tierDelta = coat.prices[t.id] - (coat.prices['standard'] || 0);
      }

      h += '<div class="c-tier-body">' +
        '<div class="c-tier-badges">' +
        '<span class="c-tier-badge ' + t.badge + '">' + t.label + '</span>' +
        (t.rec ? '<span class="c-tier-badge rec">Recommended</span>' : '') +
        '</div>' +
        '<div class="c-tier-name">' + t.name + '</div>' +
        '<div class="c-tier-desc">' + t.desc + '</div>' +
        '<ul class="c-tier-feats">' +
        t.feats.map(function (f) { return '<li>' + CHECK_GREEN + ' ' + f + '</li>'; }).join('') +
        '</ul></div>' +
        '<div class="c-tier-right">' +
        '<div class="c-tier-price' + (tierDelta === 0 ? ' inc' : '') + '">' +
        (tierDelta === 0 ? 'Included' : '+ ' + money(tierDelta)) + '</div>' +
        '<div class="c-radio">' + CHECK_SVG + '</div>' +
        '</div></div>';
    });
    wrap.innerHTML = h;

    // Init Lottie for tier icons
    $$('.c-lottie[data-lottie]', wrap).forEach(function(el) {
      var key = el.getAttribute('data-lottie');
      initLottieIcon(el, key);
    });

    $$('.c-tier', wrap).forEach(function (card) {
      card.addEventListener('click', function () {
        $$('.c-tier', wrap).forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        S.tier = card.getAttribute('data-id');
        playLottieFor(S.tier);
        updateBtn(3); updateTotal(); updateSubtotalBar(3);
        if (navigator.vibrate) navigator.vibrate(10);
      });

      card.addEventListener('mouseenter', function() {
        var id = card.getAttribute('data-id');
        playLottieFor(id);
      });
    });
  }

  // ── Step 4: Coatings with Lottie icons ──
  function renderCoats() {
    var wrap = $('#c-coats');
    var activeCoats = isSunglasses ? SG_COATS : COATS;
    var h = '';

    if (isSunglasses) {
      // ── Sunglasses lens options: premium cards with Lottie icons ──
      activeCoats.forEach(function (a) {
        var badgePrice = a.prices['standard'] || 0;
        var priceLabel = '+ ' + money(badgePrice);
        var hasLottie = !!LOTTIE_MAP[a.id];

        h += '<div class="c-sg-card" data-id="' + a.id + '">';

        // Lottie icon area
        if (hasLottie) {
          h += '<div class="c-sg-icon' + (a.isPremium ? ' c-sg-icon--polarized' : '') + '">';
          h += '<div class="c-lottie" data-lottie="' + a.id + '"></div>';
          h += '</div>';
        }

        h += '<div class="c-sg-card-body">';
        h += '<div class="c-sg-card-header">';
        h += '<span class="c-sg-card-name">' + a.name + '</span>';
        h += '<span class="c-sg-card-price">' + priceLabel + '</span>';
        h += '</div>';
        if (a.isPremium) h += '<span class="c-sg-premium-badge">PREMIUM</span>';
        h += '<p class="c-sg-card-desc">' + a.desc + '</p>';

        // Feature pills
        h += '<div class="c-sg-pills">';
        h += '<span class="c-sg-pill c-sg-pill--green">100% UV Protection</span>';
        if (a.id === 'solid') {
          h += '<span class="c-sg-pill c-sg-pill--neutral">Choose Your Tint</span>';
        } else {
          h += '<span class="c-sg-pill c-sg-pill--blue">Glare Elimination</span>';
          h += '<span class="c-sg-pill c-sg-pill--blue">Enhanced Clarity</span>';
        }
        h += '</div>';

        h += '<div class="c-sg-radio">' + CHECK_SVG + '</div>';
        h += '</div></div>';
      });

      // Shared colour picker (shown for whichever option is selected)
      h += '<div class="c-sg-color-picker" id="c-sg-colors" style="display:none">';
      h += '<span class="c-sg-color-label">Choose your tint colour:</span>';
      h += '<div class="c-sg-color-swatches">';
      var colors = SG_COATS[0].colors; // same colours for both
      colors.forEach(function(c) {
        h += '<button class="c-sg-swatch" data-color="' + c.id + '" title="' + c.name + '">';
        h += '<span class="c-sg-dot" style="background: ' + c.dot + '"></span>';
        h += '<span class="c-sg-swatch-name">' + c.name + '</span>';
        h += '</button>';
      });
      h += '</div></div>';

    } else {
      // ── Regular glasses coatings ──
      activeCoats.forEach(function (a) {
        var hasLottie = !!LOTTIE_MAP[a.id];
        h += '<div class="c-coat" data-id="' + a.id + '">';

        if (hasLottie) {
          h += '<div class="c-coat-icon"><div class="c-lottie" data-lottie="' + a.id + '"></div></div>';
        }

        var badgePrice = a.prices['standard'] || 0;
        var badgeHtml = '';
        if (badgePrice === 0) {
          badgeHtml = '<span class="c-coat-badge c-coat-badge--green">Included</span>';
        } else {
          badgeHtml = '<span class="c-coat-badge c-coat-badge--orange">+ ' + money(badgePrice) + '</span>';
        }

        h += '<div class="c-coat-text"><div class="c-coat-name">' + a.name + ' ' + badgeHtml + '</div>' +
          '<div class="c-coat-desc">' + a.desc + '</div>';

        if (a.hasColor) {
          h += '<div class="c-trans-colors" onclick="event.stopPropagation()">' +
            '<span class="c-trans-label">Choose colour:</span>' +
            '<button class="c-trans-swatch" data-color="brown" title="Brown">' +
              '<span class="c-trans-dot" style="background: linear-gradient(135deg, #8B6914, #A0522D)"></span>' +
              '<span class="c-trans-name">Brown</span>' +
            '</button>' +
            '<button class="c-trans-swatch" data-color="gray" title="Gray">' +
              '<span class="c-trans-dot" style="background: linear-gradient(135deg, #6B7280, #9CA3AF)"></span>' +
              '<span class="c-trans-name">Gray</span>' +
            '</button>' +
          '</div>';
        }

        h += '</div>' +
          '<div class="c-coat-right">' +
          '<div class="c-radio">' + CHECK_SVG + '</div></div></div>';
      });
    }

    wrap.innerHTML = h;

    if (isSunglasses) {
      // ── Sunglasses card handlers ──
      // Init Lottie for sunglasses icons
      $$('.c-lottie[data-lottie]', wrap).forEach(function(el) {
        var key = el.getAttribute('data-lottie');
        initLottieIcon(el, key);
      });

      // Restore selected state after re-render
      if (S.coats.length > 0) {
        S.coats.forEach(function (id) {
          var card = $('.c-sg-card[data-id="' + id + '"]');
          if (card) card.classList.add('is-on');
        });
        var picker = $('#c-sg-colors');
        if (picker) picker.style.display = '';
        updateSgSwatches();
      }

      $$('.c-sg-card', wrap).forEach(function (card) {
        card.addEventListener('click', function () {
          var id = card.getAttribute('data-id');
          if (card.classList.contains('is-on')) return;

          $$('.c-sg-card', wrap).forEach(function (c) { c.classList.remove('is-on'); });
          S.coats = [id];
          card.classList.add('is-on');

          // Show colour picker for both solid and polarized
          var picker = $('#c-sg-colors');
          picker.style.display = '';
          if (!S.sgColor) { S.sgColor = 'gray'; updateSgSwatches(); }

          updateTotal();
          updateBtn(currentDataStep());
          updateSubtotalBar(currentDataStep());
          if (navigator.vibrate) navigator.vibrate(10);
        });
      });

      // Colour swatch handlers — only change colour, never switch lens type
      $$('.c-sg-swatch', wrap).forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          S.sgColor = btn.getAttribute('data-color');
          updateSgSwatches();
          // If nothing is selected yet, default to solid
          if (S.coats.length === 0) {
            var solidCard = $('.c-sg-card[data-id="solid"]');
            if (solidCard) { solidCard.classList.add('is-on'); S.coats = ['solid']; }
          }
          updateTotal();
          updateSubtotalBar(currentDataStep());
          if (navigator.vibrate) navigator.vibrate(10);
        });
      });

    } else {
      // ── Regular glasses handlers ──
      $$('.c-lottie[data-lottie]', wrap).forEach(function(el) {
        var key = el.getAttribute('data-lottie');
        initLottieIcon(el, key);
      });

      $$('.c-coat', wrap).forEach(function (row) {
        row.addEventListener('click', function () {
          var id = row.getAttribute('data-id');
          var wasOn = row.classList.contains('is-on');
          if (wasOn) return;

          $$('.c-coat', wrap).forEach(function (r) { r.classList.remove('is-on'); });
          S.coats = [];
          S.transitionColor = '';

          S.coats = [id];
          row.classList.add('is-on');
          playLottieFor(id);
          if (id === 'photo') {
            S.transitionColor = 'brown';
            updateTransitionSwatches();
            startPhotoCycle();
          } else {
            stopPhotoCycle();
          }
          updateTransitionSwatches();
          updateTotal();
          updateBtn(currentDataStep());
          updateSubtotalBar(currentDataStep());
          if (navigator.vibrate) navigator.vibrate(10);
        });

        row.addEventListener('mouseenter', function() {
          var id = row.getAttribute('data-id');
          if (LOTTIE_MAP[id]) playLottieFor(id);
        });
      });

      $$('.c-trans-swatch', wrap).forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          S.transitionColor = btn.getAttribute('data-color');
          updateTransitionSwatches();
          var photoRow = $('.c-coat[data-id="photo"]');
          var wasPhoto = S.coats[0] === 'photo';
          if (!wasPhoto) {
            $$('.c-coat', wrap).forEach(function (r) { r.classList.remove('is-on'); });
            S.coats = ['photo'];
            if (photoRow) photoRow.classList.add('is-on');
            playLottieFor('photo');
          }
          updateTotal();
          updateSubtotalBar(currentDataStep());
          if (navigator.vibrate) navigator.vibrate(10);
        });
      });
    }
  }

  function updateSgSwatches() {
    $$('.c-sg-swatch').forEach(function(btn) {
      var color = btn.getAttribute('data-color');
      btn.classList.toggle('is-active', color === S.sgColor);
    });
  }

  function updateTransitionSwatches() {
    $$('.c-trans-swatch').forEach(function(btn) {
      var color = btn.getAttribute('data-color');
      btn.classList.toggle('is-active', color === S.transitionColor);
    });
  }

  // ── Step 5: Review ──
  // ── Insurance helper (Review step) ──────────────────────────────
  // Fully optional. Never blocks checkout. The selection is recorded as a
  // hidden line-item property (underscore prefix → admin-only) so the choice,
  // and for non-accepting plans the customer's acknowledgement that they saw
  // the notice, shows on the order in Shopify admin.
  var INS_PROVIDERS = {
    'ab-blue-cross': { name: 'Alberta Blue Cross',   tone: 'ok' },
    'canada-life':   { name: 'Canada Life',          tone: 'ok' },
    'desjardins':    { name: 'Desjardins',           tone: 'ok' },
    'beneva':        { name: 'Beneva',               tone: 'ok' },
    'chambers':      { name: 'Chambers Plan',        tone: 'ok' },
    'claimsecure':   { name: 'ClaimSecure',          tone: 'ok' },
    'greenshield':   { name: 'Green Shield Canada',  tone: 'warn' },
    'sunlife':       { name: 'Sun Life',             tone: 'warn' },
    'equitable':     { name: 'Equitable',            tone: 'warn' },
    'not-listed':    { name: "My provider isn't listed", tone: 'neutral' },
    'none':          { name: 'Not using insurance',  tone: 'neutral' }
  };

  // Exact copy — do not rewrite, shorten, or add dashes.
  function insMessage(key) {
    var p = INS_PROVIDERS[key];
    if (!p) return null;
    if (p.tone === 'ok') {
      return { tone: 'ok', text: "You'll pay today and get a full itemized receipt to submit to " + p.name + " for reimbursement." };
    }
    if (p.tone === 'warn') {
      // Shown only AFTER the customer clicked through the notice popup (acceptInsPopup).
      return { tone: 'warn', text: "You acknowledged that " + p.name + " will decline this claim. Returns and cancellations are subject to a restocking fee." };
    }
    if (key === 'not-listed') {
      return { tone: 'neutral', text: "No problem. You'll still pay today and receive a full itemized receipt you can submit yourself. Since every plan is a little different, we suggest a quick call to your provider first: 'Do you cover prescription eyewear purchased online?' Five minutes now saves surprises later." };
    }
    return { tone: 'neutral', text: "Simple. Pay today, and your glasses are on their way. No paperwork needed." };
  }

  // Circle-with-X reads "not accepted" instantly; muted-red via currentColor.
  var INS_WARN_ICON = '<svg class="c-ins-msg-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>';

  function renderInsMessage(key) {
    var box = $('#c-ins-msg');
    if (!box) return;
    var msg = insMessage(key);
    if (!msg) { box.hidden = true; box.className = 'c-ins-msg'; box.innerHTML = ''; return; }
    box.className = 'c-ins-msg c-ins-msg--' + msg.tone;
    box.innerHTML = (msg.tone === 'warn' ? INS_WARN_ICON : '') + '<span class="c-ins-msg-text">' + msg.text + '</span>';
    box.hidden = false;
    // Replay the entrance animation on every selection change.
    box.classList.remove('is-in');
    void box.offsetWidth; // force reflow
    box.classList.add('is-in');
  }

  // ── Declined-provider notice popup ──────────────────────────────
  // Sun Life / Green Shield / Equitable: the pick only counts once the customer
  // clicks "I understand". The exact sentence + an Edmonton timestamp are frozen
  // into S.insurance and written to the order (applyInsuranceProps) so the
  // invoice and work order print what was agreed, even if this copy changes later.
  // Exact copy — keep in sync with #c-ins-popup in charmlio.liquid.
  function insAckText(name) {
    return name + " won't accept this transaction. If you submit it to them anyway and the claim gets declined, that is at your own risk. If you then decide to return or cancel your order, you are subject to a restocking fee. Customer clicked \"I understand\".";
  }
  function insAckStamp() {
    try {
      return new Intl.DateTimeFormat('en-US', { timeZone: 'America/Edmonton', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true, timeZoneName: 'short' }).format(new Date());
    } catch (e) { return new Date().toISOString(); }
  }

  var insPopupBound = false;
  function insPopupEl() { return document.getElementById('c-ins-popup'); }
  function openInsPopup(key) {
    var popup = insPopupEl();
    var p = INS_PROVIDERS[key];
    if (!popup || !p) return;
    var nameEl = document.getElementById('c-ins-pop-provider');
    if (nameEl) nameEl.textContent = p.name;
    popup.setAttribute('data-key', key);
    popup.classList.add('is-open');
    if (!insPopupBound) {
      insPopupBound = true;
      var ok = document.getElementById('c-ins-pop-ok');
      var back = document.getElementById('c-ins-pop-back');
      if (ok) ok.addEventListener('click', acceptInsPopup);
      if (back) back.addEventListener('click', declineInsPopup);
      // Backdrop tap / Escape = no acknowledgement, same as "different provider".
      popup.addEventListener('click', function (e) { if (e.target === popup) declineInsPopup(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.classList.contains('is-open')) declineInsPopup();
      });
    }
    var okBtn = document.getElementById('c-ins-pop-ok');
    if (okBtn) setTimeout(function () { try { okBtn.focus(); } catch (e) {} }, 60);
  }
  function acceptInsPopup() {
    var popup = insPopupEl();
    if (!popup) return;
    var key = popup.getAttribute('data-key');
    var p = INS_PROVIDERS[key];
    popup.classList.remove('is-open');
    if (!p) return;
    S.insurance = { key: key, name: p.name, tone: p.tone, acknowledged: true, ackText: insAckText(p.name), ackAt: insAckStamp() };
    renderInsMessage(key);
    fireInsurancePick(key);
    if (navigator.vibrate) navigator.vibrate(8);
  }
  function declineInsPopup() {
    var popup = insPopupEl();
    if (!popup) return;
    popup.classList.remove('is-open');
    S.insurance = null;
    try { localStorage.removeItem('charmlio_insurance'); } catch (e) {}
    var sel = document.getElementById('c-ins-select');
    if (sel) {
      sel.value = '';
      // Custom dropdown repaints its placeholder off this event; our own change
      // handler sees no provider and clears the note.
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    renderInsMessage(null);
  }

  function setInsuranceOpen(isOpen) {
    var w = $('#c-ins');
    var toggle = $('#c-ins-toggle');
    if (!w) return;
    w.setAttribute('data-open', isOpen ? 'true' : 'false');
    if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  // First-party "which provider did they pick" counter — mirrors fireUsagePick.
  // At most one beacon per provider per configurator session (page load) so the
  // admin's Insurance tab counts PEOPLE, not button mashes. Fired only on a real
  // user pick (the restore path sets the value without dispatching 'change').
  // Never blocks or surfaces to the shopper.
  var insFired = {};
  function fireInsurancePick(key) {
    if (!key || insFired[key]) return;
    insFired[key] = true;
    try {
      fetch(CHARMLIO_API_BASE + '/api/config?service=insurance-click', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ provider: key }),
        keepalive: true
      }).catch(function () { /* never surface analytics failures to a shopper */ });
    } catch (e) {}
  }

  var insBound = false;
  function bindInsurance() {
    if (insBound) return;
    var w = $('#c-ins');
    if (!w) return;
    insBound = true;
    var toggle = $('#c-ins-toggle');
    var sel = $('#c-ins-select');

    if (toggle) {
      toggle.addEventListener('click', function () {
        setInsuranceOpen(w.getAttribute('data-open') !== 'true');
      });
    }

    // Restore a prior selection (this browser) so a returning customer keeps
    // their context — but stay collapsed by default.
    try {
      var saved = localStorage.getItem('charmlio_insurance');
      // Declined providers are never restored: the click-through must happen
      // fresh on every visit (the acknowledgement is stamped per order).
      if (saved && INS_PROVIDERS[saved] && INS_PROVIDERS[saved].tone === 'warn') {
        localStorage.removeItem('charmlio_insurance');
        saved = null;
      }
      if (saved && INS_PROVIDERS[saved] && sel) {
        sel.value = saved;
        S.insurance = { key: saved, name: INS_PROVIDERS[saved].name, tone: INS_PROVIDERS[saved].tone };
        renderInsMessage(saved);
      }
    } catch (e) {}

    if (sel) {
      sel.addEventListener('change', function () {
        var key = sel.value;
        var p = INS_PROVIDERS[key];
        if (!p) { S.insurance = null; renderInsMessage(null); return; }
        if (p.tone === 'warn') {
          // Declined provider: nothing is recorded until "I understand" (acceptInsPopup).
          S.insurance = null;
          renderInsMessage(null);
          try { localStorage.removeItem('charmlio_insurance'); } catch (e) {}
          openInsPopup(key);
          return;
        }
        S.insurance = { key: key, name: p.name, tone: p.tone };
        try { localStorage.setItem('charmlio_insurance', key); } catch (e) {}
        renderInsMessage(key);
        fireInsurancePick(key);
        if (navigator.vibrate) navigator.vibrate(8);
      });
    }
  }

  // ── Custom Material-style provider dropdown ─────────────────────
  // A purely visual layer over the native <select id="c-ins-select">, which
  // stays in the DOM as the single source of truth. Choosing a row writes the
  // select's value and dispatches a bubbling 'change' — that fires ALL the
  // existing message / localStorage / order-record logic (in bindInsurance).
  // This function only paints; it never duplicates that logic.
  // Custom Material-style provider dropdown. Builds itself from the (hidden)
  // native <select id="c-ins-select"> which stays the source of truth; on pick
  // it sets select.value + dispatches 'change' so the existing message /
  // localStorage / order-record logic runs unchanged.
  function initInsDropdown() {
    var sel = $('#c-ins-select');
    if (!sel || sel.getAttribute('data-dd-init') === '1') return;
    sel.setAttribute('data-dd-init', '1');

    var CARET = '<svg class="c-ins-dd-caret" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
    var CHECK = '<svg class="c-ins-dd-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

    // First option is the disabled placeholder ("Select your provider").
    var placeholder = (sel.options[0] && sel.options[0].disabled) ? sel.options[0].text : 'Select your provider';

    // Real, selectable options in DOM order — labels/values from the <select>.
    var opts = [];
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].disabled) continue;
      opts.push({ value: sel.options[i].value, label: sel.options[i].text });
    }

    var rowsHtml = '';
    for (var j = 0; j < opts.length; j++) {
      rowsHtml += '<div class="c-ins-dd-opt" role="option" id="c-ins-dd-opt-' + j + '"'
        + ' data-index="' + j + '" aria-selected="false">'
        + '<span class="c-ins-dd-opt-label">' + opts[j].label + '</span>' + CHECK + '</div>';
    }

    var dd = document.createElement('div');
    dd.className = 'c-ins-dd';
    dd.id = 'c-ins-dd';
    dd.setAttribute('data-open', 'false');
    dd.innerHTML =
      '<button type="button" class="c-ins-dd-trigger" id="c-ins-dd-trigger"'
        + ' aria-haspopup="listbox" aria-expanded="false" aria-controls="c-ins-dd-panel">'
        + '<span class="c-ins-dd-label is-placeholder" id="c-ins-dd-value">' + placeholder + '</span>'
        + CARET
      + '</button>'
      + '<div class="c-ins-dd-panel" id="c-ins-dd-panel" role="listbox" tabindex="-1">' + rowsHtml + '</div>';

    // Drop the visual layer right after the (hidden) native select.
    sel.parentNode.insertBefore(dd, sel.nextSibling);

    var trigger = $('#c-ins-dd-trigger', dd);
    var panel = $('#c-ins-dd-panel', dd);
    var valueSpan = $('#c-ins-dd-value', dd);
    var rows = $$('.c-ins-dd-opt', dd);
    var activeIndex = -1;

    // Point the field label ("Select your provider") at the trigger + listbox.
    var fieldLabel = $('.c-ins-label', $('#c-ins'));
    if (fieldLabel) {
      if (!fieldLabel.id) fieldLabel.id = 'c-ins-dd-fieldlabel';
      trigger.setAttribute('aria-labelledby', fieldLabel.id + ' c-ins-dd-value');
      panel.setAttribute('aria-labelledby', fieldLabel.id);
    }

    function isOpen() { return dd.getAttribute('data-open') === 'true'; }

    function indexForValue(v) {
      for (var k = 0; k < opts.length; k++) { if (opts[k].value === v) return k; }
      return -1;
    }

    var PANEL_MAX = 252; // keep in sync with .c-ins-dd-panel[data-open] max-height
    function setActive(idx) {
      if (activeIndex > -1 && rows[activeIndex]) rows[activeIndex].classList.remove('is-active');
      activeIndex = idx;
      if (idx > -1 && rows[idx]) {
        rows[idx].classList.add('is-active');
        panel.setAttribute('aria-activedescendant', rows[idx].id);
        // Measure against the panel's FINAL height (scrollHeight), not its live
        // clientHeight — on open, clientHeight is still ~0 mid max-height
        // animation and would wrongly nudge the list down a row.
        var r = rows[idx];
        var vh = Math.min(PANEL_MAX, panel.scrollHeight);
        if (r.offsetTop < panel.scrollTop) panel.scrollTop = r.offsetTop - 6;
        else if (r.offsetTop + r.offsetHeight > panel.scrollTop + vh) {
          panel.scrollTop = r.offsetTop + r.offsetHeight - vh + 6;
        }
      } else {
        panel.removeAttribute('aria-activedescendant');
      }
    }

    function openDd() {
      if (isOpen()) return;
      dd.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
      var startIdx = indexForValue(sel.value);
      setActive(startIdx > -1 ? startIdx : 0);
      try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); }
      document.addEventListener('mousedown', onDocDown, true);
      document.addEventListener('keydown', onDocKey, true);
    }

    function closeDd(refocus) {
      if (!isOpen()) return;
      dd.setAttribute('data-open', 'false');
      trigger.setAttribute('aria-expanded', 'false');
      setActive(-1);
      document.removeEventListener('mousedown', onDocDown, true);
      document.removeEventListener('keydown', onDocKey, true);
      if (refocus) trigger.focus();
    }

    function choose(idx) {
      if (idx < 0 || idx >= opts.length) return;
      sel.value = opts[idx].value;
      // Hand off to the existing logic (message / storage / order record).
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      closeDd(true);
    }

    function onDocDown(e) { if (!dd.contains(e.target)) closeDd(false); }

    function onDocKey(e) {
      if (!isOpen()) return;
      var k = e.key;
      if (k === 'Escape') { e.preventDefault(); closeDd(true); }
      else if (k === 'ArrowDown') { e.preventDefault(); setActive(activeIndex < 0 ? 0 : Math.min(opts.length - 1, activeIndex + 1)); }
      else if (k === 'ArrowUp') { e.preventDefault(); setActive(activeIndex < 0 ? opts.length - 1 : Math.max(0, activeIndex - 1)); }
      else if (k === 'Home') { e.preventDefault(); setActive(0); }
      else if (k === 'End') { e.preventDefault(); setActive(opts.length - 1); }
      else if (k === 'Enter' || k === ' ' || k === 'Spacebar') { e.preventDefault(); if (activeIndex > -1) choose(activeIndex); }
      else if (k === 'Tab') { closeDd(false); }
    }

    trigger.addEventListener('click', function () { if (isOpen()) closeDd(true); else openDd(); });
    trigger.addEventListener('keydown', function (e) {
      if (isOpen()) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        openDd();
      }
    });

    rows.forEach(function (row) {
      var idx = parseInt(row.getAttribute('data-index'), 10);
      row.addEventListener('click', function () { choose(idx); });
      row.addEventListener('mousemove', function () { if (idx !== activeIndex) setActive(idx); });
    });

    // Mirror the source-of-truth <select> into the trigger label + row checks.
    function syncFromSelect() {
      var idx = indexForValue(sel.value);
      for (var m = 0; m < rows.length; m++) {
        rows[m].setAttribute('aria-selected', m === idx ? 'true' : 'false');
      }
      if (idx > -1) {
        valueSpan.textContent = opts[idx].label;
        valueSpan.classList.remove('is-placeholder');
      } else {
        valueSpan.textContent = placeholder;
        valueSpan.classList.add('is-placeholder');
      }
    }
    sel.addEventListener('change', syncFromSelect);

    // If the outer helper section collapses, close the dropdown with it.
    var outer = $('#c-ins');
    if (outer && window.MutationObserver) {
      new MutationObserver(function () {
        if (outer.getAttribute('data-open') !== 'true') closeDd(false);
      }).observe(outer, { attributes: true, attributeFilter: ['data-open'] });
    }

    // Initial paint — bindInsurance() may have restored a saved provider first.
    syncFromSelect();
  }

  // Show on glasses + contact-lens review; hide for Frame Only.
  function updateInsuranceVisibility() {
    var w = $('#c-ins');
    if (!w) return;
    w.style.display = (S.type === 'frame-only') ? 'none' : '';
  }

  // Attach the insurance record to a line item's properties (frame / CL line).
  function applyInsuranceProps(props) {
    if (!S.insurance || !S.insurance.key) return;
    // A declined provider is only recorded once the customer clicked through the
    // notice popup; anything else would print an acknowledgement nobody gave.
    if (S.insurance.tone === 'warn' && !S.insurance.acknowledged) return;
    props['_Insurance Provider'] = S.insurance.name;
    if (S.insurance.tone === 'warn') {
      // Frozen sentence + Edmonton timestamp → invoice tile and work-order band
      // in the admin panel (charmlio-backend/public/admin7804900090.html).
      props['_Insurance Acknowledged'] = S.insurance.ackText;
      props['_Insurance Acknowledged At'] = S.insurance.ackAt;
    }
  }

  function renderReview() {
    var wrap = $('#c-review');

    // Contact Lens review
    if (S.type === 'contact-lens') {
      renderClReview(wrap);
      return;
    }

    var typeObj = TYPES.find(function (t) { return t.id === S.type; });
    var tierObj = S.tier ? TIERS.find(function (t) { return t.id === S.tier; }) : null;
    var h = '';

    // Product header with image
    h += '<div class="c-rev-product">';
    h += '<img class="c-rev-product-img" src="' + (P.imageMed || P.image || '') + '" alt="' + (P.title || '') + '">';
    h += '<div class="c-rev-product-info">';
    h += '<div class="c-rev-product-name">' + (P.title || '') + '</div>';
    h += '<div class="c-rev-product-price">' + money(P.price || 0) + '</div>';
    h += '</div></div>';

    // Line items
    h += '<div class="c-rev-items">';

    // Frame
    h += '<div class="c-rev-row">' +
      '<div class="c-rev-row-left"><span class="c-rev-cat">Frame</span><span class="c-rev-detail">' + (P.title || '') + '</span></div>' +
      '<span class="c-rev-price">' + money(P.price || 0) + '</span></div>';

    // Prescription Type
    if (typeObj && S.type !== 'frame-only') {
      h += '<div class="c-rev-row">' +
        '<div class="c-rev-row-left"><span class="c-rev-cat">Prescription Type</span><span class="c-rev-detail">' + typeObj.name + '</span></div>' +
        '<span class="c-rev-price">Included</span></div>';
    }

    // Lens Type (coating / sun lens) — base price at Standard tier.
    // Skipped for Frame Only so a stale lens selection can never render charges the total ignores.
    if (S.type !== 'frame-only' && S.coats.length > 0) {
      var _ac4 = getActiveCoats();
      var coat = _ac4.find(function (x) { return x.id === S.coats[0]; });
      if (coat) {
        var coatLabel = coat.name;
        if (isSunglasses && S.sgColor) coatLabel += ' (' + S.sgColor.charAt(0).toUpperCase() + S.sgColor.slice(1) + ')';
        if (!isSunglasses && S.coats[0] === 'photo' && S.transitionColor) coatLabel += ' (' + S.transitionColor.charAt(0).toUpperCase() + S.transitionColor.slice(1) + ')';
        var coatBase = coat.prices['standard'] || 0;
        var catLabel = isSunglasses ? 'Sun Lens' : 'Lens Type';
        h += '<div class="c-rev-row">' +
          '<div class="c-rev-row-left"><span class="c-rev-cat">' + catLabel + '</span><span class="c-rev-detail">' + coatLabel + '</span></div>' +
          '<span class="c-rev-price">' + (coatBase === 0 ? 'Included' : '+ ' + money(coatBase)) + '</span></div>';

        // Thickness upgrade — delta over Standard
        if (tierObj) {
          var tierDelta = (coat.prices[tierObj.id] || 0) - coatBase;
          h += '<div class="c-rev-row">' +
            '<div class="c-rev-row-left"><span class="c-rev-cat">Lens Thickness</span><span class="c-rev-detail">' + tierObj.name + '</span></div>' +
            '<span class="c-rev-price">' + (tierDelta === 0 ? 'Included' : '+ ' + money(tierDelta)) + '</span></div>';
        }
      }
    } else if (S.type !== 'frame-only' && tierObj) {
      h += '<div class="c-rev-row">' +
        '<div class="c-rev-row-left"><span class="c-rev-cat">Lens Thickness</span><span class="c-rev-detail">' + tierObj.name + '</span></div>' +
        '<span class="c-rev-price">Included</span></div>';
    }

    h += '</div>'; // end c-rev-items

    // Dotted separator + Subtotal
    h += '<div class="c-rev-sep"></div>';
    h += '<div class="c-rev-subtotal">' +
      '<span class="c-rev-subtotal-label">Sub Total</span>' +
      '<span class="c-rev-subtotal-price">' + money(total()) + '</span></div>';

    // Prescription card
    if (S.type !== 'frame-only') {
      h += '<div class="c-rev-rx-card">';
      if (S.method === 'manual') {
        h += '<div class="c-rev-rx-header"><div class="c-rev-rx-title">Your Prescription</div><div class="c-rev-rx-badges">' +
          '<span class="c-rev-rx-confirmed"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg> My Rx is correct</span>' +
          '<span class="c-rev-rx-info" tabindex="0" aria-label="More info"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg><span class="c-rev-rx-tooltip">You confirmed that your prescription details are entered correctly and match your original prescription.</span></span></div></div>';
        var showAdd = S.od.add || S.os.add;
        var pdVal = S.pd.mode === 'dual' && S.pd.r && S.pd.l ? 'R: ' + S.pd.r + ' / L: ' + S.pd.l : (S.pd.v || $('#c-pd').value || '63');
        h += '<table class="c-rev-rx-table"><thead><tr><th></th><th>SPH</th><th>CYL</th><th>AXIS</th>';
        if (showAdd) h += '<th>ADD</th>';
        h += '<th>PD</th></tr></thead><tbody>';
        h += '<tr><td class="c-rev-rx-eye">OD <small>Right</small></td><td>' + (S.od.sph || '—') + '</td><td>' + (S.od.cyl || '—') + '</td><td>' + (S.od.axis || '—') + '</td>';
        if (showAdd) h += '<td>' + (S.od.add || '—') + '</td>';
        var pdR = S.pd.mode === 'dual' ? (S.pd.r || '—') : (S.pd.v || $('#c-pd').value || '63');
        h += '<td>' + pdR + '</td></tr>';
        h += '<tr><td class="c-rev-rx-eye">OS <small>Left</small></td><td>' + (S.os.sph || '—') + '</td><td>' + (S.os.cyl || '—') + '</td><td>' + (S.os.axis || '—') + '</td>';
        if (showAdd) h += '<td>' + (S.os.add || '—') + '</td>';
        var pdL = S.pd.mode === 'dual' ? (S.pd.l || '—') : '';
        h += '<td>' + pdL + '</td></tr>';
        h += '</tbody></table>';
      } else if (S.method === 'upload' && S.file) {
        h += '<div class="c-rev-rx-header"><div class="c-rev-rx-title">Prescription</div>' +
          '<span class="c-rev-rx-confirmed"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg> Uploaded</span></div>';
        h += '<div class="c-rev-file"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg> ' + S.file.name + '</div>';
        var pdValUp = S.pd.mode === 'dual' && S.pd.r && S.pd.l ? 'R: ' + S.pd.r + ' / L: ' + S.pd.l : (S.pd.v || $('#c-pd').value || '63');
        h += '<div class="c-rev-rx-meta"><span><strong>PD:</strong> ' + pdValUp + '</span></div>';
      } else if (S.method === 'later') {
        h += '<div class="c-rev-rx-header"><div class="c-rev-rx-title">Prescription</div>' +
          '<span class="c-rev-rx-pending"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg> Send later</span></div>';
        h += '<div class="c-rev-file"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><polyline points="22,7 12,13 2,7"/></svg> Will be sent via email</div>';
      }
      // Doctor + date row
      if (S.method !== 'later' && (S.rxDoctor || S.rxDate)) {
        h += '<div class="c-rev-rx-meta">';
        if (S.rxDoctor) h += '<span><strong>Doctor:</strong> ' + S.rxDoctor + '</span>';
        if (S.rxDate) h += '<span><strong>Rx Date:</strong> ' + S.rxDate + '</span>';
        h += '</div>';
      }
      // Note (inside card)
      h += '<div class="c-rev-rx-note"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg> Our opticians review every order before production. If anything needs attention, we\'ll contact you within 1 business day.</div>';

      // Final sale warning inside card — only if prescription is expired
      if (checkRxExpiry(S.rxDate, 'glasses')) {
        h += '<div class="c-rev-rx-warning">';
        h += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>';
        h += '<div><strong>Final sale policy:</strong> Your prescription appears to be expired. Prescription lenses are custom-made to your exact specifications. If you are unable to see clearly due to an outdated prescription, we will not be able to offer a return or exchange.</div>';
        h += '</div>';
      }

      h += '</div>'; // end c-rev-rx-card
    }

    // Momono deal — final sale notice on review step
    if (P.vendor && P.vendor.toLowerCase() === 'momono') {
      h += '<div class="c-momono-final-sale">';
      h += '<strong>Final Sale</strong> — This item is final sale. No returns, exchanges, or warranty.';
      h += '</div>';
    }

    wrap.innerHTML = h;
  }

  function renderClReview(wrap) {
    var h = '';
    var isToric = P.prescriptionType === 'toric';
    var dia = (P.rxParams && P.rxParams.diameter && P.rxParams.diameter.values) ? P.rxParams.diameter.values[0] : '';
    var bc = S.baseCurve || ((P.rxParams && P.rxParams.baseCurve && P.rxParams.baseCurve.values) ? P.rxParams.baseCurve.values[0] : '');
    var qR = S.clBoxQty && S.clBoxQty.right != null ? S.clBoxQty.right : 1;
    var qL = S.clBoxQty && S.clBoxQty.left != null ? S.clBoxQty.left : 1;
    var sameCheck = $('#c-cl-same');
    var isSameRx = sameCheck && sameCheck.checked;
    var unitPrice = P.price || 0;
    var totalQty = isSameRx ? qR : (qR + qL);
    var lineTotal = unitPrice * totalQty;

    // Product header
    h += '<div class="c-rev-product">';
    h += '<img class="c-rev-product-img" src="' + (P.imageMed || P.image || '') + '" alt="' + (P.title || '') + '">';
    h += '<div class="c-rev-product-info">';
    h += '<div class="c-rev-product-name">' + (P.title || '') + '</div>';
    h += '<div class="c-rev-product-price">' + money(unitPrice) + ' per box</div>';
    h += '</div></div>';

    // Line items
    h += '<div class="c-rev-items">';
    if (isSameRx) {
      h += '<div class="c-rev-row"><div class="c-rev-row-left"><span class="c-rev-cat">Both Eyes</span><span class="c-rev-detail">' + qR + ' box' + (qR > 1 ? 'es' : '') + '</span></div><span class="c-rev-price">' + money(unitPrice * qR) + '</span></div>';
    } else {
      h += '<div class="c-rev-row"><div class="c-rev-row-left"><span class="c-rev-cat">Right Eye (OD)</span><span class="c-rev-detail">' + qR + ' box' + (qR > 1 ? 'es' : '') + '</span></div><span class="c-rev-price">' + money(unitPrice * qR) + '</span></div>';
      h += '<div class="c-rev-row"><div class="c-rev-row-left"><span class="c-rev-cat">Left Eye (OS)</span><span class="c-rev-detail">' + qL + ' box' + (qL > 1 ? 'es' : '') + '</span></div><span class="c-rev-price">' + money(unitPrice * qL) + '</span></div>';
    }
    h += '</div>';

    // Subtotal
    h += '<div class="c-rev-sep"></div>';
    h += '<div class="c-rev-subtotal"><span class="c-rev-subtotal-label">Sub Total</span><span class="c-rev-subtotal-price">' + money(lineTotal) + '</span></div>';

    // Prescription table
    h += '<div class="c-rev-sep"></div>';
    h += '<div class="c-rev-rx-title">Your Contact Lens Prescription</div>';

    if (S.clMethod === 'upload' && S.clFile) {
      h += '<div class="c-rev-file"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg> ' + S.clFile.name + '</div>';
    } else {
      h += '<table class="c-rev-rx-table"><thead><tr><th></th><th>SPH</th>';
      if (isToric) h += '<th>CYL</th><th>AXIS</th>';
      h += '<th>BC</th><th>DIA</th>';
      h += '</tr></thead><tbody>';
      var bcStr = bc ? (typeof bc === 'number' ? bc.toFixed(1) : bc) : '—';
      var diaStr = dia ? (typeof dia === 'number' ? dia.toFixed(1) : dia) : '—';
      if (isSameRx) {
        h += '<tr><td class="c-rev-rx-eye">Both Eyes</td><td>' + (S.clRx.right.sph || '—') + '</td>';
        if (isToric) h += '<td>' + (S.clRx.right.cyl || '—') + '</td><td>' + (S.clRx.right.axis ? S.clRx.right.axis + '°' : '—') + '</td>';
        h += '<td>' + bcStr + '</td><td>' + diaStr + '</td></tr>';
      } else {
        h += '<tr><td class="c-rev-rx-eye">OD <small>Right</small></td><td>' + (S.clRx.right.sph || '—') + '</td>';
        if (isToric) h += '<td>' + (S.clRx.right.cyl || '—') + '</td><td>' + (S.clRx.right.axis ? S.clRx.right.axis + '°' : '—') + '</td>';
        h += '<td>' + bcStr + '</td><td>' + diaStr + '</td></tr>';
        h += '<tr><td class="c-rev-rx-eye">OS <small>Left</small></td><td>' + (S.clRx.left.sph || '—') + '</td>';
        if (isToric) h += '<td>' + (S.clRx.left.cyl || '—') + '</td><td>' + (S.clRx.left.axis ? S.clRx.left.axis + '°' : '—') + '</td>';
        h += '<td>' + bcStr + '</td><td>' + diaStr + '</td></tr>';
      }
      h += '</tbody></table>';
    }

    // Doctor + date info
    if (S.clRxDoctor || S.clRxDate) {
      h += '<div style="display:flex;gap:16px;margin-top:10px;font-size:13px;color:#6B7280">';
      if (S.clRxDoctor) h += '<span><strong>Doctor:</strong> ' + S.clRxDoctor + '</span>';
      if (S.clRxDate) h += '<span><strong>Rx Date:</strong> ' + S.clRxDate + '</span>';
      h += '</div>';
    }
    if (isSameRx) {
      h += '<div style="margin-top:8px;font-size:13px;color:#6B7280">Same prescription for both eyes — ' + qR + ' box' + (qR > 1 ? 'es' : '') + '</div>';
    } else {
      h += '<div style="margin-top:8px;font-size:13px;color:#6B7280">Right: ' + qR + ' box' + (qR > 1 ? 'es' : '') + ', Left: ' + qL + ' box' + (qL > 1 ? 'es' : '') + '</div>';
    }

    h += '<div class="c-review-note">We verify every contact lens prescription before shipping. If anything needs attention, we\'ll reach out within 1 business day.</div>';

    if (checkRxExpiry(S.clRxDate, 'cl')) {
      h += '<div class="c-final-sale">';
      h += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>';
      h += '<div><strong>Final sale policy:</strong> Your prescription appears to be expired. Prescription contact lenses are made to your exact specifications. If you are unable to see clearly due to an outdated prescription, we will not be able to offer a return or exchange.</div>';
      h += '</div>';
    }

    wrap.innerHTML = h;
  }

  // POST to /cart/add.js. With no file, send the items array as JSON.
  // With a file, follow Shopify's documented single-item multipart format
  // (file-bearing item alone), then send any remaining items via JSON.
  // The file property name must NOT start with `_` — Shopify's file→URL
  // pipeline only triggers on non-prefixed property names.
  function postCartJson(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }
  function postCart(items, fileForFirstItem, filePropName) {
    if (!fileForFirstItem) return postCartJson(items);

    var first = items[0];
    var fd = new FormData();
    fd.append('id', String(first.id));
    fd.append('quantity', String(first.quantity));
    var p = first.properties || {};
    Object.keys(p).forEach(function (k) {
      if (k === filePropName) return;
      fd.append('properties[' + k + ']', p[k] == null ? '' : String(p[k]));
    });
    fd.append('properties[' + filePropName + ']', fileForFirstItem, fileForFirstItem.name);

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: fd
    }).then(function (r) {
      if (!r.ok || items.length <= 1) return r;
      // The lens add-on is a SECOND request after the frame is already committed (multipart adds
      // are not atomic). If it fails — HTTP error OR network rejection — roll back the just-added
      // orphan frame so it can never reach checkout unpaired (the free-lens bug, #1288).
      function rollbackFrame() {
        return r.clone().json().then(function (added) {
          var key = added && (added.key || (added.items && added.items[0] && added.items[0].key));
          if (!key) return;
          return fetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
        }).catch(function () { /* best-effort; downstream checkout + backend guards still block it */ });
      }
      return postCartJson(items.slice(1)).then(function (r2) {
        if (r2.ok) return r;
        return rollbackFrame().then(function () { return r2; });
      }, function (err) {
        return rollbackFrame().then(function () { throw err; });
      });
    });
  }

  // Fire a GA4 add_to_cart event. Shopify's native Google & YouTube channel does
  // NOT catch our AJAX /cart/add.js adds, so the analytics funnel under-counts
  // "Added to cart" without this. Fire-and-forget + fully guarded (try/catch +
  // typeof check) so analytics can NEVER block the cart add or the /cart redirect.
  // gtag is injected by Shopify's Google channel — same gtag the theme already
  // uses for phone_click / book_exam_click events.
  function fireGa4AddToCart(vid, qty) {
    try {
      if (typeof window.gtag !== 'function') return;
      var q = qty && qty > 0 ? qty : 1;
      var valueDollars = (total() || 0) / 100;
      var name = (P.title || '').replace(/<br\s*\/?>(?:\s*)/gi, ' ').trim() || 'Charm Optical product';
      window.gtag('event', 'add_to_cart', {
        currency: 'CAD',
        value: valueDollars,
        items: [{
          item_id: String(vid || P.variantId || ''),
          item_name: name,
          price: valueDollars / q,
          quantity: q
        }]
      });
    } catch (e) { /* analytics must never break the cart */ }
  }

  // ── Add to Cart ──
  // Unique per-pair token stamped on BOTH a frame line and its lens add-on line, so the cart
  // and backend pair them by identity — NOT by the shared lens variant id, which collides when
  // two frames share a variant. Closes the free-lens hole even for same-variant duplicate lines.
  function genPairId() {
    try { if (window.crypto && typeof crypto.randomUUID === 'function') return crypto.randomUUID(); } catch (e) {}
    return 'clp_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }
  function addToCart() {
    // Contact lens cart
    if (S.type === 'contact-lens') {
      addClToCart();
      return;
    }

    var typeObj = TYPES.find(function (t) { return t.id === S.type; });
    var tierObj = S.tier ? TIERS.find(function (t) { return t.id === S.tier; }) : null;
    var props = { '_charmlio': 'true', 'Prescription Type': typeObj ? typeObj.name : 'Frame Only' };

    // Optional insurance record (glasses only; widget is hidden for Frame Only).
    if (S.type !== 'frame-only') applyInsuranceProps(props);

    // Lens/fee integrity (root-cause guard for the free-lens bug, order #1288). When a lens is
    // configured (coating/sun-lens + thickness): (1) ABORT if its priced lens variant can't be
    // resolved, so lens work-order props are never written without a chargeable lens line; and
    // (2) mint a per-pair token stamped on the frame here and on its lens line below, so the two
    // are paired by identity rather than by the shared lens variant id.
    var pairId = null;
    if (S.type !== 'frame-only' && S.coats.length > 0 && S.tier) {
      if (!LENS_VARIANT_MAP[S.coats[0] + '_' + S.tier]) {
        alert('Sorry — this lens option is temporarily unavailable online. Please contact us and we\'ll set it up for you.');
        return;
      }
      pairId = genPairId();
      props['_charmlio_pair_id'] = pairId;
    }

    if (S.type !== 'frame-only') {
      props['_Rx Method'] = S.method === 'manual' ? 'Entered Manually' : S.method === 'upload' ? 'File Uploaded' : 'Send Later';
      if (S.method === 'manual') {
        props['_OD (Right)'] = 'SPH: ' + S.od.sph + ', CYL: ' + S.od.cyl + (S.od.axis ? ', AXIS: ' + S.od.axis : '') + (S.od.add ? ', ADD: ' + S.od.add : '');
        props['_OS (Left)'] = 'SPH: ' + S.os.sph + ', CYL: ' + S.os.cyl + (S.os.axis ? ', AXIS: ' + S.os.axis : '') + (S.os.add ? ', ADD: ' + S.os.add : '');
      } else if (S.method === 'upload' && S.file) {
        // Actual file is attached via multipart in postCart() so Shopify
        // stores it and exposes a download URL on the order line.
      }
      // PD applies to both manual and uploaded prescriptions (not "send later")
      if (S.method !== 'later') {
        var pdStr = S.pd.mode === 'dual' && S.pd.r && S.pd.l ? 'R: ' + S.pd.r + ' / L: ' + S.pd.l : (S.pd.v || $('#c-pd').value || '63');
        props['_PD'] = pdStr;
        if (S.pdSource) props['_PD Source'] = S.pdSource; // PD-MEASURE-TOOL
        props['_Prescription Date'] = S.rxDate || '';
        props['_Prescribing Doctor'] = S.rxDoctor || '';
        if (checkRxExpiry(S.rxDate, 'glasses')) props['_Expired Rx'] = 'true';
      }
      // Coatings / Sunglasses lens — base price at Standard tier
      if (S.coats.length > 0) {
        var ac = getActiveCoats();
        var coat = ac.find(function (x) { return x.id === S.coats[0]; });
        if (coat) {
          var coatLabel = coat.name;
          if (isSunglasses && S.sgColor) coatLabel += ' (' + S.sgColor.charAt(0).toUpperCase() + S.sgColor.slice(1) + ')';
          if (!isSunglasses && S.coats[0] === 'photo' && S.transitionColor) coatLabel += ' (' + S.transitionColor + ')';
          props[isSunglasses ? 'Sun Lens' : 'Coatings'] = coatLabel;
          if (isSunglasses && S.sgColor) props['_Sun Lens Color'] = S.sgColor;
          if (!isSunglasses && S.coats[0] === 'photo' && S.transitionColor) props['_Transition Color'] = S.transitionColor;
          var coatBase = coat.prices['standard'] || 0;
          if (coatBase > 0) props[isSunglasses ? '_Sun Lens Price' : '_Coating Price'] = money(coatBase);
          // Work-order-only bracket label. Hidden from customer cart (underscore prefix), read by Charmlio admin/work-order.
          if (!isSunglasses) {
            var WO_COAT_LABEL = { 'ar': 'SCR Lenses', 'arplus': 'AR Lenses', 'blue': 'Bluelight Lenses' };
            var coatBracket = WO_COAT_LABEL[S.coats[0]];
            if (S.coats[0] === 'photo') {
              var photoCol = S.transitionColor === 'brown' ? 'Brown' : (S.transitionColor === 'gray' ? 'Gray' : '');
              coatBracket = (photoCol ? photoCol + ' — ' : '') + 'comes with AR coating';
            }
            props['_Coatings Detail'] = coat.name + (coatBracket ? ' (' + coatBracket + ')' : '');
          }
        }
      }
      // Thickness — delta over Standard tier
      if (tierObj) {
        props['Lens Package'] = tierObj.name;
        // Work-order-only bracket with the index numbers. Hidden from customer cart (underscore prefix).
        var WO_TIER_INDEX = { 'standard': '1.5 / 1.56', 'thin': '1.6', 'ultra': '1.67' };
        var tierIdx = WO_TIER_INDEX[S.tier];
        props['_Lens Package Detail'] = tierObj.name + (tierIdx ? ' (' + tierIdx + ')' : '');
        var ac2 = getActiveCoats();
        var coat2 = S.coats.length > 0 ? ac2.find(function (x) { return x.id === S.coats[0]; }) : null;
        var tierDelta = 0;
        if (coat2 && coat2.prices && S.tier) {
          var coatBase2 = coat2.prices['standard'] || 0;
          tierDelta = (coat2.prices[S.tier] || coatBase2) - coatBase2;
        }
        props['_Lens Price'] = tierDelta > 0 ? money(tierDelta) : '$0.00';
      }
    }

    // Momono deal — mark as final sale
    if (P.vendor && P.vendor.toLowerCase() === 'momono') {
      props['_Momono_Deal'] = 'true';
      props['_Final_Sale'] = 'true';
    }

    // PD Tool numbers (admin Sales Funnel → PD Tool): a browser that got a PD from the tool in the last 30 days marks
    // its glasses line with the Edmonton DAY it measured, so someone who measured, reopened the form (which clears
    // _PD Source) and then ordered still counts as a buyer, and only in ranges that hold that day. PD-MEASURE-TOOL
    var pdDay = pdUsedDay();
    if (pdDay) props['_PD Tool Used'] = pdDay;

    var vid = P.variantId;
    var colorInput = document.querySelector('input[name="color"]:checked');
    if (colorInput) {
      vid = colorInput.value;
    } else {
      var selectInput = document.querySelector('select[name="id"]');
      if (selectInput) vid = selectInput.value;
    }

    // Build cart items array — frame + lens add-on (if not frame-only)
    var cartItems = [{ id: parseInt(vid, 10), quantity: 1, properties: props }];

    if (S.type !== 'frame-only' && S.coats.length > 0 && S.tier) {
      // Look up the lens variant for the first selected coating + tier
      var coatingId = S.coats[0]; // primary coating
      var lensKey = coatingId + '_' + S.tier;
      var lensVariantId = LENS_VARIANT_MAP[lensKey];
      console.log('[Charmlio] Lens lookup:', lensKey, '->', lensVariantId, '| map keys:', Object.keys(LENS_VARIANT_MAP).join(','));
      if (lensVariantId) {
        var _ac5 = getActiveCoats();
        var coatObj = _ac5.find(function (x) { return x.id === coatingId; });
        var tierObj2 = TIERS.find(function (x) { return x.id === S.tier; });
        // Work-order-only technical label appended in brackets after the customer-facing coating name.
        // Lab/production team needs to know the exact lens type — the customer just sees the friendly name elsewhere.
        var WORK_ORDER_LABEL = {
          'ar':     'SCR Lenses',
          'arplus': 'AR Lenses',
          'blue':   'Bluelight Lenses'
        };
        var coatNameForOrder = coatObj ? coatObj.name : coatingId;
        var bracket = WORK_ORDER_LABEL[coatingId];
        if (coatingId === 'photo') {
          var colourName = S.transitionColor === 'brown' ? 'Brown' : (S.transitionColor === 'gray' ? 'Gray' : '');
          bracket = (colourName ? colourName + ' — ' : '') + 'comes with AR coating';
        }
        if (bracket) coatNameForOrder = coatNameForOrder + ' (' + bracket + ')';
        // Work-order-only tier index numbers (lab needs the exact index — customer-facing UI stays plain)
        var TIER_INDEX_LABEL = {
          'standard': '1.5 / 1.56',
          'thin':     '1.6',
          'ultra':    '1.67'
        };
        var tierNameForOrder = tierObj2 ? tierObj2.name : S.tier;
        var tierIdx = TIER_INDEX_LABEL[S.tier];
        if (tierIdx) tierNameForOrder = tierNameForOrder + ' (' + tierIdx + ')';
        var lensName = coatNameForOrder + ' / ' + tierNameForOrder;
        cartItems.push({
          id: lensVariantId,
          quantity: 1,
          properties: {
            '_charmlio_lens': 'true',
            '_charmlio_parent_vid': '' + vid,
            '_charmlio_pair_id': pairId,
            '_Lens Package': lensName
          }
        });
      }
    }

    var btn = $('#c-next');
    btn.innerHTML = '<span class="c-spin"></span> Adding...';
    btn.disabled = true;

    var rxFile = (S.method === 'upload' && S.file) ? S.file : null;
    // No underscore on the file property — Shopify's file→URL pipeline
    // requires a non-prefixed property name.
    postCart(cartItems, rxFile, 'Prescription File')
    .then(function (r) {
      return r.text().then(function(txt) {
        var data;
        try { data = JSON.parse(txt); } catch(e) { data = null; }
        if (!r.ok) throw new Error((data && data.description) || 'Cart error (status ' + r.status + ')');
        return data;
      });
    })
    .then(function () {
      fireGa4AddToCart(vid, 1);
      close();
      window.location.assign('/cart');
    })
    .catch(function (err) {
      console.error('Charmlio cart error:', err);
      alert('Could not add to cart: ' + err.message);
      btn.innerHTML = 'Add to Cart &mdash; ' + money(total());
      btn.disabled = false;
    });
  }

  function addClToCart() {
    var isToric = P.prescriptionType === 'toric';
    var bc = S.baseCurve || ((P.rxParams && P.rxParams.baseCurve && P.rxParams.baseCurve.values) ? P.rxParams.baseCurve.values[0] : '');
    var dia = (P.rxParams && P.rxParams.diameter && P.rxParams.diameter.values) ? P.rxParams.diameter.values[0] : '';
    var sameCheck = $('#c-cl-same');
    var isSameRx = sameCheck && sameCheck.checked;
    var qR = S.clBoxQty && S.clBoxQty.right != null ? S.clBoxQty.right : 1;
    var qL = S.clBoxQty && S.clBoxQty.left != null ? S.clBoxQty.left : 1;

    var baseProps = {
      '_charmlio': 'true',
      'Product Type': 'Contact Lens',
      '_Rx Method': S.clMethod === 'manual' ? 'Entered Manually' : 'File Uploaded'
    };
    if (S.clMethod === 'manual') {
      baseProps['_Right Eye (OD)'] = 'SPH: ' + S.clRx.right.sph + (isToric ? ', CYL: ' + S.clRx.right.cyl + ', AXIS: ' + S.clRx.right.axis + '°' : '');
      baseProps['_Left Eye (OS)'] = 'SPH: ' + S.clRx.left.sph + (isToric ? ', CYL: ' + S.clRx.left.cyl + ', AXIS: ' + S.clRx.left.axis + '°' : '');
    } else if (S.clFile) {
      // Actual file is attached via multipart in postCart() so Shopify
      // stores it and exposes a download URL on the order line.
    }

    baseProps['_Base Curve'] = bc ? (typeof bc === 'number' ? bc.toFixed(1) : bc) : '';
    baseProps['_Diameter'] = dia ? (typeof dia === 'number' ? dia.toFixed(1) : dia) : '';
    if (isSameRx) baseProps['Same Rx Both Eyes'] = 'Yes';
    baseProps['_Prescription Date'] = S.clRxDate || '';
    baseProps['_Prescribing Doctor'] = S.clRxDoctor || '';
    if (checkRxExpiry(S.clRxDate, 'cl')) baseProps['_Expired Rx'] = 'true';
    if (isSameRx) {
      baseProps['Boxes (both eyes)'] = '' + qR;
    } else {
      baseProps['Right Eye Boxes'] = '' + qR;
      baseProps['Left Eye Boxes'] = '' + qL;
    }
    // Optional insurance record on the contact-lens line.
    applyInsuranceProps(baseProps);

    var vid = P.variantId;
    var totalQty = isSameRx ? qR : (qR + qL);
    var btn = $('#c-next');
    btn.innerHTML = '<span class="c-spin"></span> Adding...';
    btn.disabled = true;

    var clRxFile = (S.clMethod === 'upload' && S.clFile) ? S.clFile : null;
    // No underscore on the file property — Shopify's file→URL pipeline
    // requires a non-prefixed property name.
    postCart([{ id: parseInt(vid, 10), quantity: totalQty, properties: baseProps }], clRxFile, 'Prescription File')
    .then(function (r) {
      return r.text().then(function (txt) {
        var data;
        try { data = JSON.parse(txt); } catch (e) { data = null; }
        if (!r.ok) throw new Error((data && data.description) || 'Cart error (status ' + r.status + ')');
        return data;
      });
    })
    .then(function () {
      fireGa4AddToCart(vid, totalQty);
      close();
      window.location.assign('/cart');
    })
    .catch(function (err) {
      console.error('Charmlio CL cart error:', err);
      alert('Could not add to cart: ' + err.message);
      btn.innerHTML = 'Add to Cart &mdash; ' + money(total());
      btn.disabled = false;
    });
  }

  // ── CYL helpers for per-SPH format: { cyl: { sph: [axis...] } } ──
  function getAvailableCyls(sphValue) {
    if (!P.rxParams || !P.rxParams.cylAxisMap) return [];
    var sph = parseFloat(sphValue);
    var sphKey = isNaN(sph) ? null : sph.toFixed(2);
    var map = P.rxParams.cylAxisMap;
    var result = [];
    for (var key in map) {
      var entry = map[key];
      if (sphKey === null) { result.push(parseFloat(key)); continue; }
      if (entry && typeof entry === 'object' && !Array.isArray(entry)) {
        if (entry[sphKey] && entry[sphKey].length > 0) result.push(parseFloat(key));
      }
    }
    return result.sort(function(a,b){return b-a;});
  }

  function getCylAxisValues(cylKey, sphValue) {
    if (!P.rxParams || !P.rxParams.cylAxisMap) return [];
    var entry = P.rxParams.cylAxisMap[cylKey];
    if (!entry) return [];
    if (typeof entry === 'object' && !Array.isArray(entry)) {
      var sphKey = parseFloat(sphValue).toFixed(2);
      return entry[sphKey] || [];
    }
    return [];
  }

  // ── Contact Lens RX Init ──
  function initClRx() {
    if (!P.rxParams) return;

    // ── CL Method tabs (manual / upload) with sliding indicator ──
    var clIndicator = $('#c-cl-indicator');
    $$('[data-cl-method]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('[data-cl-method]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        S.clMethod = btn.getAttribute('data-cl-method');
        if (clIndicator) clIndicator.classList.toggle('is-right', S.clMethod === 'upload');
        $$('[data-panel="cl-manual"]').forEach(function (p) { p.classList.toggle('is-active', S.clMethod === 'manual'); });
        $$('[data-panel="cl-upload"]').forEach(function (p) { p.classList.toggle('is-active', S.clMethod === 'upload'); });
        updateBtn(6);
      });
    });

    // ── CL Upload handling ──
    var clZone = $('#c-cl-upload-zone');
    var clInput = $('#c-cl-file-input');
    var clUpDone = $('#c-cl-upload-done');
    if (clZone && clInput) {
      clZone.addEventListener('click', function () { clInput.click(); });
      clZone.addEventListener('dragover', function (e) { e.preventDefault(); clZone.classList.add('is-drag'); });
      clZone.addEventListener('dragleave', function () { clZone.classList.remove('is-drag'); });
      clZone.addEventListener('drop', function (e) {
        e.preventDefault(); clZone.classList.remove('is-drag');
        if (e.dataTransfer.files.length) handleClFile(e.dataTransfer.files[0]);
      });
      clInput.addEventListener('change', function () { if (clInput.files.length) handleClFile(clInput.files[0]); });
    }
    var clRemove = $('#c-cl-file-remove');
    if (clRemove) {
      clRemove.addEventListener('click', function () {
        S.clFile = null; if (clInput) clInput.value = '';
        if (clZone) clZone.style.display = '';
        if (clUpDone) clUpDone.style.display = 'none';
        updateBtn(6);
      });
    }
    function handleClFile(f) {
      if (f.size > 10485760) { alert('File must be under 10MB'); return; }
      S.clFile = f;
      var fnEl = $('#c-cl-file-name'); if (fnEl) fnEl.textContent = f.name;
      if (clZone) clZone.style.display = 'none';
      if (clUpDone) clUpDone.style.display = '';
      updateBtn(6);
    }

    // ── BC / DIA display in cards ──
    var bcs = (P.rxParams.baseCurve && P.rxParams.baseCurve.values) ? P.rxParams.baseCurve.values : [];
    var dia = (P.rxParams.diameter && P.rxParams.diameter.values) ? P.rxParams.diameter.values[0] : '';
    var bcDisplayEls = $$('#c-cl-bc-display-r, #c-cl-bc-display-l, #c-cl-same-bc');
    var diaDisplayEls = $$('#c-cl-dia-display-r, #c-cl-dia-display-l, #c-cl-same-dia');

    function setBcDisplays() {
      var bcStr = S.baseCurve ? (typeof S.baseCurve === 'number' ? S.baseCurve.toFixed(1) : S.baseCurve) + ' mm' : '—';
      bcDisplayEls.forEach(function (el) { if (el) el.textContent = bcStr; });
    }
    function setDiaDisplays() {
      var diaStr = dia ? (typeof dia === 'number' ? dia.toFixed(1) : dia) + ' mm' : '—';
      diaDisplayEls.forEach(function (el) { if (el) el.textContent = diaStr; });
    }

    if (bcs.length > 1) {
      // Multiple BCs — show inline <select> dropdowns instead of static display
      var bcSelects = $$('#c-cl-bc-select-r, #c-cl-bc-select-l, #c-cl-bc-select-same');
      bcSelects.forEach(function (sel) {
        if (!sel) return;
        // Hide the static display, show the select
        var fixed = sel.previousElementSibling;
        if (fixed && fixed.classList.contains('cl-field-fixed')) fixed.style.display = 'none';
        sel.style.display = '';
        // Populate options
        sel.innerHTML = '<option value="" disabled selected>Select</option>';
        bcs.forEach(function (bc) {
          var opt = document.createElement('option');
          opt.value = bc;
          opt.textContent = (typeof bc === 'number' ? bc.toFixed(1) : bc) + ' mm';
          sel.appendChild(opt);
        });
        sel.onchange = function () {
          S.baseCurve = parseFloat(sel.value);
          // Sync all BC selects to same value
          bcSelects.forEach(function (s) { if (s && s !== sel) s.value = sel.value; });
          setBcDisplays();
          updateBtn(6);
        };
      });
    } else if (bcs.length === 1) {
      S.baseCurve = bcs[0];
    }
    setBcDisplays();
    setDiaDisplays();

    // Get SPH values (handle old min/max/step format)
    var sphVals = [];
    if (P.rxParams.sph && P.rxParams.sph.values && P.rxParams.sph.values.length > 0) {
      sphVals = P.rxParams.sph.values;
    } else if (P.rxParams.sph && P.rxParams.sph.min !== undefined) {
      for (var v = P.rxParams.sph.min; v <= P.rxParams.sph.max + 0.001; v += (P.rxParams.sph.step || 0.25)) {
        sphVals.push(Math.round(v * 100) / 100);
      }
    }

    // Populate SPH selects
    var rSph = $('#c-cl-r-sph');
    var lSph = $('#c-cl-l-sph');
    if (rSph && lSph) {
      fill(rSph, sphVals, { fmt: true, ph: '\u2014' });
      fill(lSph, sphVals, { fmt: true, ph: '\u2014' });
      rSph.onchange = function () {
        S.clRx.right.sph = rSph.value;
        if (isToric && rCyl) {
          var avail = getAvailableCyls(rSph.value);
          var oldCyl = S.clRx.right.cyl;
          fill(rCyl, avail, { fmt: true, ph: '\u2014' });
          if (oldCyl && avail.indexOf(parseFloat(oldCyl)) >= 0) {
            rCyl.value = oldCyl;
            // Refresh axis since different SPH may have different axis availability
            if (rAxis) {
              var oldAxis = S.clRx.right.axis;
              var axVals = getCylAxisValues(parseFloat(oldCyl).toFixed(2), rSph.value);
              fill(rAxis, axVals, { ph: '\u2014' });
              if (oldAxis && axVals.indexOf(parseInt(oldAxis)) >= 0) { rAxis.value = oldAxis; }
              else { S.clRx.right.axis = ''; }
            }
          } else {
            S.clRx.right.cyl = ''; S.clRx.right.axis = '';
            rAxis.innerHTML = '<option value="">\u2014</option>';
          }
        }
        clSyncSame(); updateBtn(6);
      };
      lSph.onchange = function () {
        S.clRx.left.sph = lSph.value;
        if (isToric && lCyl) {
          var avail = getAvailableCyls(lSph.value);
          var oldCyl = S.clRx.left.cyl;
          fill(lCyl, avail, { fmt: true, ph: '\u2014' });
          if (oldCyl && avail.indexOf(parseFloat(oldCyl)) >= 0) {
            lCyl.value = oldCyl;
            // Refresh axis since different SPH may have different axis availability
            if (lAxis) {
              var oldAxis = S.clRx.left.axis;
              var axVals = getCylAxisValues(parseFloat(oldCyl).toFixed(2), lSph.value);
              fill(lAxis, axVals, { ph: '\u2014' });
              if (oldAxis && axVals.indexOf(parseInt(oldAxis)) >= 0) { lAxis.value = oldAxis; }
              else { S.clRx.left.axis = ''; }
            }
          } else {
            S.clRx.left.cyl = ''; S.clRx.left.axis = '';
            lAxis.innerHTML = '<option value="">\u2014</option>';
          }
        }
        updateBtn(6);
      };
    }

    // Show/hide toric columns + fix tfoot colspan
    var isToric = P.prescriptionType === 'toric';
    $$('.c-cl-toric-col').forEach(function (el) { el.style.display = isToric ? '' : 'none'; });
    var rCyl = $('#c-cl-r-cyl'), rAxis = $('#c-cl-r-axis');
    var lCyl = $('#c-cl-l-cyl'), lAxis = $('#c-cl-l-axis');

    if (isToric && P.rxParams.cylAxisMap) {
      var cylKeys = getAvailableCyls(NaN); // no SPH selected yet → show all

      if (rCyl && lCyl) {
        fill(rCyl, cylKeys, { fmt: true, ph: '\u2014' });
        fill(lCyl, cylKeys, { fmt: true, ph: '\u2014' });
        rAxis.innerHTML = '<option value="">\u2014</option>';
        lAxis.innerHTML = '<option value="">\u2014</option>';

        rCyl.onchange = function () {
          S.clRx.right.cyl = rCyl.value;
          var axisVals = getCylAxisValues(parseFloat(rCyl.value).toFixed(2), S.clRx.right.sph);
          fill(rAxis, axisVals, { ph: '\u2014' });
          S.clRx.right.axis = '';
          clSyncSame();
          updateBtn(6);
        };
        rAxis.onchange = function () { S.clRx.right.axis = rAxis.value; clSyncSame(); updateBtn(6); };

        lCyl.onchange = function () {
          S.clRx.left.cyl = lCyl.value;
          var axisVals = getCylAxisValues(parseFloat(lCyl.value).toFixed(2), S.clRx.left.sph);
          fill(lAxis, axisVals, { ph: '\u2014' });
          S.clRx.left.axis = '';
          updateBtn(6);
        };
        lAxis.onchange = function () { S.clRx.left.axis = lAxis.value; updateBtn(6); };
      }
    } else if (isToric && P.rxParams.cyl && P.rxParams.cyl.values) {
      // Fallback for old cyl+axis format
      var cylVals = P.rxParams.cyl.values.slice().sort(function(a,b){return b-a;});
      var axisVals = (P.rxParams.axis && P.rxParams.axis.values) || [];
      var rCyl = $('#c-cl-r-cyl'), rAxis = $('#c-cl-r-axis');
      var lCyl = $('#c-cl-l-cyl'), lAxis = $('#c-cl-l-axis');
      if (rCyl && lCyl) {
        fill(rCyl, cylVals, { fmt: true, ph: '\u2014' });
        fill(lCyl, cylVals, { fmt: true, ph: '\u2014' });
        fill(rAxis, axisVals, { ph: '\u2014' });
        fill(lAxis, axisVals, { ph: '\u2014' });
        rCyl.onchange = function () { S.clRx.right.cyl = rCyl.value; clSyncSame(); updateBtn(6); };
        rAxis.onchange = function () { S.clRx.right.axis = rAxis.value; clSyncSame(); updateBtn(6); };
        lCyl.onchange = function () { S.clRx.left.cyl = lCyl.value; updateBtn(6); };
        lAxis.onchange = function () { S.clRx.left.axis = lAxis.value; updateBtn(6); };
      }
    }

    // "Same prescription" checkbox + compact form
    var sameCheck = $('#c-cl-same');
    var separateForm = $('#c-cl-separate-form');
    var sameForm = $('#c-cl-same-form');
    var sameSph = $('#c-cl-same-sph');
    var sameCyl = $('#c-cl-same-cyl');
    var sameAxis = $('#c-cl-same-axis');
    var sameBc = $('#c-cl-same-bc');
    var sameDia = $('#c-cl-same-dia');

    // Populate same-form SPH dropdown (mirror of right-eye SPH)
    if (sameSph && sphVals) {
      fill(sameSph, sphVals, { fmt: true, ph: '\u2014' });
      sameSph.onchange = function () {
        S.clRx.right.sph = S.clRx.left.sph = sameSph.value;
        var rSph2 = $('#c-cl-r-sph'), lSph2 = $('#c-cl-l-sph');
        if (rSph2) rSph2.value = sameSph.value;
        if (lSph2) lSph2.value = sameSph.value;
        // Re-filter CYL for same-form when SPH changes
        if (isToric && sameCyl) {
          var avail = getAvailableCyls(sameSph.value);
          var oldCyl = S.clRx.right.cyl;
          fill(sameCyl, avail, { fmt: true, ph: '\u2014' });
          if (oldCyl && avail.indexOf(parseFloat(oldCyl)) >= 0) {
            sameCyl.value = oldCyl;
            // Refresh axis for new SPH
            if (sameAxis) {
              var oldAxis = S.clRx.right.axis;
              var axVals = getCylAxisValues(parseFloat(oldCyl).toFixed(2), sameSph.value);
              fill(sameAxis, axVals, { ph: '\u2014' });
              if (oldAxis && axVals.indexOf(parseInt(oldAxis)) >= 0) { sameAxis.value = oldAxis; S.clRx.right.axis = S.clRx.left.axis = oldAxis; }
              else { S.clRx.right.axis = S.clRx.left.axis = ''; }
            }
          } else {
            S.clRx.right.cyl = S.clRx.left.cyl = '';
            S.clRx.right.axis = S.clRx.left.axis = '';
            sameAxis.innerHTML = '<option value="">\u2014</option>';
          }
        }
        updateBtn(6);
      };
    }

    // Populate same-form toric fields
    if (isToric && sameCyl && sameAxis) {
      $$('.c-cl-same-toric').forEach(function (el) { el.style.display = ''; });
      var cylNums = getAvailableCyls(NaN); // no SPH yet → all CYLs
      fill(sameCyl, cylNums, { fmt: true, ph: '\u2014' });
      sameAxis.innerHTML = '<option value="">\u2014</option>';
      sameCyl.onchange = function () {
        S.clRx.right.cyl = S.clRx.left.cyl = sameCyl.value;
        var axVals = getCylAxisValues(parseFloat(sameCyl.value).toFixed(2), S.clRx.right.sph);
        fill(sameAxis, axVals, { ph: '\u2014' });
        S.clRx.right.axis = S.clRx.left.axis = '';
        // Sync to hidden OD/OS fields
        var rCyl2 = $('#c-cl-r-cyl'), lCyl2 = $('#c-cl-l-cyl');
        if (rCyl2) rCyl2.value = sameCyl.value;
        if (lCyl2) lCyl2.value = sameCyl.value;
        updateBtn(6);
      };
      sameAxis.onchange = function () {
        S.clRx.right.axis = S.clRx.left.axis = sameAxis.value;
        var rAxis2 = $('#c-cl-r-axis'), lAxis2 = $('#c-cl-l-axis');
        if (rAxis2) rAxis2.value = sameAxis.value;
        if (lAxis2) lAxis2.value = sameAxis.value;
        updateBtn(6);
      };
    }

    // Fill same-form BC/DIA static values
    function updateSameFormInfo() {
      setBcDisplays();
      setDiaDisplays();
    }
    updateSameFormInfo();

    // Quantity pills — per-eye
    $$('.cl-qty-pills').forEach(function (group) {
      var eye = group.getAttribute('data-eye');
      $$('.cl-qty-pill', group).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var qty = parseInt(this.getAttribute('data-qty'), 10);
          if (eye === 'both') {
            S.clBoxQty.right = qty;
            S.clBoxQty.left = qty;
          } else if (eye === 'upload-right') {
            S.clBoxQty.right = qty;
          } else if (eye === 'upload-left') {
            S.clBoxQty.left = qty;
          } else {
            var stateKey = (eye === 'right') ? 'right' : 'left';
            S.clBoxQty[stateKey] = qty;
          }
          $$('.cl-qty-pill', group).forEach(function (b) {
            b.classList.toggle('is-active', b.getAttribute('data-qty') === '' + qty);
          });
          // Sync corresponding dropdown
          var qtySelect = group.parentElement.querySelector('.cl-qty-select');
          if (qtySelect) qtySelect.value = '' + qty;
          updateTotal();
          updateClQtyHints();
        });
      });
    });

    // Quantity dropdowns (mobile) — sync with pills
    $$('.cl-qty-select').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var eye = this.getAttribute('data-eye');
        var qty = parseInt(this.value, 10);
        if (eye === 'both') {
          S.clBoxQty.right = qty;
          S.clBoxQty.left = qty;
        } else {
          S.clBoxQty[eye] = qty;
        }
        var pillGroup = document.querySelector('.cl-qty-pills[data-eye="' + eye + '"]');
        if (pillGroup) {
          $$('.cl-qty-pill', pillGroup).forEach(function (b) {
            b.classList.toggle('is-active', b.getAttribute('data-qty') === '' + qty);
          });
        }
        updateTotal();
        updateClQtyHints();
      });
    });

    function updateClQtyHints() {
      var included = P.whatsIncluded || '';
      var qR = S.clBoxQty.right != null ? S.clBoxQty.right : 1;
      var qL = S.clBoxQty.left != null ? S.clBoxQty.left : 1;
      var hintR = $('#c-cl-hint-r');
      var hintL = $('#c-cl-hint-l');
      var hintS = $('#c-cl-hint-same');
      var hintUR = $('#c-cl-hint-upload-r');
      var hintUL = $('#c-cl-hint-upload-l');
      if (included) {
        if (hintR) hintR.textContent = qR + ' box' + (qR > 1 ? 'es' : '') + ' · ' + included;
        if (hintL) hintL.textContent = qL + ' box' + (qL > 1 ? 'es' : '') + ' · ' + included;
        if (hintS) hintS.textContent = qR + ' box' + (qR > 1 ? 'es' : '') + ' for both eyes · ' + included;
        if (hintUR) hintUR.textContent = qR === 0 ? 'None' : qR + ' box' + (qR > 1 ? 'es' : '') + ' · ' + included;
        if (hintUL) hintUL.textContent = qL === 0 ? 'None' : qL + ' box' + (qL > 1 ? 'es' : '') + ' · ' + included;
      }
    }
    updateClQtyHints();

    // Toggle switch for same-rx
    var toggleTrack = $('#c-cl-same-toggle');
    if (toggleTrack && sameCheck) {
      sameCheck.checked = false;
      toggleTrack.addEventListener('click', function () {
        var nowChecked = sameCheck.checked;
        sameCheck.checked = !nowChecked;
        toggleTrack.setAttribute('aria-checked', !nowChecked ? 'true' : 'false');
        sameCheck.dispatchEvent(new Event('change'));
      });
      sameCheck.onchange = function () {
        var checked = sameCheck.checked;
        toggleTrack.setAttribute('aria-checked', checked ? 'true' : 'false');
        if (separateForm) separateForm.style.display = checked ? 'none' : '';
        if (sameForm) sameForm.style.display = checked ? '' : 'none';
        if (checked) {
          if (sameSph && S.clRx.right.sph) sameSph.value = S.clRx.right.sph;
          if (sameCyl && S.clRx.right.cyl) sameCyl.value = S.clRx.right.cyl;
          if (sameAxis && S.clRx.right.axis) sameAxis.value = S.clRx.right.axis;
          clSyncSame();
          updateSameFormInfo();
          // Sync unified "both" qty pills + dropdown to right-eye value
          var bothQty = S.clBoxQty.right || 1;
          S.clBoxQty.left = bothQty;
          var bothGroup = document.querySelector('.cl-qty-pills[data-eye="both"]');
          if (bothGroup) {
            $$('.cl-qty-pill', bothGroup).forEach(function (b) {
              b.classList.toggle('is-active', b.getAttribute('data-qty') === '' + bothQty);
            });
          }
          var selR = document.querySelector('.cl-qty-select[data-eye="right"]');
          if (selR) selR.value = '' + bothQty;
          var selL = document.querySelector('.cl-qty-select[data-eye="left"]');
          if (selL) selL.value = '' + bothQty;
        }
        updateTotal();
        updateBtn(6);
      };
    }

    // ── CL Verification fields ──
    var clConfEl = $('#c-cl-confirm');
    initDatePicker('c-cl-rx-date-picker', 'c-cl-rx-date', function (dateStr) {
      S.clRxDate = dateStr;
      expiryAcknowledged.cl = false;
      if (checkRxExpiry(dateStr, 'cl')) showExpiryPopup('cl');
      updateBtn(6);
    });
    bindDoctorField(true);
    if (clConfEl) clConfEl.addEventListener('change', function () { S.clConfirm = this.checked; updateBtn(6); });
  }

  function clSyncSame() {
    var sameCheck = $('#c-cl-same');
    if (!sameCheck || !sameCheck.checked) return;
    // Copy right eye values to left eye
    S.clRx.left.sph = S.clRx.right.sph;
    var lSph = $('#c-cl-l-sph');
    if (lSph) lSph.value = S.clRx.right.sph;
    if (P.prescriptionType === 'toric') {
      S.clRx.left.cyl = S.clRx.right.cyl;
      S.clRx.left.axis = S.clRx.right.axis;
      var lCyl = $('#c-cl-l-cyl'), lAxis = $('#c-cl-l-axis');
      if (lCyl) lCyl.value = S.clRx.right.cyl;
      if (lAxis && S.clRx.right.cyl && P.rxParams.cylAxisMap) {
        var axVals = getCylAxisValues(parseFloat(S.clRx.right.cyl).toFixed(2), S.clRx.right.sph);
        fill(lAxis, axVals, { ph: '\u2014' });
      }
      if (lAxis) lAxis.value = S.clRx.right.axis;
    }
    updateBtn(6);
  }

  function initBaseCurve() {
    var wrap = $('#c-basecurves');
    if (!wrap || !P.rxParams || !P.rxParams.baseCurve) return;
    var bcs = P.rxParams.baseCurve.values || [];
    if (bcs.length <= 1) return; // Single BC — auto-selected, step skipped
    var h = '';
    bcs.forEach(function (bc) {
      h += '<div class="c-card c-card-bc" data-bc="' + bc + '">';
      h += '<div class="c-card-radio"><div class="c-radio"></div></div>';
      h += '<div class="c-card-body">';
      h += '<div class="c-card-name">BC ' + bc.toFixed(1) + '</div>';
      h += '<div class="c-card-desc">Base Curve ' + bc.toFixed(1) + ' mm</div>';
      h += '</div></div>';
    });
    wrap.innerHTML = h;
    $$('.c-card-bc', wrap).forEach(function (card) {
      card.addEventListener('click', function () {
        $$('.c-card-bc', wrap).forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        S.baseCurve = parseFloat(card.getAttribute('data-bc'));
        updateBtn(7);
      });
    });
  }

  // ── Bind internal charmlio UI ──
  function bindInternal() {
    $('#c-close').addEventListener('click', close);
    $('#c-mob-close').addEventListener('click', close);
    $('#c-back').addEventListener('click', prev);
    $('#c-mob-back').addEventListener('click', prev);
    $('#c-next').addEventListener('click', next);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      // While the insurance notice popup is up, Escape only dismisses the popup
      // (declineInsPopup) — it must not close the configurator and wipe the config.
      var ip = insPopupEl();
      if (ip && ip.classList.contains('is-open')) return;
      close();
    });

    // Mobile breakdown chevron toggle
    var mobPriceBtn = $('#c-mob-price');
    if (mobPriceBtn) {
      mobPriceBtn.addEventListener('click', function () {
        var bd = $('#c-mob-breakdown');
        if (!bd || !bd.classList.contains('has-content')) return;
        var expanded = mobPriceBtn.getAttribute('aria-expanded') === 'true';
        mobPriceBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        bd.classList.toggle('is-open', !expanded);
      });
    }

    // Hide chevron initially
    var chevron = document.querySelector('.c-mob-chevron');
    if (chevron) chevron.style.display = 'none';

    // Mobile product image lightbox
    initLightbox();
  }

  function initLightbox() {
    // Create lightbox if not already in DOM
    var lb = document.getElementById('c-lightbox');
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'c-lightbox';
      lb.id = 'c-lightbox';
      lb.innerHTML = '<button class="c-lightbox-close" id="c-lightbox-close">' +
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button><img class="c-lightbox-img" id="c-lightbox-img" src="" alt="">';
      document.body.appendChild(lb);
    }

    var lbImg = $('#c-lightbox-img');
    var lbClose = $('#c-lightbox-close');

    function openLb(src) {
      if (!src) return;
      lbImg.src = src;
      lb.classList.add('is-open');
    }
    function closeLb() { lb.classList.remove('is-open'); }

    // Mobile: tap the product bar (but not the price button)
    var mobProduct = $('.c-mob-product');
    if (mobProduct) {
      mobProduct.style.cursor = 'pointer';
      mobProduct.addEventListener('click', function (e) {
        // Don't open lightbox if user tapped the price/breakdown button
        if (e.target.closest('#c-mob-price')) return;
        var fullImg = $('#c-img');
        var mobImg = $('#c-mob-img');
        openLb(fullImg && fullImg.src ? fullImg.src : (mobImg ? mobImg.src : ''));
      });
    }

    // Desktop: tap the showcase image
    var showcaseImg = $('#c-img');
    if (showcaseImg) {
      showcaseImg.style.cursor = 'pointer';
      showcaseImg.addEventListener('click', function () { openLb(showcaseImg.src); });
    }

    lbClose.addEventListener('click', closeLb);
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // ===== PD-MEASURE-TOOL =====
  // ── Measure my PD: phone camera measurement, desktop QR hand off, autofill ──
  // Spec: charmlio-backend/docs/pd-tool/design/design-spec.md (D0 to D6, C1 to C3).
  // Desktop (> 768px): modal with a QR code; the phone measures on
  // PD_BASE + '/pd/<token>' and the relay (PD_BASE + '/api/pd/*') hands the
  // numbers back here within about a second. Phone (<= 768px): the same
  // measuring screens mount inline on top of the configurator (no QR).
  // The result always fills the two-number fields through their own change
  // listeners, so S.pd updates exactly as a hand-typed dual PD would.
  // the PD tool's own address (owner 2026-11-04: letspd.charmoptical.ca, same backend project); localhost stays local
  var PD_BASE = window.CharmlioPdBase || (CHARMLIO_API_BASE.indexOf('localhost') >= 0 ? CHARMLIO_API_BASE : 'https://letspd.charmoptical.ca');
  var PD_QR_LIB = 'https://cdn.jsdelivr.net/npm/qrcode-generator@1.4.4/qrcode.js';
  var PD_T = {
    trigger: 'Measure my PD', helperMobile: 'Not sure? Use your front camera.', measured: 'PD measured',
    eyebrow: 'Measure my PD', title: "Use your phone's camera",
    sub: '',
    privacy: 'Your picture never leaves your phone.',
    manual: "I'll enter it myself", close: 'Close',
    step1: 'Open the camera on your phone', step1Sub: '', step2: 'Point it at this code', step2Sub: '',
    qrAlt: 'QR code that opens the PD tool on your phone', waitStatus: 'Waiting for your phone',
    connTile: 'Connected', connTitle: 'Now follow your phone', connBody: 'Your PD will appear here by itself.', connStatus: 'Connected to your phone',
    measTile: 'Measuring', measTitle: 'Measuring now', measBody: 'Keep looking at your phone.', measBar: 'Holding steady', measStatus: 'Measuring on your phone',
    expTile: 'Code expired', expTitle: 'This code expired', expBody: 'Codes only last a short time. Your order is safe.', expCta: 'Get a new code', expStatus: 'Code expired',
    lostTitle: 'Your phone disconnected', lostBody: 'Open the page on your phone again, or get a new code.',
    oldTitle: "That phone can't run the camera tool", oldTile: 'Not supported', oldStatus: 'Phone not supported', oldBody: 'Try another phone with a new code, or enter your PD yourself.',
    filledTitle: 'PD added from your phone', filledSub: '', retake: 'Retake',
    srConnected: 'Phone connected.', srMeasuring: 'Measuring on your phone.', srAdded: 'PD added. Right {right}, left {left}.', srExpired: 'This code expired.'
  };
  var pd = { ticketRun: null, session: null, polling: false, modal: null, live: null, lastFocus: null, applying: false, inline: null, ui: null, cssLoaded: false, qrReady: null };

  // Phones AND touch tablets measure on themselves (an iPad has a front camera; it should not be told to scan a QR with a phone).
  function pdIsPhone() { return window.matchMedia('(max-width: 768px)').matches || (window.matchMedia('(pointer: coarse)').matches && navigator.maxTouchPoints > 0); }
  // Minimum device, by capability (mirrors checkSupport() in the phone page): camera API, WebAssembly SIMD
  // (iOS 16.4+, current Chrome / Samsung Internet), modern DOM and CSS. In-app browsers still get the button:
  // it leads to the "open in Safari or Chrome" screen, which is the useful next step there.
  function pdInApp() { return /Instagram|FBAN|FBAV|FB_IAB|Messenger|Threads|TikTok|musical_ly|Snapchat|LinkedInApp|MicroMessenger/i.test(navigator.userAgent || ''); }
  function pdCanMeasureHere() {
    if (pdInApp()) return true;
    try {
      if (!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== 'function') return false;
      if (!window.WebAssembly || !WebAssembly.validate(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 5, 1, 96, 0, 1, 123, 3, 2, 1, 0, 10, 10, 1, 8, 0, 65, 0, 253, 15, 253, 98, 11]))) return false;
      if (!Element.prototype.replaceChildren) return false;
      if (window.CSS && CSS.supports && !CSS.supports('container-type', 'inline-size')) return false;
      return true;
    } catch (e) { return false; }
  }
  function pdFmt(v) { return v % 1 !== 0 ? v.toFixed(1) : '' + v; }
  function pdFmt1(v) { return (Math.round(v * 2) / 2).toFixed(1); }
  function pdEl(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html !== undefined) e.innerHTML = html; return e; }
  function pdAnnounce(msg) { if (!pd.live) return; pd.live.textContent = ''; setTimeout(function () { pd.live.textContent = msg; }, 30); }
  function pdApi(name, body, method) {
    method = method || 'POST';
    return fetch(PD_BASE + '/api/pd/' + name, { method: method, headers: { 'Content-Type': 'application/json' }, body: method === 'POST' ? JSON.stringify(body || {}) : undefined, cache: 'no-store' })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { if (!r.ok) { var e = new Error(d.error || 'http_' + r.status); e.code = d.error || 'http_' + r.status; e.status = r.status; throw e; } return d; }); });
  }
  var PD_SVG = {
    lock: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>',
    close: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    phone: '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="2" width="14" height="20" rx="2"/><path d="M12 18h.01"/></svg>',
    check: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>',
    checkCircle: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><polyline points="8 12 11 15 16 9"/></svg>',
    clock: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    refresh: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 0 1 15.5-6.3"/><path d="M21 4v5h-5"/><path d="M21 12a9 9 0 0 1-15.5 6.3"/><path d="M3 20v-5h5"/></svg>'
  };

  // ===== PD-SHEET (2026-11-04): the original QR modal, polished, Apple style. Replaces the ticket.
  // Same entry points as before (pdTicketShell / pdTicketApply / pdTicketResult, PD_TICKET_TIMING) so
  // openPdModal, pdSetModal, pdPoll and closePdModal are unchanged. Classic script: no modules.
  var PD_TICKET_TIMING = {
    swap: 280,         // a state's content cross-fades in
    hold: 2000,        // result: the numbers stay on screen this long before they fly into the fields (owner: 2 seconds)
    fly: 760,          // each number's flight to its field
    stagger: 90,       // the left number leaves this much after the right one
    land: 220,         // a landed number lingers over its field while the field flashes
    reducedHold: 1600  // reduced motion: no flight, just a hold, then fill and close
  };
  var PD_SHEET_T = {
    close: 'Close', manual: "I'll enter it myself", privacy: 'Your picture never leaves your phone.',
    waitTitle: 'Measure your PD', waitSub: "Scan the code with your phone's camera.",
    step1: 'Open your camera', step2: 'Point it at the code', qrAlt: 'QR code that opens the PD tool on your phone', waitStatus: 'Waiting for your phone',
    connTitle: 'Phone connected', connSub: 'Follow the steps on your phone.', connStatus: 'Connected',
    measTitle: 'Measuring', measSub: 'Keep looking at your phone.', measStatus: 'Measuring on your phone',
    resTitle: 'Your PD', resSub: "We'll fill it in for you.", resStatus: 'Added to your order', right: 'Right', left: 'Left', unit: 'mm',
    expTitle: 'This code expired', expSub: 'Codes only last a short time. Your order is safe.',
    lostTitle: 'Your phone disconnected', lostSub: 'Open the page on your phone again, or get a new code.',
    oldTitle: "That phone can't run the camera tool", oldSub: 'Try another phone with a new code, or enter your PD yourself.',
    newCode: 'Get a new code', tryAgain: 'Try again',
    failTitle: "We couldn't make your code", failSub: 'Wait a minute, then try again. Or enter your PD yourself.', srFail: "We couldn't make your code.",
    srConnected: 'Phone connected.', srMeasuring: 'Measuring on your phone.', srResult: 'Your PD is {total}. Right {right}, left {left}. Added to your order.',
    srExpired: 'This code expired.', srLost: 'Your phone disconnected.', srOld: "That phone can't run the camera tool."
  };
  var PD_SH_ICON = (function () {
    var s = function (d, w) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (w || 1.8) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + d + '</svg>'; };
    return {
      close: s('<path d="M17 7L7 17M7 7l10 10"/>', 2.2),
      lock: s('<rect x="5" y="11" width="14" height="9" rx="2.5"/><path d="M8.5 11V8a3.5 3.5 0 0 1 7 0v3"/>'),
      phone: s('<rect x="6.5" y="2.5" width="11" height="19" rx="3"/><path d="M10.5 18.5h3"/>'),
      phoneOff: s('<rect x="6.5" y="2.5" width="11" height="19" rx="3"/><path d="M10.5 18.5h3"/><path d="M3 3l18 18"/>'),
      check: s('<path d="M5 12.5l4.5 4.5L19 7.5"/>', 2.6),
      checkC: s('<circle cx="12" cy="12" r="9"/><path d="M8 12.3l2.8 2.8L16.2 9.6"/>', 2),
      clock: s('<circle cx="12" cy="12" r="9"/><path d="M12 7.5V12l3 2"/>'),
      noConn: s('<path d="M2.5 9a14 14 0 0 1 4.3-2.6M9.8 5.3A14 14 0 0 1 21.5 9M5.6 12.6a9 9 0 0 1 3-1.8M15 11.1a9 9 0 0 1 3.4 1.5M8.8 16a4.5 4.5 0 0 1 6.4 0M12 19.5h.01"/><path d="M3 3l18 18"/>'),
      refresh: s('<path d="M20 12a8 8 0 1 1-2.3-5.6"/><path d="M20 4.5v4.5h-4.5"/>', 2)
    };
  })();
  function pdShEsc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function pdTicketShell() {
    var T = PD_SHEET_T, I = PD_SH_ICON;
    return '' +
      '<div class="c-expiry-box pd-modal-box pd-sh" data-state="waiting" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="pd-modal-title" aria-describedby="pd-sh-sub">' +
        '<button type="button" class="c-close pd-modal-close pd-sh-close" aria-label="' + T.close + '">' + I.close + '</button>' +
        '<h3 class="pd-sh-title" id="pd-modal-title">' + T.waitTitle + '</h3>' +
        '<p class="pd-sh-sub" id="pd-sh-sub">' + T.waitSub + '</p>' +
        '<div class="pd-sh-stage"><div class="pd-sh-card" id="pd-tile"></div></div>' +
        '<div class="pd-sh-below" id="pd-col"></div>' +
        '<div class="pd-sh-status"><span class="pd-sh-pill"><i class="pd-status-dot pd-status-dot--waiting" id="pd-status-dot"></i><span id="pd-status-text">' + T.waitStatus + '</span></span></div>' +
        '<div class="pd-sh-foot">' +
          '<span class="pd-sh-privacy">' + I.lock + '<span>' + T.privacy + '</span></span>' +
          '<button type="button" class="c-skip pd-manual pd-sh-manual" id="pd-manual">' + T.manual + '</button>' +
        '</div>' +
        '<div class="pd-sr" aria-live="polite" role="status" id="pd-live"></div>' +
      '</div>';
  }

  function pdShRender(state, data) {
    var T = PD_SHEET_T, I = PD_SH_ICON;
    var btn = '<button type="button" class="c-btn-primary pd-newcode pd-sh-btn" id="pd-newcode">' + I.refresh + '<span>' + T.newCode + '</span></button>';
    var qr = function (dead) { return '<div class="pd-sh-qr' + (dead ? ' is-dead' : '') + '"' + (dead ? ' aria-hidden="true"' : ' role="img" aria-label="' + T.qrAlt + '"') + '>' + (data.svg || '') + '</div>'; };
    var glyph = function (icon, badge, cls) { return '<div class="pd-sh-glyph' + (cls || '') + '">' + icon + (badge ? '<b>' + badge + '</b>' : '') + '</div>'; };
    switch (state) {
      case 'waiting': return { title: T.waitTitle, sub: T.waitSub, card: qr(false), below: '<ol class="pd-sh-steps"><li><span>1</span>' + T.step1 + '</li><li><span>2</span>' + T.step2 + '</li></ol>', status: T.waitStatus, sr: '' };
      case 'connected': return { title: T.connTitle, sub: T.connSub, card: glyph(I.phone, I.check, ' pd-sh-glyph--ok'), below: '', status: T.connStatus, sr: T.srConnected };
      case 'measuring': return { title: T.measTitle, sub: T.measSub, card: '<div class="pd-sh-spin" aria-hidden="true"><svg viewBox="0 0 120 120"><circle class="pd-sh-spin-track" cx="60" cy="60" r="54"/><circle class="pd-sh-spin-arc" cx="60" cy="60" r="54"/></svg><div class="pd-sh-meas"><i></i><b></b><i></i></div></div>', below: '', status: T.measStatus, sr: T.srMeasuring };
      case 'result': return {
        title: T.resTitle, sub: T.resSub, below: '', status: T.resStatus,
        card: '<div class="pd-sh-result"><div class="pd-sh-total"><span class="pd-sh-total-n">' + pdShEsc(data.total) + '</span><span class="pd-sh-total-u">' + T.unit + '</span></div>' +
          '<div class="pd-sh-eyes"><span class="pd-sh-eye"><em>' + T.right + '</em><strong class="pd-sh-val-r">' + pdShEsc(data.right) + '</strong></span><span class="pd-sh-sep" aria-hidden="true"></span>' +
          '<span class="pd-sh-eye"><em>' + T.left + '</em><strong class="pd-sh-val-l">' + pdShEsc(data.left) + '</strong></span></div></div>',
        sr: T.srResult.replace('{total}', data.total).replace('{right}', data.right).replace('{left}', data.left)
      };
      case 'expired': return { title: T.expTitle, sub: T.expSub, card: (data.svg ? qr(true) : '') + '<div class="pd-sh-over">' + I.clock + '</div>', below: btn, status: '', sr: T.srExpired };
      case 'lost': return { title: T.lostTitle, sub: T.lostSub, card: (data.svg ? qr(true) : '') + '<div class="pd-sh-over">' + I.noConn + '</div>', below: btn, status: '', sr: T.srLost };
      case 'failed': return { title: T.failTitle, sub: T.failSub, card: '<div class="pd-sh-over">' + I.refresh + '</div>', below: btn.replace(T.newCode, T.tryAgain), status: '', sr: T.srFail };
      case 'phone_old': return { title: T.oldTitle, sub: T.oldSub, card: glyph(I.phoneOff, '', ' pd-sh-glyph--off'), below: btn, status: '', sr: T.srOld };
    }
    return { title: T.waitTitle, sub: T.waitSub, card: '', below: '', status: '', sr: '' };
  }

  function pdTicketApply(modal, state, data) {
    if (!modal) return null;
    data = data || {};
    var box = modal.querySelector('.pd-sh');
    var r = pdShRender(state, data);
    box.setAttribute('data-state', state);
    modal.querySelector('#pd-modal-title').textContent = r.title;
    modal.querySelector('#pd-sh-sub').textContent = r.sub;
    var card = modal.querySelector('#pd-tile');
    card.innerHTML = r.card;
    modal.querySelector('#pd-col').innerHTML = r.below;
    card.classList.remove('is-in'); void card.offsetWidth; card.classList.add('is-in');   // cross-fade the new content in
    modal.querySelector('#pd-status-dot').className = 'pd-status-dot pd-status-dot--' + state;
    modal.querySelector('#pd-status-text').textContent = r.status;
    var live = modal.querySelector('#pd-live');
    if (live && r.sr) { live.textContent = ''; setTimeout(function () { live.textContent = r.sr; }, 30); }
    return modal.querySelector('#pd-newcode');
  }

  /* The result moment: numbers on screen for PD_TICKET_TIMING.hold, then they fly into the fields. */
  function pdTicketResult(modal, result, opts) {
    opts = opts || {};
    var TM = PD_TICKET_TIMING;
    var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var half = function (v) { return (Math.round(v * 2) / 2).toFixed(1); };
    var data = { right: half(result.pdRight), left: half(result.pdLeft), total: half(result.pdTotal) };
    var timers = [], chips = [], filled = false, ended = false;
    var later = function (ms, fn) { timers.push(setTimeout(fn, ms)); };
    var fill = function () { if (filled) return; filled = true; if (opts.fill) opts.fill(); };
    var clear = function () { chips.forEach(function (c) { if (c.parentNode) c.parentNode.removeChild(c); }); };
    var end = function () { if (ended) return; ended = true; fill(); clear(); if (opts.done) opts.done(); };
    pdTicketApply(modal, 'result', data);
    if (reduced) { later(TM.reducedHold, end); return { skip: function () { timers.forEach(clearTimeout); fill(); }, data: data }; }
    later(TM.swap + TM.hold, function () {
      var tg = opts.targets ? opts.targets() : null;
      var srcR = modal.querySelector('.pd-sh-val-r'), srcL = modal.querySelector('.pd-sh-val-l');
      if (!tg || !tg.right || !tg.left || !srcR || !srcL || !srcR.getBoundingClientRect().width) { end(); return; }
      try { tg.right.scrollIntoView({ block: 'nearest' }); } catch (e) { /* old browsers */ }
      chips.push(pdShFly(srcR, tg.right, data.right, 0));
      chips.push(pdShFly(srcL, tg.left, data.left, TM.stagger));
      var box = modal.querySelector('.pd-sh'); if (box) box.classList.add('is-handing');
      if (opts.fade) opts.fade();
      later(TM.fly + TM.stagger - 60, fill);
      later(TM.fly + TM.stagger + TM.land, end);
    });
    return { skip: function () { timers.forEach(clearTimeout); clear(); fill(); }, data: data };
  }

  /* One number's flight: a copy of the value glides on a soft arc to the centre of its field. */
  function pdShFly(src, target, text, delay) {
    var TM = PD_TICKET_TIMING;
    var a = src.getBoundingClientRect(), b = target.getBoundingClientRect();
    var chip = document.createElement('div');
    chip.className = 'pd-sh-fly';
    chip.setAttribute('aria-hidden', 'true');
    chip.textContent = text;
    document.body.appendChild(chip);
    var cw = chip.offsetWidth, ch = chip.offsetHeight;
    var x0 = a.left + a.width / 2 - cw / 2, y0 = a.top + a.height / 2 - ch / 2;
    var x1 = b.left + b.width / 2 - cw / 2, y1 = b.top + b.height / 2 - ch / 2;
    chip.style.left = x0 + 'px'; chip.style.top = y0 + 'px';
    if (!chip.animate) { setTimeout(function () { if (chip.parentNode) chip.parentNode.removeChild(chip); }, TM.fly + delay); return chip; }
    var dx = x1 - x0, dy = y1 - y0, lift = Math.min(110, 36 + Math.abs(dx) * 0.16), cx = dx * 0.5, cy = Math.min(0, dy) - lift;
    var endScale = Math.max(0.62, Math.min(1, (b.height * 0.42) / ch + 0.25));
    var ease = function (t) { return 1 - Math.pow(1 - t, 3); };   // ease out: leaves quickly, settles softly
    var frames = [], n = 16;
    for (var i = 0; i <= n; i++) {
      var t = ease(i / n), u = 1 - t;
      var x = 2 * u * t * cx + t * t * dx, y = 2 * u * t * cy + t * t * dy, sc = 1 + (endScale - 1) * t;
      frames.push({ transform: 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) scale(' + sc.toFixed(3) + ')', offset: i / n });
    }
    chip.animate(frames, { duration: TM.fly, delay: delay, easing: 'linear', fill: 'both' });
    chip.animate([{ opacity: 1 }, { opacity: 0 }], { duration: TM.land, delay: delay + TM.fly, easing: 'ease-out', fill: 'forwards' });
    return chip;
  }

  function pdResetState() {
    S.pdSource = ''; S.pdMeasured = null;
    pdClearFilled(false);
    if (pd.session) { pdApi('cancel', { sid: pd.session.sid, k: pd.session.k }).catch(function () {}); pd.session = null; }
    pd.polling = false;
    if (pd.modal) { pd.modal.remove(); pd.modal = null; }
    if (pd.inline) { try { if (pd.ui) pd.ui.destroy(); } catch (e) {} pd.inline.remove(); pd.inline = null; pd.ui = null; }
  }

  // ---- fill the fields the same way a customer would ----------------------------------
  function applyPdResult(r) {
    var dc = $('#c-pd-dual-check'), rSel = $('#c-pd-r'), lSel = $('#c-pd-l');
    if (!dc || !rSel || !lSel) return;
    var rv = pdFmt(r.pdRight), lv = pdFmt(r.pdLeft);
    var offers = function (sel, v) { for (var i = 0; i < sel.options.length; i++) { if (sel.options[i].value === v) return true; } return false; };
    if (!offers(rSel, rv) || !offers(lSel, lv)) return;   // outside the store's PD range: leave the fields to the customer
    pd.applying = true;
    if (!dc.checked) { dc.checked = true; dc.dispatchEvent(new Event('change', { bubbles: true })); }
    rSel.value = rv; lSel.value = lv;
    rSel.dispatchEvent(new Event('change', { bubbles: true }));
    lSel.dispatchEvent(new Event('change', { bubbles: true }));
    // The one-PD box gets the same total, so unticking "2 PD numbers" shows 63.5, not the old 63
    var sSel = $('#c-pd'), tv = pdFmt(r.pdRight + r.pdLeft);
    if (sSel && offers(sSel, tv)) { sSel.value = tv; sSel.dispatchEvent(new Event('change', { bubbles: true })); }
    pd.applying = false;
    S.pdSource = 'Measured with phone (' + (r.method || 'camera') + ', confidence ' + Math.round((r.confidence || 0) * 100) + '%, ' + (r.engine || '') + ')';
    S.pdMeasured = { right: r.pdRight, left: r.pdLeft, total: r.pdTotal, method: r.method, confidence: r.confidence };
    [rSel, lSel].forEach(function (el) {
      el.classList.remove('pd-flash'); void el.offsetWidth; el.classList.add('pd-flash');
      setTimeout(function () { el.classList.remove('pd-flash'); }, 1600);
    });
    pdShowFilled();
    pdAnnounce(PD_T.srAdded.replace('{right}', pdFmt1(r.pdRight)).replace('{left}', pdFmt1(r.pdLeft)));
    updateBtn(2);
    pdCountOnce();
  }

  // Owner 2026-11-04: Charmlio shows how many shoppers measured their PD and didn't buy (Sales Funnel → PD Tool).
  // One anonymous count per browser per Edmonton day: a retake or a second frame the same day counts once.
  // Only the device type is sent: no PD, no product, nothing about the person. Never blocks the shopper.
  var PD_USED_DAYS = 30;
  var pdCounted = false;
  function pdEdmDay(d) {   // YYYY-MM-DD in Edmonton, the same day buckets as the server
    try {
      var p = {};
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/Edmonton', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(d).forEach(function (x) { p[x.type] = x.value; });
      return p.year && p.month && p.day ? p.year + '-' + p.month + '-' + p.day : '';
    } catch (e) { return ''; }
  }
  function pdUsedDay() {   // the day this browser last got a PD from the tool, if within 30 days; else ''
    try { var t = Number(window.localStorage.getItem('charmPdMeasuredAt')); if (t > 0 && Date.now() - t < PD_USED_DAYS * 864e5) return pdEdmDay(new Date(t)); } catch (e) {}
    return '';
  }
  function pdCountOnce() {
    // Only the live theme marks the browser or counts for real. The theme editor and theme previews (which share
    // the live store's localStorage) must not mark a tester's real orders. The PD test theme sets CharmlioPdBase to
    // the preview backend, which keeps its own count, so it may still send.
    var sh = window.Shopify || {}, role = sh.theme && sh.theme.role, live = !sh.designMode && (!role || role === 'main');
    if (live) { try { window.localStorage.setItem('charmPdMeasuredAt', String(Date.now())); } catch (e) {} }
    if (pdCounted) return;
    pdCounted = true;
    if (!live && !window.CharmlioPdBase) return;
    var day = pdEdmDay(new Date());
    var ck = live ? 'charmPdCounted' : 'charmPdCountedPreview';   // a preview test never blocks a real count
    try { if (day && window.localStorage.getItem(ck) === day) return; } catch (e) {}
    pdApi('count', { mode: pdIsPhone() ? 'phone' : 'computer' })
      .then(function () { try { if (day) window.localStorage.setItem(ck, day); } catch (e) {} })   // only once it landed
      .catch(function () { /* analytics never surface to a shopper; the next page load tries again */ });
  }

  function pdShowFilled() {
    var trigger = $('#c-pd-measure'), dual = $('#c-pd-dual');
    if (!trigger || !dual) return;
    trigger.hidden = true;
    var helper = $('#c-pd-helper'); if (helper) helper.hidden = true;
    var chip = $('#c-pd-measured');
    if (!chip) {
      chip = pdEl('span', 'c-summary-pill c-summary-pill--green pd-measured', PD_SVG.check + '<span>' + PD_T.measured + '</span>');
      chip.id = 'c-pd-measured';
      trigger.parentNode.insertBefore(chip, trigger);
    }
    chip.hidden = false;
    var note = $('#c-pd-filled');
    if (!note) {
      note = pdEl('div', 'c-ins-msg c-ins-msg--ok pd-filled', '<span class="c-ins-msg-icon">' + PD_SVG.checkCircle + '</span><div class="c-ins-msg-text"><strong>' + PD_T.filledTitle + '</strong><br>' + PD_T.filledSub + '</div><button type="button" class="pd-filled-retake">' + PD_T.retake + '</button>');
      note.id = 'c-pd-filled'; note.setAttribute('role', 'status'); note.tabIndex = -1;
      dual.parentNode.insertBefore(note, dual.nextSibling);
      note.querySelector('.pd-filled-retake').addEventListener('click', function () { pdIsPhone() ? openPdInline() : openPdModal(); });
    }
    note.hidden = false;
    note.classList.remove('is-in'); void note.offsetWidth; note.classList.add('is-in');
  }

  function pdClearFilled(edited) {
    var chip = $('#c-pd-measured'), note = $('#c-pd-filled'), trigger = $('#c-pd-measure'), helper = $('#c-pd-helper');
    if (chip) chip.hidden = true;
    if (note) note.hidden = true;
    if (trigger && trigger.dataset.ready) trigger.hidden = false;
    if (helper) helper.hidden = false;
    if (edited && S.pdMeasured) { S.pdSource = 'Edited by customer after a phone measurement'; S.pdMeasured = null; }
  }

  function initPdMeasure() {
    var trigger = $('#c-pd-measure');
    if (!trigger || trigger.dataset.ready) return;
    if (!window.fetch || !window.Promise) return;              // the row works without the tool
    if (pdIsPhone() && !pdCanMeasureHere()) return;            // older phone: no button, the PD row works as before
    trigger.dataset.ready = '1';
    trigger.hidden = false;
    var row = trigger.closest('.c-pd-row');
    if (row) row.classList.add('pd-row-ready');
    if (pdIsPhone()) {
      trigger.classList.add('pd-trigger--block');
      var helper = pdEl('div', 'pd-helper', PD_T.helperMobile); helper.id = 'c-pd-helper';
      row.parentNode.insertBefore(helper, row.nextSibling);
      row.parentNode.insertBefore(trigger, helper);
    }
    trigger.addEventListener('click', function () { pdIsPhone() ? openPdInline() : openPdModal(); });
    // Manual edits win: a hand change after a fill removes the chip and the note.
    ['c-pd', 'c-pd-r', 'c-pd-l'].forEach(function (id) {
      var el = $('#' + id);
      if (el) el.addEventListener('change', function () { if (!pd.applying && S.pdMeasured) pdClearFilled(true); });
    });
    var dc = $('#c-pd-dual-check');
    if (dc) dc.addEventListener('change', function () {
      if (pd.applying || !S.pdMeasured || dc.checked) return;
      // Switching to one PD keeps the tool's number when the box holds the measured total; anything else counts as an edit
      var sp = $('#c-pd');
      if (!sp || sp.value !== pdFmt(S.pdMeasured.right + S.pdMeasured.left)) pdClearFilled(true);
    });
  }

  // ---- desktop: modal + QR + long poll ------------------------------------------------------
  function pdLoadQr() {
    if (window.qrcode) return Promise.resolve();
    if (pd.qrReady) return pd.qrReady;
    pd.qrReady = new Promise(function (resolve, reject) {
      var sc = document.createElement('script'); sc.src = PD_QR_LIB; sc.async = true;
      sc.integrity = 'sha384-8FWZA6BGMXhsfO+BLtrJK0We6gg5o1JyO8xQm6peWDEUs17ACA5ziE/NIAkl9z2k'; sc.crossOrigin = 'anonymous';   // qrcode-generator 1.4.4
      sc.onload = resolve; sc.onerror = function () { pd.qrReady = null; reject(new Error('qr lib')); };
      document.head.appendChild(sc);
    });
    return pd.qrReady;
  }
  function pdQrSvg(url) {
    try {
      var q = window.qrcode(0, 'M'); q.addData(url); q.make();
      return q.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
    } catch (e) { return ''; }
  }

  function openPdModal() {
    if (pd.modal) pd.modal.remove();
    pd.lastFocus = document.activeElement;
    var m = pdEl('div', 'c-expiry-popup pd-modal');
    m.innerHTML = pdTicketShell({ product: (P.title || '').replace(/<[^>]+>/g, ' ').trim() });
    page.appendChild(m);
    pd.modal = m; pd.live = m.querySelector('#pd-live');
    m.querySelector('.pd-modal-close').addEventListener('click', closePdModal);
    m.querySelector('#pd-manual').addEventListener('click', function () { closePdModal(); var sp = $('#c-pd-dual-check') && $('#c-pd-dual-check').checked ? $('#c-pd-r') : $('#c-pd'); if (sp) sp.focus(); });
    m.addEventListener('click', function (e) { if (e.target === m) closePdModal(); });
    m.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closePdModal(); return; }
      if (e.key === 'Tab') {
        var f = m.querySelectorAll('button:not([hidden]), a[href], [tabindex="0"]');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    requestAnimationFrame(function () { m.classList.add('is-open'); var box0 = m.querySelector('.pd-sh'); try { (box0 || m.querySelector('.pd-modal-close')).focus({ preventScroll: true }); } catch (e) {} });   // focus the sheet, not the close button: no ring on open
    pdStartSession();
  }

  function closePdModal() {
    if (pd.ticketRun) { var tr = pd.ticketRun; pd.ticketRun = null; tr.skip(); }
    pd.polling = false;
    if (pd.session) { pdApi('cancel', { sid: pd.session.sid, k: pd.session.k }).catch(function () {}); pd.session = null; }
    if (pd.modal) { var m = pd.modal; pd.modal = null; m.classList.remove('is-open'); setTimeout(function () { m.remove(); }, 260); }
    if (pd.lastFocus && pd.lastFocus.focus) { try { pd.lastFocus.focus(); } catch (e) {} }
  }

  function pdSetModal(state, extra) {
    if (!pd.modal) return;
    var b = pdTicketApply(pd.modal, state, extra);
    if (b) b.addEventListener('click', pdStartSession);
  }

  function pdStartSession() {
    pd.polling = false;
    if (pd.session) { pdApi('cancel', { sid: pd.session.sid, k: pd.session.k }).catch(function () {}); pd.session = null; }
    var origin = { url: location.href.slice(0, 300), product: (P.title || '').replace(/<[^>]+>/g, ' ').slice(0, 120) };
    Promise.all([pdApi('create', { mode: 'desktop', origin: origin }), pdLoadQr().catch(function () {})]).then(function (res) {
      var s = res[0];
      if (!pd.modal) return;
      pd.session = { sid: s.sid, k: s.k, t: s.t, expiresAt: s.expiresAt, v: 0 };
      var url = PD_BASE + '/pd/' + s.t;
      var svg = window.qrcode ? pdQrSvg(url) : '';
      pd.session.svg = svg;
      pdSetModal('waiting', { svg: svg || ('<a class="pd-qr-link" href="' + url + '" target="_blank" rel="noopener">' + url + '</a>') });
      pdPoll();
    }).catch(function (e) {
      console.warn('[pd] create failed', e);
      pdSetModal('failed');
    });
  }

  function pdPoll() {
    if (!pd.session || !pd.modal) return;
    pd.polling = true;
    var sess = pd.session;
    var loop = function () {
      if (!pd.polling || pd.session !== sess) return;
      if (Date.now() > sess.expiresAt) { pd.polling = false; pdSetModal('expired', { svg: sess.svg }); return; }
      pdApi('wait?sid=' + encodeURIComponent(sess.sid) + '&k=' + encodeURIComponent(sess.k) + '&since=' + sess.v, null, 'GET').then(function (r) {
        if (!pd.polling || pd.session !== sess) return;
        if (!r.timeout) {
          sess.v = r.v;
          if (r.result) {
            pd.polling = false;
            pdApi('ack', { sid: sess.sid, k: sess.k }).catch(function () {});
            pd.session = null;
            var res = r.result;
            // the ticket moment: the pocket opens, the PD shows for PD_TICKET_TIMING.hold, then the numbers fly into the fields
            pd.ticketRun = pdTicketResult(pd.modal, res, {
              targets: function () {
                var dc = $('#c-pd-dual-check');
                if (dc && !dc.checked) { pd.applying = true; dc.checked = true; dc.dispatchEvent(new Event('change', { bubbles: true })); pd.applying = false; }
                return { right: $('#c-pd-r'), left: $('#c-pd-l') };
              },
              fill: function () { pd.live = null; applyPdResult(res); },
              fade: function () { if (pd.modal) pd.modal.classList.remove('is-open'); },
              done: function () { pd.ticketRun = null; closePdModal(); var note = $('#c-pd-filled'); if (note) { try { note.focus(); } catch (e) {} } }
            });
            return;
          }
          if (r.stage === 'unsupported' || r.stage === 'slow') { pd.polling = false; pdSetModal('phone_old'); return; }
          if (r.stage === 'measuring') pdSetModal('measuring');
          else if (r.connected) pdSetModal('connected');
        }
        setTimeout(loop, 150);
      }).catch(function (e) {
        if (!pd.polling || pd.session !== sess) return;
        if (e && (e.status === 404)) { pd.polling = false; pdSetModal('expired', { svg: sess.svg }); return; }
        setTimeout(loop, 2000);   // network blip: keep waiting
      });
    };
    loop();
  }

  // ---- phone: the measuring screens mount inline over the configurator -----------------------
  var PD_ASSET_V = '20261104g';   // bump with every backend PD change: phones cache module URLs
  function pdLoadUi() {
    if (window.__charmlioPdMount) return Promise.resolve(window.__charmlioPdMount);
    if (pd.uiReady) return pd.uiReady;
    pd.uiReady = new Promise(function (resolve, reject) {
      var done = false;
      var timer = setTimeout(function () { if (!done) { done = true; pd.uiReady = null; reject(new Error('pd ui timeout')); } }, 20000);
      window.addEventListener('charmlio-pd-ready', function onReady() {
        window.removeEventListener('charmlio-pd-ready', onReady);
        if (done) return; done = true; clearTimeout(timer);
        if (window.__charmlioPdMount) resolve(window.__charmlioPdMount); else reject(new Error('pd ui missing'));
      });
      var sc = document.createElement('script');
      sc.type = 'module';
      sc.textContent = "import { mountPdUi } from " + JSON.stringify(PD_BASE + '/pd/ui.js?v=' + PD_ASSET_V) + "; window.__charmlioPdMount = mountPdUi; window.dispatchEvent(new Event('charmlio-pd-ready'));";
      sc.onerror = function () { if (!done) { done = true; clearTimeout(timer); pd.uiReady = null; reject(new Error('pd ui script error')); } };
      document.head.appendChild(sc);
    });
    return pd.uiReady;
  }

  function openPdInline() {
    if (pd.inline) return;
    pd.lastFocus = document.activeElement;
    if (!pd.cssLoaded) {
      var link = document.createElement('link'); link.rel = 'stylesheet'; link.href = PD_BASE + '/pd/pd.css?v=' + PD_ASSET_V;
      document.head.appendChild(link); pd.cssLoaded = true;
    }
    var host = pdEl('div', 'pd-inline'); host.setAttribute('role', 'dialog'); host.setAttribute('aria-modal', 'true'); host.setAttribute('aria-label', PD_T.trigger);
    var rootEl = pdEl('div', 'pd-inline-root');
    host.appendChild(rootEl);
    document.body.appendChild(host);   // on <body>, outside .c-page, so the configurator's button reset cannot restyle the tool
    pd.inline = host;
    var closeInline = function () {
      if (pd.ui) { try { pd.ui.destroy(); } catch (e) {} pd.ui = null; }
      if (pd.inline) { pd.inline.remove(); pd.inline = null; }
      var note = $('#c-pd-filled');
      if (note && !note.hidden) { note.scrollIntoView({ block: 'center' }); try { note.focus(); } catch (e) {} }
      else if (pd.lastFocus && pd.lastFocus.focus) { try { pd.lastFocus.focus(); } catch (e) {} }
    };
    // A <script type="module"> tag, not a dynamic import: Shopify's asset CDN rewrites
    // dynamic imports inside classic theme scripts into require(), which does not exist in the browser.
    pdLoadUi().then(function (mountPdUi) {
      if (!pd.inline) return;
      pd.ui = mountPdUi({ root: rootEl, mode: 'inline', apiBase: PD_BASE, onResult: function (r) { applyPdResult(r); }, onClose: closeInline });
    }).catch(function (e) {
      console.warn('[pd] inline load failed', e);
      closeInline();
      alert('The measuring tool could not load. Check your connection and try again.');
    });
  }

  // ===== RX-DROPDOWN (design-v3, docs/pd-tool/design-v3/rx-dropdown.js, pasted: Shopify's CDN breaks dynamic imports) =====
  function enhanceRxSelects(root) { return pdRxModule().enhanceRxSelects(root); }
  function pdRxModule() {
    if (!pdRxModule._m) pdRxModule._m = (function () {
/* Charm Optical configurator, Rx step: custom dropdown over the native selects.
 *
 *   import { enhanceRxSelects } from './rx-dropdown.js';
 *   const rx = enhanceRxSelects(document.getElementById('charmlio'));   // or no argument = document
 *   rx.destroy();                                                       // optional
 *
 * What it does, and what it never does
 *  - Progressive enhancement over <select class="c-rx-select"> and <select class="c-date-sel">
 *    inside .c-step[data-step="2"] ONLY. Never .cl-field-select, never the insurance dropdown.
 *  - The native <select> stays in the DOM, stays visible as the closed control and stays the
 *    source of truth. So everything charmlio.js already does keeps working untouched:
 *    fill() rebuilding options with innerHTML, updateDays() trimming days, applyPdResult()
 *    setting .value by code, style.display toggles, .c-axis-warn, .pd-flash. Because the
 *    closed control IS the select, its text can never drift from its value, even when code
 *    sets the value without firing an event.
 *  - Options are read from the select at OPEN time (never cached), and the open list is
 *    closed if the select's options change underneath it.
 *  - Choosing sets select.selectedIndex and dispatches bubbling `input` and `change`, so the
 *    existing listeners (S state, axis warning, date sync, PD clear) fire exactly as for a
 *    native pick.
 *  - Fine pointer (mouse, trackpad): an animated popover listbox anchored to the select.
 *    Coarse pointer (phones, tablets, touch on a laptop): the native picker. The platform
 *    wheel is already smooth, thumb sized and the most accessible thing there is; we only
 *    style the closed control (rx-polish.css). Decided per press from pointerType, so a
 *    touch laptop gets the wheel for a tap and the popover for a mouse click.
 *  - Keyboard (fine pointer environments): Enter, Space, Alt+ArrowDown, ArrowDown, ArrowUp
 *    and F4 open; Home and End open at the ends; typing opens and jumps. Open: arrows,
 *    Home, End, PageUp, PageDown move; type ahead ("-2" lands on -2.00, "1" on +1.00, "ju"
 *    on June); Enter, Space or Alt+ArrowUp choose; Escape and Tab close without changing.
 *  - ARIA: role=listbox with aria-activedescendant (focus sits on the listbox while open,
 *    returns to the select on close); the select gets aria-expanded and aria-controls, and
 *    an aria-label when it has no name of its own (the Rx table cells have none today).
 *  - A changed value flashes once (data-rx-flash, styled in rx-polish.css), for native picks
 *    on phones too.
 */

const SCOPE = '.c-step[data-step="2"]';
const ELIGIBLE = 'select.c-rx-select, select.c-date-sel';
const NEVER = '.cl-field-select, .c-ins-select, #c-ins-select';
const ROW = 44;            // option height, same as the house insurance list and the 44px target rule
const PAD = 6;             // popover inner padding
const MAX_ROWS = 7.5;      // half a row peeks out so it reads as scrollable
const GAP = 6;             // select to popover
const EDGE = 12;           // keep clear of viewport edges
const MIN_W = 112;
const TYPE_RESET_MS = 700;
const FLASH_MS = 1000;
const PAGE = 7;
const FOLLOW_MS = 600;    // scrolls this soon after opening are the browser bringing the field into view: follow, do not close

let uidSeq = 0;
const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const mq = (q) => (typeof matchMedia === 'function' ? matchMedia(q).matches : false);
const textOf = (el) => (el ? el.textContent.replace(/\s+/g, ' ').trim() : '');
const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);

function enhanceRxSelects(root = document) {
  const steps = [];
  if (root && root.matches && root.matches(SCOPE)) steps.push(root);
  if (root && root.querySelectorAll) root.querySelectorAll(SCOPE).forEach((s) => steps.push(s));
  const handles = steps.filter((s) => !s.__rxd).map((s) => (s.__rxd = mount(s)));
  return { destroy() { handles.forEach((h) => h.destroy()); } };
}

function mount(step) {
  const uid = 'rxd' + (++uidSeq);
  const pop = document.createElement('div');
  pop.className = 'rxd-pop';
  pop.setAttribute('data-rxd', '');
  const list = document.createElement('ul');
  list.className = 'rxd-list';
  list.id = uid + '-list';
  list.setAttribute('role', 'listbox');
  list.tabIndex = -1;
  pop.appendChild(list);
  // Zero size fixed probe: tells us where position:fixed's origin really is. .c-page is
  // transformed (scale(1)), which makes it the containing block for fixed children.
  const probe = document.createElement('span');
  probe.className = 'rxd-probe';
  probe.setAttribute('aria-hidden', 'true');
  step.appendChild(probe);
  step.appendChild(pop);

  let cur = null, rows = [], active = -1, lastPointer = '', buf = '', bufTimer = 0, mo = null, closing = false, openedAt = 0;
  const scrollers = new WeakMap();   // select -> its scrolling ancestor, found once

  const eligible = (el) => el && el.matches && el.matches(ELIGIBLE) && !el.matches(NEVER) && el.closest(SCOPE) === step;
  const fineEnv = () => mq('(pointer: fine)') || mq('(any-pointer: fine)');

  /* ---------- names: the Rx table selects have no label at all today ---------- */
  function nameFor(sel) {
    const own = sel.getAttribute('aria-label');
    if (own) return own;
    const by = sel.getAttribute('aria-labelledby');
    if (by) return by.split(/\s+/).map((id) => textOf(document.getElementById(id))).join(' ');
    if (sel.id) { const l = step.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(sel.id) : sel.id) + '"]'); if (l) return textOf(l); }
    const td = sel.closest('td');
    if (td) {
      const tr = td.parentElement, table = td.closest('table');
      const col = Array.prototype.indexOf.call(tr.children, td);
      const th = table && table.tHead && table.tHead.rows[0] ? table.tHead.rows[0].cells[col] : null;
      const head = tr.cells[0];
      const eye = head && head.querySelector('small') ? textOf(head.querySelector('small')) : textOf(head);
      return (cap(eye) + ' ' + textOf(th)).trim();
    }
    const role = sel.getAttribute('data-role');
    if (role) { const f = sel.closest('.c-verify-field'); const l = f && f.querySelector('label'); return ((l ? textOf(l) : 'Date') + ', ' + role).trim(); }
    const box = sel.parentElement && sel.parentElement.querySelector(':scope > label');
    if (box) return textOf(box);
    const row = sel.closest('.c-pd-row');
    if (row) { const l = row.querySelector(':scope > label'); if (l) return textOf(l).replace(/\s+/g, ' ').trim() || 'PD'; }
    return 'Choose a value';
  }
  function ensureName(sel) {
    if (sel.hasAttribute('aria-label') || sel.hasAttribute('aria-labelledby') || sel.labels && sel.labels.length) return;
    sel.setAttribute('aria-label', nameFor(sel));
  }

  /* ---------- open / close ---------- */
  function readRows(sel) {
    const out = [];
    let prevNeg = null;
    for (let i = 0; i < sel.options.length; i++) {
      const o = sel.options[i];
      if (o.disabled && o.value === '') continue;            // "Month", "Day", "Year" prompts: not choosable natively either
      const text = o.text;
      const neg = /^-\d/.test(text.trim());
      const sep = prevNeg === true && !neg && o.value !== '';  // minus to plus boundary in SPH, CYL
      if (o.value !== '') prevNeg = neg;
      out.push({ i, text, value: o.value, disabled: o.disabled, ph: o.value === '', sep });
    }
    return out;
  }
  function render(sel) {
    const selIdx = sel.selectedIndex;
    let h = '';
    rows.forEach((r, n) => {
      const cls = 'rxd-opt' + (r.ph ? ' is-ph' : '') + (r.sep ? ' is-sep' : '');
      h += '<li role="option" id="' + uid + '-o' + n + '" class="' + cls + '" data-n="' + n + '" aria-selected="' + (r.i === selIdx) + '"' + (r.disabled ? ' aria-disabled="true"' : '') + '>' +
        '<span class="rxd-tick"></span><span class="rxd-txt">' + esc(r.text) + '</span></li>';
    });
    list.innerHTML = h;
  }
  function scroller(el) {
    if (scrollers.has(el)) return scrollers.get(el);
    let found = null;
    for (let p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      const oy = getComputedStyle(p).overflowY;
      if (oy === 'auto' || oy === 'scroll') { found = p; break; }
    }
    scrollers.set(el, found);
    return found;
  }
  function scrollParentTop(el) { const p = scroller(el); return p ? p.getBoundingClientRect().top : 0; }
  function place(sel) {
    const r = sel.getBoundingClientRect();
    const o = probe.getBoundingClientRect();
    const vw = document.documentElement.clientWidth, vh = window.innerHeight;
    let top = Math.max(EDGE, scrollParentTop(sel) + 4), bottom = vh - EDGE;
    const panel = sel.closest('.c-panel');
    const foot = panel && panel.querySelector('.c-panel-footer');
    if (foot) { const fr = foot.getBoundingClientRect(); if (fr.height && fr.top < bottom) bottom = fr.top - 8; }
    const want = Math.min(rows.length * ROW, MAX_ROWS * ROW) + PAD * 2;
    const below = bottom - (r.bottom + GAP), above = (r.top - GAP) - top;
    const up = below < Math.min(want, ROW * 3.5 + PAD * 2) && above > below;
    const hgt = Math.max(ROW + PAD * 2, Math.min(want, up ? above : below));
    const w = Math.max(r.width, MIN_W);
    let left = r.left + (r.width - w) / 2;                    // narrow selects: centre the wider list under them
    left = Math.min(Math.max(EDGE, left), vw - EDGE - w);
    pop.classList.toggle('is-up', up);
    pop.style.left = (left - o.left) + 'px';
    pop.style.top = ((up ? r.top - GAP - hgt : r.bottom + GAP) - o.top) + 'px';
    pop.style.width = w + 'px';
    list.style.maxHeight = (hgt - PAD * 2) + 'px';
    pop.style.setProperty('--rxd-origin-x', (r.left + r.width / 2 - left) + 'px');
  }
  function open(sel, how, move) {
    if (!sel || sel.disabled) return;
    const rect = sel.getBoundingClientRect();
    if (!rect.width || !rect.height) return;                 // hidden (dual PD swaps, collapsed panels)
    if (cur) close(false);
    // a half hidden field is brought into view first; the browser may animate that (the house
    // panel has scroll-behavior: smooth), so the list follows it for FOLLOW_MS instead of closing
    const sp = scroller(sel);
    if (sp) { const pr = sp.getBoundingClientRect(); if (rect.top < pr.top || rect.bottom > pr.bottom) { try { sel.scrollIntoView({ block: 'nearest' }); } catch (e) { /* old engines */ } } }
    openedAt = performance.now();
    cur = sel;
    ensureName(sel);
    rows = readRows(sel);
    render(sel);
    pop.classList.toggle('rxd-pop--start', sel.matches('.c-date-sel'));
    pop.classList.toggle('rxd-pop--rx', sel.matches('.c-rx-select'));
    list.setAttribute('aria-label', nameFor(sel));
    place(sel);
    // where to start: the selected row, else the first choosable one
    let n = rows.findIndex((r) => r.i === sel.selectedIndex && !r.disabled);
    if (n < 0) n = sel.matches('.c-date-sel') ? -1 : rows.findIndex((r) => !r.disabled);
    setActive(n, 'none');
    centre(n < 0 ? 0 : n);
    if (move === 'first') setActive(firstEnabled(1), 'nearest');
    if (move === 'last') setActive(firstEnabled(-1), 'nearest');
    sel.setAttribute('aria-expanded', 'true');
    sel.setAttribute('aria-controls', list.id);
    void pop.offsetWidth;                                     // commit the start frame so the transition runs
    pop.classList.add('is-open');
    try { list.focus({ preventScroll: true }); } catch (e) { list.focus(); }
    document.addEventListener('pointerdown', onDocDown, true);
    document.addEventListener('scroll', onScroll, true);
    window.addEventListener('resize', onResize);
    window.addEventListener('blur', onResize);
    if (window.MutationObserver) { mo = new MutationObserver(() => close(false)); mo.observe(sel, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'style', 'class'] }); }
  }
  function close(focusSelect) {
    if (!cur || closing) return;
    closing = true;
    const sel = cur;
    cur = null;
    if (mo) { mo.disconnect(); mo = null; }
    document.removeEventListener('pointerdown', onDocDown, true);
    document.removeEventListener('scroll', onScroll, true);
    window.removeEventListener('resize', onResize);
    window.removeEventListener('blur', onResize);
    pop.classList.remove('is-open');
    list.removeAttribute('aria-activedescendant');
    sel.setAttribute('aria-expanded', 'false');
    buf = '';
    if (focusSelect) { try { sel.focus({ preventScroll: true }); } catch (e) { sel.focus(); } }
    closing = false;
  }
  function commit(n) {
    const sel = cur, r = rows[n];
    if (!sel || !r || r.disabled) return;
    const changed = sel.selectedIndex !== r.i;
    close(true);
    if (changed) {
      sel.selectedIndex = r.i;
      sel.dispatchEvent(new Event('input', { bubbles: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* ---------- active row ---------- */
  function rowEl(n) { return n >= 0 ? list.children[n] : null; }
  function setActive(n, scroll) {
    const prev = rowEl(active);
    if (prev) prev.classList.remove('is-active');
    active = n;
    const el = rowEl(n);
    if (!el) { list.removeAttribute('aria-activedescendant'); return; }
    el.classList.add('is-active');
    list.setAttribute('aria-activedescendant', el.id);
    if (scroll === 'nearest') {
      const top = el.offsetTop, bot = top + el.offsetHeight;
      if (top < list.scrollTop + PAD) list.scrollTop = top - PAD;
      else if (bot > list.scrollTop + list.clientHeight - PAD) list.scrollTop = bot - list.clientHeight + PAD;
    } else if (scroll === 'center') centre(n);
  }
  function centre(n) {
    const el = rowEl(n);
    if (el) list.scrollTop = el.offsetTop - (list.clientHeight - el.offsetHeight) / 2;   // instant, no smooth scroll on open
  }
  function firstEnabled(dir) {
    if (dir > 0) { for (let n = 0; n < rows.length; n++) if (!rows[n].disabled) return n; }
    else { for (let n = rows.length - 1; n >= 0; n--) if (!rows[n].disabled) return n; }
    return -1;
  }
  function step1(from, delta) {
    let n = from < 0 ? (delta > 0 ? -1 : rows.length) : from;
    const dir = delta > 0 ? 1 : -1;
    let left = Math.abs(delta), last = from;
    while (left > 0) {
      n += dir;
      if (n < 0 || n >= rows.length) break;
      if (!rows[n].disabled) { last = n; left--; }
    }
    return last < 0 ? firstEnabled(dir) : last;
  }

  /* ---------- type ahead ---------- */
  function findMatch(q) {
    const s = q.trim().toLowerCase();
    if (!s) return -1;
    const usable = (r) => !r.disabled;
    if (/^[+-]?(\d+\.?\d*|\.\d+)$/.test(s)) {                // a number: exact value wins over prefix ("-2" is -2.00, not -20.00)
      const v = parseFloat(s);
      let hit = rows.findIndex((r) => usable(r) && !r.ph && parseFloat(r.text) === v);
      if (hit < 0) hit = rows.findIndex((r) => usable(r) && r.ph && parseFloat(r.text) === v);
      if (hit >= 0) return hit;
    }
    const pre = (r) => { const t = r.text.trim().toLowerCase(); return t.startsWith(s) || t.replace(/^\+/, '').startsWith(s); };
    let hit = rows.findIndex((r) => usable(r) && !r.ph && pre(r));
    if (hit < 0) hit = rows.findIndex((r) => usable(r) && pre(r));
    return hit;
  }
  function typeahead(ch) {
    buf += ch;
    clearTimeout(bufTimer);
    bufTimer = setTimeout(() => { buf = ''; }, TYPE_RESET_MS);
    const n = findMatch(buf);
    if (n >= 0) setActive(n, 'center');
  }
  const printable = (e) => e.key && e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey;

  /* ---------- events: closed select ---------- */
  function onPointerDown(e) { if (eligible(e.target)) lastPointer = e.pointerType || 'mouse'; }
  function onMouseDown(e) {
    const sel = e.target;
    if (!eligible(sel) || e.button !== 0) return;
    if (lastPointer === 'touch' || lastPointer === 'pen') return;   // native wheel / sheet
    e.preventDefault();                                             // stop the native popup (and its focus)
    if (cur === sel) { close(true); return; }
    open(sel, 'mouse');
  }
  function onSelectKey(e) {
    const sel = e.target;
    if (!eligible(sel) || cur === sel || !fineEnv()) return;
    const k = e.key;
    let move = null;
    if (k === 'Enter' || k === ' ' || k === 'ArrowDown' || k === 'ArrowUp' || k === 'F4') move = 'keep';
    else if (k === 'Home') move = 'first';
    else if (k === 'End') move = 'last';
    else if (k === 'PageUp' || k === 'PageDown') move = 'keep';
    else if (printable(e)) move = 'type';
    if (!move) return;
    e.preventDefault();
    e.stopPropagation();
    open(sel, 'key', move === 'first' || move === 'last' ? move : null);
    if (move === 'type') typeahead(k);
  }
  function onChange(e) {
    const sel = e.target;
    if (!eligible(sel)) return;
    sel.removeAttribute('data-rx-flash');
    void sel.offsetWidth;
    sel.setAttribute('data-rx-flash', '');
    clearTimeout(sel.__rxdFlash);
    sel.__rxdFlash = setTimeout(() => sel.removeAttribute('data-rx-flash'), FLASH_MS);
  }

  /* ---------- events: open list ---------- */
  function onListKey(e) {
    if (!cur) return;
    const k = e.key;
    let handled = true;
    if (k === 'ArrowDown' && !e.altKey) setActive(step1(active, 1), 'nearest');
    else if (k === 'ArrowUp' && e.altKey) commit(active);
    else if (k === 'ArrowUp') setActive(step1(active, -1), 'nearest');
    else if (k === 'PageDown') setActive(step1(active, PAGE), 'nearest');
    else if (k === 'PageUp') setActive(step1(active, -PAGE), 'nearest');
    else if (k === 'Home') setActive(firstEnabled(1), 'nearest');
    else if (k === 'End') setActive(firstEnabled(-1), 'nearest');
    else if (k === 'Enter') commit(active);
    else if (k === ' ' && buf) typeahead(' ');
    else if (k === ' ') commit(active);
    else if (k === 'Escape') close(true);
    else if (k === 'Tab') { close(true); handled = false; }    // focus is back on the select; the browser's Tab moves on from there
    else if (printable(e)) typeahead(k);
    else handled = false;
    if (handled) { e.preventDefault(); e.stopPropagation(); }
    else if (k === 'Tab') e.stopPropagation();
  }
  function onListMove(e) {
    const li = e.target.closest && e.target.closest('.rxd-opt');
    if (!li) return;
    const n = +li.getAttribute('data-n');
    if (n !== active && !rows[n].disabled) setActive(n, 'none');
  }
  function onListClick(e) {
    const li = e.target.closest && e.target.closest('.rxd-opt');
    if (li) commit(+li.getAttribute('data-n'));
  }
  function onListDown(e) { e.preventDefault(); }              // keep focus on the listbox, no text selection
  function onDocDown(e) {
    if (!cur) return;
    if (pop.contains(e.target) || e.target === cur) return;  // the select's own mousedown toggles
    close(false);
  }
  function onScroll(e) {
    if (!cur) return;
    if (e.target === list || pop.contains(e.target)) return;
    if (performance.now() - openedAt < FOLLOW_MS) { place(cur); return; }
    close(true);
  }
  function onResize() { if (cur) close(true); }

  step.addEventListener('pointerdown', onPointerDown, true);
  step.addEventListener('mousedown', onMouseDown);
  step.addEventListener('keydown', onSelectKey);
  step.addEventListener('change', onChange);
  list.addEventListener('keydown', onListKey);
  list.addEventListener('pointermove', onListMove);
  list.addEventListener('click', onListClick);
  list.addEventListener('pointerdown', onListDown);
  list.addEventListener('focusout', (e) => { if (cur && !closing && !pop.contains(e.relatedTarget) && e.relatedTarget !== cur && e.relatedTarget) close(false); });

  return {
    destroy() {
      close(false);
      step.removeEventListener('pointerdown', onPointerDown, true);
      step.removeEventListener('mousedown', onMouseDown);
      step.removeEventListener('keydown', onSelectKey);
      step.removeEventListener('change', onChange);
      pop.remove(); probe.remove();
      delete step.__rxd;
    },
    get openSelect() { return cur; },
  };
}

      return { enhanceRxSelects: enhanceRxSelects };
    })();
    return pdRxModule._m;
  }

})();
